import {css} from "linaria";

export const article = css`
  :not(:defined) {
    visibility: initial;
  }

  .instruction__section {
    display: grid;
    grid-template-columns:1fr .3fr;
    gap: 24px;
    align-items: flex-start;
    margin-bottom: 65px
  }

  @media (max-width: 600px) {
    .instruction__section {
      display: flex;
      flex-direction: column
    }
  }

  .instruction__section p {
    margin: 0
  }

  .instruction__section .section__margin {
    margin-bottom: 16px
  }

  .img-container {
    display: flex
  }

  .img-container img {
    width: 100%;
    height: 100%;
    object-fit: contain
  }

  .info-advice {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 90px;
    max-width: 707px;
    padding-top: 26px;
    margin: auto
  }

  .info-advice h1 {
    font-size: 48px;
    margin-bottom: 32px;
    margin-top: 16px;
    line-height: 56px
  }

  @media (max-width: 600px) {
    .info-advice h1 {
      font-size: 34px
    }
  }

  .info-advice h2 {
    font-weight: 500;
    font-size: 26px;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px
  }

  .info-advice h2 span {
    border: 2px solid var(--text-primary);
    border-radius: 50%;
    width: 38px;
    height: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: var(--big-font-size)
  }

  .info-advice h3 {
    font-weight: 500;
    font-size: var(--big-font-size)
  }

  .info-advice p {
    font-weight: 500;
    font-size: var(--base-font-size)
  }

  @media (max-width: 1024px) {
    .info-advice {
      margin-left: 123px;
      max-width: 616px
    }
  }

  @media (max-width: 768px) {
    .info-advice {
      margin: 0 auto;
      max-width: 606px
    }
  }

  @media (max-width: 600px) {
    .info-advice {
      margin-left: 14px;
      margin-right: 14px
    }
  }

  .info-advice__category {
    background: var(--control-gray);
    border-radius: 100px;
    padding: 6px 12px;
    color: var(--text-primary)
  }

  .info-advice__banner {
    border-radius: 8px;
    width: 100%
  }

  .info-advice__container {
    display: flex;
    flex-direction: column
  }

  .info-advice__section p {
    font-weight: 400
  }

  .info-advice__snackbar {
    background: var(--bg-secondary)
  }

  .info-advice__snackbar p {
    position: relative;
    margin-left: 40px;
    padding: 16px 16px 16px 8px;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px
  }

  .info-advice__snackbar p:before {
    content: "i";
    position: absolute;
    border: 3px solid var(--text-primary);
    width: 20px;
    height: 20px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    left: -25px;
    font-weight: 700
  }

  .info-advice__instruction {
    display: flex;
    flex-direction: column;
    gap: 48px;
    margin-bottom: 32px
  }

  .info-advice__instruction h3 {
    margin-bottom: -20px
  }

  :root {
    font-synthesis: none;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-text-size-adjust: 100%;
    --big-font-size: 20px;
    --base-font-size: 16px;
    --small-font-size: 14px;
    --tiny-font-size: 12px;
    --base-padding: 22px 93px;
    --text-primary: #333333;
    --control-gray: #E8E9EB;
    --control-hover: #c6c8d0;
    --control-primary: #464C5C;
    --control-secondary: #CED0D6;
    --color-white: #FFFFFF;
    --hover-minor: #DCDDE0;
    --text-secondary: #999999;
    --text-contrast: #666666;
    --advice-padding: 59px 93px;
    --attention-primary: #E6615E;
    --bg-secondary: #F2F3F5;
    --inner-alignment: #444B5B;
    --alignment: #D2D4D8;
    --accent-dark: #C39844;
    --green: #66c05d
  }

  * {
    box-sizing: border-box;
  }

  body {
    margin: 0;
    font-size: var(--base-font-size);
    color: var(--text-primary)
  }

  h1 {
    font-size: 34px;
    font-weight: 700;
    margin: 0
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0
  }

  button {
    border: none;
    outline: none
  }

  a {
    text-decoration: none;
    color: inherit
  }

  .rotated {
    transform: rotate(180deg)
  }

  .main-container {
    max-width: 1336px;
    margin: 0 auto
  }

  @media (max-width: 1028px) {
    :root {
      --base-padding: 14px 42px;
      --advice-padding: 59px 42px
    }
  }

  @media (max-width: 768px) {
    :root {
      --base-padding: 14px 54px;
      --advice-padding: 59px 42px
    }
  }

  @media (max-width: 450px) {
    h1 {
      font-size: 28px
    }

    :root {
      --base-padding: 14px 16px;
      --advice-padding: 32px 16px
    }
  }

  .overcover__img-popup {
    background: black;
    opacity: .5;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9
  }

  .img-popup {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10
  }

  .img-popup img {
    max-width: 600px;
    max-height: 600px
  }

  .error {
    border: 1px solid #ff0a47 !important
  }

  * {
    outline: none;
    box-sizing: border-box
  }

  *:before, *:after {
    box-sizing: border-box
  }

  body {
    margin: 0;
    padding: 0;
    color: #333;
    background: #fff !important;
    line-height: 140%
  }

  html, body {
    height: 100%
  }

  .awg__section {
    max-width: 1180px;
    margin: 47px auto;
    padding: 0 15px;
    font-size: 16px;
    line-height: 140%
  }

  .awg__section__inn {
    margin: 35px 0
  }

  .text-jst {
    text-align: justify
  }

  .cust-col-4 h3 {
    margin-bottom: 16px
  }

  .awg__section p {
    font-size: 16px;
    line-height: 140%;
    margin-top: 16px;
    text-align: left
  }

  .awg__section p.mt-0 {
    margin-top: 0
  }

  .awg__section p:last-child {
    margin-bottom: 0
  }

  .awg__section .bold-font {
    font-weight: 500
  }

  .awg__section a {
    text-decoration-line: underline;
    color: #000
  }

  .awg__section a:hover {
    text-decoration: none
  }

  .awg__section__h1, .awg__section h2 {
    font-weight: 500 !important;
    text-transform: none !important;
    font-size: 38px !important;
    line-height: normal;
    margin: 0 !important
  }

  .awg__grey {
    background: #F3F3F5;
    border-radius: 4px;
    padding: 20px 25px;
    height: 100%
  }

  .awg__section__h2, .awg__section h3 {
    font-size: 24px !important;
    text-transform: none !important;
    font-weight: 500 !important;
    line-height: normal;
    margin: 0 !important
  }

  .cust-col-6 h3 {
    margin-top: 16px !important
  }

  .cust-row [class^=cust-col].mt-0 {
    margin-top: 0
  }

  .cust-row [class^=cust-col].pl-50 {
    padding-left: 50px
  }

  .mb-0 {
    margin-bottom: 0 !important
  }

  ul li {
    margin-bottom: 1px
  }

  ul {
    margin: 16px 0 16px 26px;
    padding: 0
  }

  ul:last-child {
    margin-bottom: 0
  }

  ul.mt-0 {
    margin-top: 0
  }

  .awg__type-1 {
    display: flex;
    align-items: center
  }

  .awg__type-1 img {
    width: 110px
  }

  .awg__type-1 p {
    width: calc(100% - 130px);
    margin: 0 0 0 15px;
    text-align: left;
    font-size: 14px
  }

  .red-text {
    font-weight: 500;
    color: #e93838;
    display: block
  }

  .awg__grey > p:first-child {
    margin-top: 0
  }

  table {
    width: 100%;
    border: 1px solid #CED0D6;
    font-size: 16px;
    border-collapse: collapse;
    text-align: center
  }

  td {
    border: 1px solid #CED0D6;
    padding: 12px 24px
  }

  th {
    padding: 16px 24px;
    font-weight: 500;
    background: #F3F3F5;
    border: 1px solid #CED0D6
  }

  .cust-row {
    display: flex;
    flex-wrap: wrap;
    margin-left: -10px;
    margin-right: -10px;
    margin-top: -20px
  }

  .cust-row [class^=cust-col] {
    padding-left: 10px;
    padding-right: 10px;
    margin: 20px 0 0;
    flex-shrink: 0;
    flex-grow: 0;
    box-sizing: border-box
  }

  .cust-col-6 {
    flex-basis: 50%;
    max-width: 50%
  }

  .cust-col-6-1 {
    flex-basis: 45%;
    max-width: 45%
  }

  .cust-col-6-2 {
    flex-basis: 55%;
    max-width: 55%
  }

  .cust-col-3 {
    flex-basis: 25%;
    max-width: 25%
  }

  .cust-col-9 {
    flex-basis: 75%;
    max-width: 75%
  }

  .cust-col-4 {
    flex-basis: 33.3333%;
    max-width: 33.3333%
  }

  .cust-col-2 {
    flex-basis: 16.6667%;
    max-width: 16.6667%
  }

  .cust-col-12 {
    flex-basis: 100%;
    max-width: 100%
  }

  .hide-me {
    display: none
  }

  .show-me {
    display: block
  }

  .btn {
    width: 130px;
    height: 40px;
    background: #464C5C;
    border-radius: 4px;
    color: #fff !important;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center
  }

  @media (max-width: 1024px) {
    .cust-col-tablet-6 {
      flex-basis: 50%;
      max-width: 50%
    }

    .cust-col-tablet-3 {
      flex-basis: 25%;
      max-width: 25%
    }

    .cust-col-tablet-12 {
      flex-basis: 100%;
      max-width: 100%
    }

    .cust-col-3 img {
      width: 100%
    }
  }

  @media (max-width: 768px) {
    .cust-row {
      margin-top: -32px;
      margin-left: -16px;
      margin-right: -16px
    }

    .cust-row [class^=cust-col] {
      margin-top: 32px;
      padding-left: 16px;
      padding-right: 16px
    }

    .cust-col-v-tablet-6 {
      flex-basis: 50%;
      max-width: 50%
    }

    .cust-col-v-tablet-12 {
      flex-basis: 100%;
      max-width: 100%
    }

    .cust-col-v-tablet-3 {
      flex-basis: 25%;
      max-width: 25%
    }

    .show-me--v-tablet {
      display: block
    }

    .hide-me--v-tablet {
      display: none
    }

    .awg__section {
      margin: 33px 0
    }

    .awg__section__h1, .awg__section__h2, .awg__section h2, .awg__section h3 {
      font-size: 22px !important
    }
  }

  @media (max-width: 480px) {
    .cust-row {
      margin-top: -12px;
      margin-left: -6px;
      margin-right: -6px
    }

    .cust-row [class^=cust-col] {
      margin-top: 12px;
      padding-left: 6px;
      padding-right: 6px
    }

    .cust-col-mobile-12 {
      flex-basis: 100%;
      max-width: 100%
    }

    .awg__type-1 {
      margin-bottom: 20px
    }

    .awg__type-1 img {
      width: 80px
    }

    .awg__type-1 p {
      width: calc(100% - 100px);
      margin: 0 0 0 20px;
      text-align: left
    }

    .awg__grey {
      padding: 15px 20px
    }

    .cust-col-6 .cust-row {
      margin-bottom: 16px
    }

    .awg__section__inn {
      margin: 24px 0
    }

    table {
      width: 100%;
      border: 1px solid #CED0D6;
      font-size: 14px;
      border-collapse: collapse;
      text-align: center
    }

    td {
      border: 1px solid #CED0D6;
      padding: 8px 12px
    }

    th {
      padding: 8px 12px;
      font-weight: 500;
      background: #F3F3F5;
      border: 1px solid #CED0D6
    }

    .h-scroll {
      width: 100%;
      overflow: auto;
      -webkit-overflow-scrolling: touch
    }
  }

  .top-page-wrapper {
    margin-bottom: 0
  }

  .main-article-image {
    height: 390px;
    position: relative
  }

  .main-article-image:before, .main-article-image:after {
    content: " ";
    display: table
  }

  .main-article-image:after {
    clear: both
  }

  @media (max-width: 767px) {
    .main-article-image {
      padding: 0
    }
  }

  @media (min-width: 600px) {
    .main-article-image {
      height: 553px
    }
  }

  .main-article-image__title-wrapper {
    position: absolute;
    bottom: 0;
    display: flex;
    flex-direction: column;
    left: 0;
    right: 0;
    padding: 0 8px
  }

  .main-article-image__image, .main-article-image__video {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 0
  }

  .main-article-image__image:before, .main-article-image__video:before {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-image: linear-gradient(to bottom, rgba(73, 72, 72, 0), rgba(73, 72, 72, .3) 27%, #494848);
    opacity: .6
  }

  .main-article-image iframe {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }

  .main-article-image__bg-container {
    display: block;
    height: 100%
  }

  .main-article-image__bg-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center
  }

  .main-article-image__play {
    /*background: url(../../../etc/designs/elbrus/images/articles-play.svg);*/
    cursor: pointer;
    left: 50%;
    top: 40%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    position: absolute;
    height: 159px;
    width: 159px;
    background-size: 159px 159px
  }

  @media (min-width: 600px) {
    .main-article-image__play {
      top: 50%
    }
  }

  @media (max-width: 767px) {
    .main-article-image__play {
      height: 95px;
      width: 95px;
      background-size: 95px 95px
    }
  }

  .main-article-image__title {
    font-size: 24px;
    width: 100%;
    text-align: center;
    font-weight: 600;
    margin-bottom: 16px;
    color: #fff
  }

  .main-article-image__additional-info {
    color: #fff;
    font-size: 11px;
    letter-spacing: .8px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px
  }

  .main-article-image__tag {
    text-transform: uppercase;
    border: 1px solid #ffffff;
    padding: 5px 15px;
    margin-right: 5px
  }

  .main-article-image__date {
    padding: 5px 0
  }

  .paginator-show-more {
    display: none;
    justify-content: center;
    border: solid 1px #eaeaea;
    background-color: #fff
  }

  .paginator-show-more {
    font-size: 12px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #66c05d
  }

  @media (max-width: 767px) {
    .paginator-show-more {
      display: flex
    }

    .pagination-page-numbers {
      display: none
    }
  }

  .articles {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    background-color: #fafafa;
    margin-bottom: 30px
  }

  .articles-card-list__card-loading {
    display: none
  }

  .spinner-ajax.loading {
    top: 0;
    position: relative
  }

  .articles-show-more {
    width: 45%;
    margin-top: 3%;
    margin-bottom: 3%;
    display: flex;
    justify-content: center
  }

  .articles-show-more p {
    margin: 0 0 0 8%
  }

  .left-menu-item {
    border: solid 1px #e3e3e3;
    margin-bottom: 7%
  }

  .article-type-header {
    display: flex;
    flex-direction: row;
    margin: 9px 0 3px;
    font-size: 14px;
    font-weight: 700;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #333
  }

  .article-type-header p {
    width: 50%;
    margin: 2% 0
  }

  .articles-type-img-container {
    display: flex;
    width: 50%;
    justify-content: flex-end
  }

  .articles-type-img {
    height: 100%;
    width: 25%;
    display: flex;
    justify-content: flex-end
  }

  .dropdown-arrow {
    width: 7px;
    height: 5px;
    align-self: center
  }

  .articles-container {
    display: flex;
    flex-direction: row
  }

  .articles-type__active {
    display: none;
    width: 5px;
    height: 30px;
    background-color: #66c05d
  }

  .article-type-li {
    display: flex !important;
    flex-direction: row;
    margin: 1% 0;
    font-size: 12px;
    height: 27px
  }

  .articles-type__active.article-type-active {
    display: block
  }

  .article-type-link {
    align-self: center;
    margin-left: 8%
  }

  .article-type-link-active {
    color: #333;
    margin-left: 7%
  }

  .articles-right-space {
    padding-right: 0
  }

  .articles-left-menu-element {
    display: flex;
    margin-bottom: 8%;
    border: solid 1px #e3e3e3;
    flex-direction: column
  }

  .articles-left-menu-element ul {
    padding-left: 0;
    margin-bottom: 13px
  }

  .left-gap {
    width: 7%
  }

  .right-gap {
    width: 8%
  }

  .awg__row {
    display: flex;
    justify-content: space-between
  }

  .cust-col-3 {
    flex-basis: 33%;
    max-width: 33%
  }

  img {
    max-width: 100%;
    border-radius: 4px
  }

  ._catalog-page_6q7x0_1 {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: var(--base-padding);
    padding-top: 0;
    max-width: 1336px;
    margin: 0 auto
  }

  ._catalog-page_6q7x0_1 h1 {
    margin-bottom: 32px
  }

  ._filter__tablet_6q7x0_14 {
    width: 100%
  }

  @media (min-width: 768px) {
    ._filter__tablet_6q7x0_14 {
      display: none !important
    }
  }

  ._catalog__filters_6q7x0_23 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 30px;
    margin-bottom: 40px;
    width: 100%
  }

  ._catalog__content_6q7x0_32 {
    display: grid;
    grid-template-columns:1fr 1fr .55fr;
    gap: 47px;
    grid-template-areas:"tabs tabs tabs" "catalog catalog filter" "paginator paginator paginator"
  }

  @media (max-width: 768px) {
    ._catalog__content_6q7x0_32 {
      grid-template-columns:1fr 1fr;
      grid-template-areas:"tabs filter" "catalog catalog" "paginator paginator"
    }
  }

  @media (max-width: 550px) {
    ._catalog__content_6q7x0_32 {
      grid-template-columns:1fr;
      grid-template-areas:"tabs" "filter" "catalog" "paginator";
      gap: 24px
    }
  }

  ._tabs_6q7x0_52 {
    grid-area: tabs
  }

  ._filter_6q7x0_14 {
    grid-area: filter
  }

  ._catalog_6q7x0_1 {
    grid-area: catalog
  }

  ._paginator_6q7x0_64 {
    grid-area: paginator
  }

  ._bread-crumbs_rc8ot_1 {
    color: var(--text-secondary);
    font-size: var(--tiny-font-size);
    cursor: pointer;
    position: relative;
    display: flex;
    align-items: center;
    padding: var(--base-padding)
  }

  ._bread-crumbs__active_rc8ot_10:before {
    content: "";
    width: 6px;
    height: 6px;
    border-bottom: 2px solid var(--text-secondary);
    border-right: 2px solid var(--text-secondary);
    transform: rotate(135deg);
    display: block
  }

  @media (max-width: 768px) and (min-width: 500px) {
    ._bread-crumbs_rc8ot_1 {
      display: none
    }
  }

  ._catalog_8fn3q_1 {
    width: 100%
  }

  ._catalog__section-one_8fn3q_4 ._catalog__three_8fn3q_4 {
    margin-top: 32px
  }

  ._catalog__section-two_8fn3q_7 {
    display: grid;
    grid-template-columns:1fr 1fr;
    gap: 32px
  }

  @media (max-width: 600px) {
    ._catalog__section-two_8fn3q_7 {
      display: flex;
      flex-direction: column
    }
  }

  ._catalog__section-two_8fn3q_7 ._catalog__three_8fn3q_4 {
    grid-column: 1/-1
  }

  ._catalog__content_8fn3q_21 {
    display: flex;
    flex-direction: column;
    gap: 32px;
    width: 100%
  }

  ._catalog__three_8fn3q_4 {
    display: grid;
    grid-template-columns:repeat(3, minmax(0, 1fr));
    gap: 32px
  }

  @media (max-width: 600px) {
    ._catalog__three_8fn3q_4 {
      display: flex;
      flex-direction: column
    }
  }

  ._catalog__twice_8fn3q_38 {
    display: grid;
    grid-template-columns:1fr 1fr;
    gap: 34px
  }

  @media (max-width: 768px) {
    ._catalog__twice_8fn3q_38 {
      display: flex;
      flex-direction: column
    }
  }

  @media (max-width: 768px) {
    ._catalog__filter_8fn3q_50 {
      display: none !important
    }
  }

  @media (max-width: 768px) {
    ._catalog_8fn3q_1 {
      grid-template-columns:100%
    }
  }

  ._advice-cart_cvk3m_1 {
    width: 100%;
    height: 280px;
    position: relative;
    padding: 24px;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    justify-content: end;
    gap: 16px;
    border-radius: 8px;
    overflow: hidden
  }

  ._advice-cart__video_cvk3m_14:before {
    position: absolute;
    content: "";
    z-index: 555;
    background: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAiIGhlaWdodD0iODAiIHZpZXdCb3g9IjAgMCA4MCA4MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBvcGFjaXR5PSIwLjQiIGN4PSI0MCIgY3k9IjQwIiByPSI0MCIgZmlsbD0iIzMzMzMzMyIvPgo8cGF0aCBkPSJNNTQuNDE4MSAzOC45Mzc0TDMyLjgzMDIgMjUuMTg2MUMzMi42NDg1IDI1LjA2OTQgMzIuNDQwMiAyNS4wMDUyIDMyLjIyNjcgMjUuMDAwM0MzMi4wMTMyIDI0Ljk5NTQgMzEuODAyNCAyNS4wNDk5IDMxLjYxNTkgMjUuMTU4MkMzMS40MjkzIDI1LjI2NjQgMzEuMjczOSAyNS40MjQ2IDMxLjE2NTcgMjUuNjE2M0MzMS4wNTc0IDI1LjgwOCAzMS4wMDAyIDI2LjAyNjMgMzEgMjYuMjQ4N1Y1My43NTEzQzMxLjAwMDIgNTMuOTczNyAzMS4wNTc0IDU0LjE5MiAzMS4xNjU3IDU0LjM4MzdDMzEuMjczOSA1NC41NzU0IDMxLjQyOTMgNTQuNzMzNiAzMS42MTU5IDU0Ljg0MThDMzEuODAyNCA1NC45NTAxIDMyLjAxMzIgNTUuMDA0NiAzMi4yMjY3IDU0Ljk5OTdDMzIuNDQwMiA1NC45OTQ4IDMyLjY0ODUgNTQuOTMwNiAzMi44MzAyIDU0LjgxMzlMNTQuNDE4MSA0MS4wNjI2QzU0LjU5NTQgNDAuOTUzNCA1NC43NDIzIDQwLjc5OCA1NC44NDQzIDQwLjYxMTdDNTQuOTQ2MyA0MC40MjUzIDU1IDQwLjIxNDUgNTUgNDBDNTUgMzkuNzg1NSA1NC45NDYzIDM5LjU3NDcgNTQuODQ0MyAzOS4zODgzQzU0Ljc0MjMgMzkuMjAyIDU0LjU5NTQgMzkuMDQ2NiA1NC40MTgxIDM4LjkzNzRaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K);
    background-repeat: no-repeat;
    background-position: center;
    width: 80px;
    height: 80px;
    transform: translate(-50%, -50%);
    top: 50%;
    left: 50%
  }

  ._advice-cart_cvk3m_1:hover:after {
    opacity: .8
  }

  ._advice-cart_cvk3m_1:after {
    content: "";
    position: absolute;
    display: block;
    width: 100%;
    height: 100%;
    bottom: 0;
    right: 0;
    z-index: -1;
    transition: opacity .4s ease-out;
    background: linear-gradient(359.31deg, #000000 -10.54%, rgba(0, 0, 0, .59) 23.04%, rgba(0, 0, 0, .24) 53.41%, rgba(51, 51, 51, 0) 102.76%)
  }

  ._advice-cart_cvk3m_1:hover {
    background-position-y: 100px
  }

  ._advice-cart__img_cvk3m_45 {
    display: flex;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    right: 0;
    z-index: -1
  }

  ._advice-cart__img_cvk3m_45 img {
    width: 100%;
    height: 100%;
    object-fit: cover
  }

  ._advice-cart__title_cvk3m_59 {
    font-size: var(--big-font-size);
    font-weight: 500;
    width: 60%;
    color: var(--color-white)
  }

  ._feedback_or8ny_1 {
    color: var(--color-white);
    display: flex;
    align-items: center;
    gap: 18px;
    font-weight: 400
  }

  @media (max-width: 768px) and (min-width: 550px) {
    ._feedback_or8ny_1 {
      gap: 12px
    }
  }

  ._feedback_or8ny_1 div {
    display: flex;
    align-items: center;
    gap: 5px;
    flex-shrink: 0
  }

  ._advice-small-card_7l0ny_1 {
    display: flex;
    align-items: center;
    flex-direction: column;
    box-shadow: 0 9px 33px #00000008, 0 2px 18px #0000000a, 0 2px 10px #00000008, 0 1.4px 5px #00000008, 0 1.17px 2px #00000005;
    border-radius: 8px;
    transition: filter .5s;
    position: relative
  }

  ._advice-small-card__video_7l0ny_10:before {
    position: absolute;
    content: "";
    z-index: 555;
    background: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAiIGhlaWdodD0iODAiIHZpZXdCb3g9IjAgMCA4MCA4MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBvcGFjaXR5PSIwLjQiIGN4PSI0MCIgY3k9IjQwIiByPSI0MCIgZmlsbD0iIzMzMzMzMyIvPgo8cGF0aCBkPSJNNTQuNDE4MSAzOC45Mzc0TDMyLjgzMDIgMjUuMTg2MUMzMi42NDg1IDI1LjA2OTQgMzIuNDQwMiAyNS4wMDUyIDMyLjIyNjcgMjUuMDAwM0MzMi4wMTMyIDI0Ljk5NTQgMzEuODAyNCAyNS4wNDk5IDMxLjYxNTkgMjUuMTU4MkMzMS40MjkzIDI1LjI2NjQgMzEuMjczOSAyNS40MjQ2IDMxLjE2NTcgMjUuNjE2M0MzMS4wNTc0IDI1LjgwOCAzMS4wMDAyIDI2LjAyNjMgMzEgMjYuMjQ4N1Y1My43NTEzQzMxLjAwMDIgNTMuOTczNyAzMS4wNTc0IDU0LjE5MiAzMS4xNjU3IDU0LjM4MzdDMzEuMjczOSA1NC41NzU0IDMxLjQyOTMgNTQuNzMzNiAzMS42MTU5IDU0Ljg0MThDMzEuODAyNCA1NC45NTAxIDMyLjAxMzIgNTUuMDA0NiAzMi4yMjY3IDU0Ljk5OTdDMzIuNDQwMiA1NC45OTQ4IDMyLjY0ODUgNTQuOTMwNiAzMi44MzAyIDU0LjgxMzlMNTQuNDE4MSA0MS4wNjI2QzU0LjU5NTQgNDAuOTUzNCA1NC43NDIzIDQwLjc5OCA1NC44NDQzIDQwLjYxMTdDNTQuOTQ2MyA0MC40MjUzIDU1IDQwLjIxNDUgNTUgNDBDNTUgMzkuNzg1NSA1NC45NDYzIDM5LjU3NDcgNTQuODQ0MyAzOS4zODgzQzU0Ljc0MjMgMzkuMjAyIDU0LjU5NTQgMzkuMDQ2NiA1NC40MTgxIDM4LjkzNzRaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K);
    background-repeat: no-repeat;
    background-position: center;
    width: 80px;
    height: 80px;
    transform: translate(-50%, -50%);
    top: 30%;
    left: 50%
  }

  ._advice-small-card_7l0ny_1:hover ._advice-small-card__img_7l0ny_23:after {
    opacity: .4
  }

  ._advice-small-card__img_7l0ny_23 {
    display: flex;
    width: 100%;
    height: 100%;
    transition: all .5s ease-out;
    position: relative;
    height: 175px;
    -webkit-box-reflect: below -1px -webkit-gradient(linear, left top, left bottom, from(transparent), color-stop(67%, transparent), to(rgba(250, 250, 250, .5)))
  }

  ._advice-small-card__img_7l0ny_23:after {
    content: "";
    display: block;
    width: 100%;
    height: 10%;
    position: absolute;
    background: linear-gradient(359.31deg, #000000 -10.54%, rgba(0, 0, 0, .59) 0%, rgba(0, 0, 0, .24) 53.41%, rgba(51, 51, 51, 0) 102.76%);
    transition: all .5s;
    bottom: -20px;
    z-index: 1;
    opacity: 0
  }

  ._advice-small-card__img_7l0ny_23 img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: 8px 8px 0 0/8px 8px 0 0
  }

  ._advice-small-card__footer_7l0ny_56 {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    min-height: 127px;
    justify-content: space-between;
    gap: 12px;
    transition: all .5s ease-out;
    backdrop-filter: blur(20px);
    font-size: var(--base-font-size);
    font-weight: 500;
    border-bottom-right-radius: 8px;
    border-bottom-left-radius: 8px;
    padding: 24px
  }

  ._advice-small-card__text_7l0ny_72 {
    max-height: 72px;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    display: -webkit-box;
    -webkit-box-orient: vertical
  }

  ._paginator_cqydn_1 {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 120px
  }

  @media (max-width: 768px) {
    ._paginator_cqydn_1 {
      margin: 0 auto;
      font-size: 12px;
      gap: 7px
    }
  }

  ._paginator__item_cqydn_14 {
    background: var(--color-white);
    border: 1px solid var(--alignment);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 20px;
    cursor: pointer;
    user-select: none
  }

  @media (max-width: 768px) {
    ._paginator__item_cqydn_14 {
      width: 30px;
      height: 30px
    }
  }

  ._paginator__item--active_cqydn_32 {
    border: 2px solid var(--inner-alignment)
  }

  ._paginator__controller_cqydn_35 {
    background: var(--control-gray);
    width: 40px;
    height: 40px;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: rotate(270deg);
    cursor: pointer
  }

  @media (max-width: 768px) {
    ._paginator__controller_cqydn_35 {
      width: 30px;
      height: 30px
    }
  }

  ._paginator__controller--left_cqydn_52 {
    transform: rotate(90deg)
  }

  ._paginator__controller--disable_cqydn_55 {
    user-select: none;
    pointer-events: none;
    opacity: .4
  }

  ._paginator__dots_cqydn_60 {
    user-select: none
  }

  ._title_1g9ie_1 {
    width: 100%;
    height: 40px;
    background: var(--bg-secondary);
    margin-bottom: 24px;
    border-radius: 8px;
    animation-duration: 2s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: _maskAnimation_1g9ie_1;
    animation-timing-function: linear
  }

  ._bread_1g9ie_14 {
    width: 134px;
    height: 16px;
    background: var(--bg-secondary);
    margin-bottom: 24px;
    border-radius: 8px;
    animation-duration: 2s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: _maskAnimation_1g9ie_1;
    animation-timing-function: linear;
    margin-top: 24px
  }

  ._tabs_1g9ie_28 {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 40px
  }

  ._tabs_1g9ie_28 div {
    background: var(--bg-secondary);
    height: 32px;
    padding: 10px 20px;
    border-radius: 100px;
    animation-duration: 2s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: _maskAnimation_1g9ie_1;
    animation-timing-function: linear
  }

  ._tabs_1g9ie_28 div:nth-child(1) {
    width: 51px
  }

  ._tabs_1g9ie_28 div:nth-child(2) {
    width: 119px
  }

  ._tabs_1g9ie_28 div:nth-child(3) {
    width: 106px
  }

  ._tabs_1g9ie_28 div:nth-child(4) {
    width: 146px
  }

  ._tabs_1g9ie_28 div:nth-child(5) {
    width: 110px
  }

  ._tabs_1g9ie_28 div:nth-child(6) {
    width: 123px
  }

  ._catalog_1g9ie_64 {
    width: 100%;
    display: grid;
    grid-template-columns:1fr .28fr;
    gap: 47px;
    margin-bottom: 56px
  }

  ._catalog__section-one_1g9ie_71 ._catalog__three_1g9ie_71 {
    margin-top: 32px
  }

  ._catalog__section-two_1g9ie_74 {
    display: grid;
    grid-template-columns:1fr 1fr;
    gap: 32px
  }

  ._catalog__section-two_1g9ie_74 ._catalog__three_1g9ie_71 {
    grid-column: 1/-1
  }

  ._catalog__content_1g9ie_82 {
    display: flex;
    flex-direction: column;
    gap: 32px;
    width: 100%
  }

  ._catalog__three_1g9ie_71 {
    display: grid;
    grid-template-columns:1fr 1fr 1fr;
    gap: 32px
  }

  ._catalog__twice_1g9ie_93 {
    display: grid;
    grid-template-columns:1fr 1fr;
    gap: 34px
  }

  @media (max-width: 450px) {
    ._catalog_1g9ie_64, ._catalog__three_1g9ie_71, ._catalog__twice_1g9ie_93, ._catalog__section-two_1g9ie_74 {
      display: flex;
      flex-direction: column
    }
  }

  ._advice1_1g9ie_117 {
    width: 100%;
    height: 278px;
    background: var(--bg-secondary);
    border-radius: 8px;
    animation-duration: 2s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: _maskAnimation_1g9ie_1;
    animation-timing-function: linear
  }

  ._advice2_1g9ie_129 {
    width: 100%;
    height: 286px;
    background: var(--bg-secondary);
    border-radius: 8px;
    animation-duration: 2s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: _maskAnimation_1g9ie_1;
    animation-timing-function: linear
  }

  ._paginator_1g9ie_141 {
    width: 303px;
    height: 40px;
    background: var(--bg-secondary);
    border-radius: 8px;
    animation-duration: 2s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: _maskAnimation_1g9ie_1;
    animation-timing-function: linear;
    margin-bottom: 120px
  }

  ._filter_1g9ie_154 {
    display: flex;
    flex-direction: column;
    gap: 32px
  }

  ._filter_1g9ie_154 div {
    height: 24px;
    background: var(--bg-secondary);
    animation-duration: 2s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: _maskAnimation_1g9ie_1;
    animation-timing-function: linear
  }

  @-moz-keyframes _maskAnimation_1g9ie_1 {
    0% {
      opacity: 1
    }
    50% {
      opacity: .3
    }
    to {
      opacity: 1
    }
  }

  @-webkit-keyframes _maskAnimation_1g9ie_1 {
    0% {
      opacity: 1
    }
    50% {
      opacity: .3
    }
    to {
      opacity: 1
    }
  }

  @-o-keyframes _maskAnimation_1g9ie_1 {
    0% {
      opacity: 1
    }
    50% {
      opacity: .3
    }
    to {
      opacity: 1
    }
  }

  @keyframes _maskAnimation_1g9ie_1 {
    0% {
      opacity: 1
    }
    50% {
      opacity: .3
    }
    to {
      opacity: 1
    }
  }

  ._tabs_1rmcz_1 {
    display: flex;
    align-items: center;
    flex-wrap: wrap
  }

  ._tabs__item_1rmcz_6 {
    background: var(--control-gray);
    padding: 10px 20px;
    border-radius: 100px;
    color: var(--text-primary);
    font-size: var(--small-font-size);
    cursor: pointer;
    transition: color .3s ease-in-out, background .3s ease-in-out
  }

  ._tabs__item_1rmcz_6:hover {
    background: var(--control-hover)
  }

  ._tabs__item--active_1rmcz_18 {
    background: var(--control-primary);
    color: var(--color-white)
  }

  ._tabs__mobile_1rmcz_22 {
    display: none
  }

  ._tabs__desktop_1rmcz_25 {
    gap: 8px;
    display: flex;
    align-items: center
  }

  ._tabs__dropdown_1rmcz_30 {
    position: absolute;
    background: var(--color-white);
    max-height: 400px;
    overflow-y: scroll;
    z-index: 2;
    top: 40px;
    border-bottom-right-radius: 8px;
    border-bottom-left-radius: 8px;
    box-shadow: 0 9px 33px #00000008, 0 2px 18px #0000000a, 0 2px 10px #00000008, 0 1.4px 5px #00000008, 0 1.17px 2px #00000005
  }

  ._tabs__dropdown_1rmcz_30 ._tabs__item_1rmcz_6 {
    width: 100%;
    text-align: start;
    border-radius: 8px;
    background: var(--color-white)
  }

  ._tabs__dropdown_1rmcz_30 ._tabs__item--active_1rmcz_18 {
    background: var(--bg-secondary);
    color: var(--text-primary)
  }

  ._tabs__selector_1rmcz_51 {
    display: none;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid var(--control-secondary);
    padding: 0 0 10px
  }

  @media (max-width: 769px) {
    ._tabs_1rmcz_1 {
      margin-bottom: 0;
      width: 100%;
      position: relative
    }

    ._tabs__mobile_1rmcz_22 {
      display: block;
      width: 100%
    }

    ._tabs__desktop_1rmcz_25 {
      display: none
    }

    ._tabs__selector_1rmcz_51 {
      display: flex
    }
  }

  ._filter__item_1fk10_1 {
    cursor: pointer;
    padding: 16px;
    border-radius: 8px;
    background: transparent;
    color: var(--text-primary);
    transition: background .2s ease-out;
    width: 100%;
    text-align: start
  }

  ._filter__item_1fk10_1:hover, ._filter__item--active_1fk10_14 {
    background: var(--bg-secondary)
  }

  ._filter__selector_1fk10_17 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid var(--control-secondary);
    padding: 0 0 10px
  }

  ._filter__dropdown_1fk10_24 {
    position: absolute;
    background: var(--color-white);
    max-height: 400px;
    overflow-y: scroll;
    z-index: 2;
    top: 40px;
    border-bottom-right-radius: 8px;
    border-bottom-left-radius: 8px;
    box-shadow: 0 9px 33px #00000008, 0 2px 18px #0000000a, 0 2px 10px #00000008, 0 1.4px 5px #00000008, 0 1.17px 2px #00000005
  }

  @media (max-width: 768px) {
    ._filter__desktop_1fk10_36 {
      display: none !important
    }
  }

  ._filter__mobile_1fk10_40 {
    position: relative;
    width: 100%
  }

  @media (min-width: 769px) {
    ._filter__mobile_1fk10_40 {
      display: none !important
    }
  }

  ._instruction__section_1ovr9_1 {
    display: grid;
    grid-template-columns:1fr .3fr;
    gap: 24px;
    align-items: flex-start;
    margin-bottom: 65px
  }

  @media (max-width: 600px) {
    ._instruction__section_1ovr9_1 {
      display: flex;
      flex-direction: column
    }
  }

  ._instruction__section_1ovr9_1 p {
    margin: 0
  }

  ._instruction__section_1ovr9_1 ._section__margin_1ovr9_17 {
    margin-bottom: 16px
  }

  ._img-container_1ovr9_21 {
    display: flex
  }

  ._img-container_1ovr9_21 img {
    width: 100%;
    height: 100%;
    object-fit: contain
  }

  ._info-advice_1ovr9_30 {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 90px;
    max-width: 707px;
    padding-top: 26px;
    margin: auto;
    max-width: 1189px
  }

  ._info-advice_1ovr9_30 h1 {
    font-size: 48px;
    margin-bottom: 32px;
    margin-top: 16px;
    line-height: 56px
  }

  @media (max-width: 600px) {
    ._info-advice_1ovr9_30 h1 {
      font-size: 34px
    }
  }

  ._info-advice_1ovr9_30 h2 {
    font-weight: 500;
    font-size: 26px;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px
  }

  ._info-advice_1ovr9_30 h2 span {
    border: 2px solid var(--text-primary);
    border-radius: 50%;
    width: 38px;
    height: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: var(--big-font-size)
  }

  ._info-advice_1ovr9_30 h3 {
    font-weight: 500;
    font-size: var(--big-font-size)
  }

  ._info-advice_1ovr9_30 p {
    font-weight: 500;
    font-size: var(--base-font-size)
  }

  @media (max-width: 1024px) {
    ._info-advice_1ovr9_30 {
      margin-left: 123px;
      max-width: 616px
    }
  }

  @media (max-width: 768px) {
    ._info-advice_1ovr9_30 {
      margin: 0 auto;
      max-width: 606px
    }
  }

  @media (max-width: 600px) {
    ._info-advice_1ovr9_30 {
      margin-left: 14px;
      margin-right: 14px
    }
  }

  ._info-advice__category_1ovr9_96 {
    background: var(--control-gray);
    border-radius: 100px;
    padding: 6px 12px;
    color: var(--text-primary)
  }

  ._info-advice__banner_1ovr9_102 {
    border-radius: 8px;
    width: 100%
  }

  ._info-advice__container_1ovr9_106 {
    display: flex;
    flex-direction: column
  }

  ._info-advice__section_1ovr9_110 p {
    font-weight: 400
  }

  ._info-advice__snackbar_1ovr9_113 {
    background: var(--bg-secondary)
  }

  ._info-advice__snackbar_1ovr9_113 p {
    position: relative;
    margin-left: 40px;
    padding: 16px 16px 16px 8px;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px
  }

  ._info-advice__snackbar_1ovr9_113 p:before {
    content: "i";
    position: absolute;
    border: 3px solid var(--text-primary);
    width: 20px;
    height: 20px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    left: -25px;
    font-weight: 700
  }

  ._info-advice__instruction_1ovr9_137 {
    display: flex;
    flex-direction: column;
    gap: 48px;
    margin-bottom: 32px
  }

  ._info-advice__instruction_1ovr9_137 h3 {
    margin-bottom: -20px
  }

  ._advice__html-body_1ovr9_147 {
    max-width: 1190px;
    margin: auto
  }

  ._comments_95umz_1 {
    width: 100%
  }

  ._comments_95umz_1 h2 {
    font-size: 26px;
    line-height: 32px;
    display: flex;
    align-items: center;
    flex-direction: row;
    gap: 8px
  }

  ._comments_95umz_1 h2:before {
    display: none
  }

  ._comments_95umz_1 h2 div {
    font-weight: 500;
    font-size: 26px;
    line-height: 32px;
    color: var(--text-secondary)
  }

  ._comments__heading_95umz_21 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 40px
  }

  @media (max-width: 600px) {
    ._comments__heading_95umz_21 {
      flex-direction: column;
      width: 100%;
      align-items: flex-start
    }

    ._comments__heading_95umz_21 ._comments__tabs_95umz_33 {
      width: 100%;
      gap: 0
    }

    ._comments__heading_95umz_21 ._comments__tabs_95umz_33 span {
      width: 100%;
      text-align: center
    }
  }

  ._comments__tabs_95umz_33 {
    display: flex;
    align-items: center;
    gap: 24px
  }

  ._comments__tabs_95umz_33 span {
    color: var(--text-secondary);
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    letter-spacing: .05px;
    border-bottom: 2px solid var(--control-gray);
    padding-bottom: 8px;
    cursor: pointer;
    transition: color .2s ease-out, border .2s ease-out
  }

  ._comments__tabs_95umz_33 ._active__tab_95umz_58 {
    color: var(--text-primary);
    border-bottom: 2px solid var(--text-primary)
  }

  ._comment_39vjk_1 {
    margin-bottom: 32px
  }

  ._comment__heading_39vjk_4 {
    display: flex;
    align-items: center;
    gap: 12px
  }

  ._comment__heading_39vjk_4 img {
    width: 40px;
    height: 40px;
    object-fit: contain;
    border-radius: 50%
  }

  ._comment__heading_39vjk_4 ._empty-avatar_39vjk_15 {
    width: 40px;
    height: 40px;
    background: var(--control-gray);
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    letter-spacing: .12px;
    color: var(--text-primary);
    border-radius: 50%
  }

  ._comment__user-data_39vjk_29 {
    display: grid;
    grid-template-columns:1fr 1fr
  }

  ._comment__user-name_39vjk_33 {
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: .12px;
    margin-right: 8px
  }

  ._comment__date_39vjk_40 {
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: .12px;
    color: var(--text-secondary)
  }

  ._comment__user-role_39vjk_47 {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: .2px;
    color: var(--accent-dark)
  }

  ._comment__footer_39vjk_54 {
    display: flex;
    align-items: center;
    gap: 21px;
    margin-bottom: 32px
  }

  ._comment__footer_39vjk_54 ._answer_39vjk_60 {
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: .12px;
    color: var(--text-contrast);
    cursor: pointer
  }

  ._comment__footer_39vjk_54 svg {
    cursor: pointer
  }

  ._comment__footer_39vjk_54 div {
    display: flex;
    align-items: center;
    gap: 9px
  }

  ._comment__likes-counter_39vjk_76 {
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: .12px;
    color: var(--text-secondary)
  }

  ._comment__images_39vjk_83 {
    display: flex;
    gap: 10px;
    align-items: center;
    margin-bottom: 16px
  }

  ._comment__images_39vjk_83 div {
    width: 83px;
    height: 83px;
    border-radius: 8px
  }

  ._comment__images_39vjk_83 div img {
    width: 100%;
    height: 100%;
    object-fit: contain
  }

  ._comment__positive_39vjk_99 {
    color: #5ab030
  }

  ._comment__negative_39vjk_102 {
    color: #b84d4b
  }

  ._comment_39vjk_1 p {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: .12px;
    color: var(--text-primary)
  }

  ._pl-40_39vjk_113 {
    padding-left: 40px
  }

  @media (max-width: 600px) {
    ._pl-40_39vjk_113 {
      padding-left: 12px
    }
  }

  ._review_o0cio_1 {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 90px
  }

  @media (max-width: 600px) {
    ._review_o0cio_1 {
      margin-bottom: 65px
    }
  }

  ._review_o0cio_1 h2:before {
    display: none
  }

  ._review__likes_o0cio_15 {
    display: flex;
    align-items: center;
    gap: 8px
  }

  ._review__likes_o0cio_15 div {
    gap: 4px;
    justify-content: center;
    display: flex;
    align-items: center;
    width: 76px;
    height: 44px;
    border: 2px solid var(--control-secondary);
    border-radius: 40px;
    cursor: pointer;
    transition: all .5s
  }

  ._review__likes_o0cio_15 div:hover, ._review__likes_o0cio_15 ._like__active_o0cio_35 {
    border-color: var(--control-primary)
  }

  ._testimonial_o0cio_39 {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 20px
  }

  @media (max-width: 600px) {
    ._testimonial_o0cio_39 {
      display: none
    }
  }

  ._testimonial_o0cio_39 h2:before {
    display: none
  }

  ._testimonial_o0cio_39 input, ._testimonial_o0cio_39 textarea {
    width: 100%;
    height: 150px;
    background: #fff;
    border: 1px solid var(--control-secondary);
    border-radius: 4px;
    padding: 20px;
    font-size: inherit;
    outline: 0;
    resize: vertical
  }

  ._testimonial_o0cio_39 input {
    height: auto;
    width: 30%;
    padding: 10px
  }

  ._testimonial_o0cio_39 button, ._testimonial_o0cio_39 label {
    border: none;
    outline: none;
    background: var(--control-primary);
    color: var(--color-white);
    padding: 10px 20px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    cursor: pointer
  }

  ._testimonial_o0cio_39 button:first-of-type, ._testimonial_o0cio_39 label:first-of-type {
    padding: 10px 13px
  }

  ._testimonial__btns_o0cio_89 {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-left: auto
  }

  ._testimonial__files_o0cio_95 {
    display: flex;
    gap: 15px;
    flex-wrap: wrap
  }

  ._info-advice_bsb3n_1 {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 90px;
    max-width: 707px;
    padding-top: 26px;
    margin: auto
  }

  @media (max-width: 1024px) {
    ._info-advice_bsb3n_1 {
      margin-left: 123px
    }
  }

  @media (max-width: 768px) {
    ._info-advice_bsb3n_1 {
      margin: 0 auto;
      max-width: 606px
    }
  }

  @media (max-width: 600px) {
    ._info-advice_bsb3n_1 {
      margin-left: 14px;
      margin-right: 14px
    }
  }

  ._info-advice_bsb3n_1 h1 {
    font-size: 48px;
    margin-bottom: 32px;
    margin-top: 16px;
    line-height: 56px
  }

  @media (max-width: 600px) {
    ._info-advice_bsb3n_1 h1 {
      font-size: 34px
    }
  }

  ._info-advice_bsb3n_1 h2 {
    font-weight: 500;
    font-size: 26px;
    position: relative
  }

  ._info-advice__icons_bsb3n_44 {
    display: flex;
    align-items: center;
    gap: 18px;
    color: var(--text-contrast)
  }

  ._info-advice__icons_bsb3n_44 div {
    display: flex;
    align-items: center;
    gap: 5px
  }

  ._info-advice__header_bsb3n_55 {
    margin-bottom: -52px
  }

  ._info-advice__video_bsb3n_58 {
    width: 100%;
    height: 355px
  }

  @media (max-width: 600px) {
    ._info-advice__video_bsb3n_58 {
      width: 105%;
      height: 355px;
      margin-left: -13px
    }
  }

  ._info-advice__category_bsb3n_69 {
    background: var(--control-gray);
    border-radius: 100px;
    padding: 6px 12px;
    color: var(--text-primary)
  }

  ._info-advice__bottom_bsb3n_75 {
    width: 100%
  }

  ._recomendation_1lw2m_1 {
    display: flex;
    flex-direction: column;
    max-width: 1189px;
    margin: 0 auto;
    scrollbar-color: white transparent;
    scrollbar-width: thin
  }

  ._recomendation_1lw2m_1::-webkit-scrollbar {
    width: 0
  }

  ._recomendation_1lw2m_1::-webkit-scrollbar-track {
    background: transparent
  }

  ._recomendation_1lw2m_1::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 50px
  }

  @media (max-width: 767px) {
    ._recomendation_1lw2m_1::-webkit-scrollbar-thumb {
      display: none
    }
  }

  @media (max-width: 1024px) {
    ._recomendation_1lw2m_1 {
      padding: 0 0 0 42px
    }
  }

  @media (max-width: 600px) {
    ._recomendation_1lw2m_1 {
      padding: 0 0 0 16px
    }
  }

  ._recomendation__slider_1lw2m_34 {
    display: grid;
    grid-template-columns:1fr 1fr 1fr 1fr;
    gap: 23px;
    max-width: 1189px;
    overflow: scroll;
    padding-bottom: 85px
  }

  ._recomendation__slider_1lw2m_34::-webkit-scrollbar {
    width: 0
  }

  ._recomendation__slider_1lw2m_34::-webkit-scrollbar-track {
    background: transparent
  }

  ._recomendation__slider_1lw2m_34::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 50px
  }

  @media (max-width: 767px) {
    ._recomendation__slider_1lw2m_34::-webkit-scrollbar-thumb {
      display: none
    }
  }

  ._recomendation__slider_1lw2m_34 a {
    width: 271px
  }

  @media (max-width: 600px) {
    ._recomendation__slider_1lw2m_34 {
      display: flex
    }
  }

  ._recomendation__slider_1lw2m_34 a {
    flex-shrink: 0
  }

  ._header_bvfaj_1 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: var(--small-font-size);
    padding: var(--base-padding)
  }

  @media (max-width: 768px) {
    ._header_bvfaj_1 {
      display: grid;
      grid-template-columns:1fr 1fr 1fr;
      gap: 14px
    }
  }

  ._header__open_bvfaj_15 {
    position: fixed;
    z-index: 1000;
    top: 0;
    left: 0;
    right: 0;
    background: white;
    padding: 22px 145px
  }

  ._header__open_bvfaj_15 ._location_bvfaj_24, ._header__open_bvfaj_15 ._stores_bvfaj_25, ._header__open_bvfaj_15 ._search_bvfaj_26, ._header__open_bvfaj_15 ._sections_bvfaj_27 {
    display: none
  }

  @media (max-width: 1024px) {
    ._header__open_bvfaj_15 {
      padding: 22px 30px
    }
  }

  ._header_bvfaj_1 ._close__btn_bvfaj_35 {
    cursor: pointer;
    position: fixed;
    top: 31px;
    right: 9%;
    width: 16px;
    height: 16px;
    z-index: 1001;
    background: url(data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTAgMTAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xIDBMMCAxbDQgNC00IDQgMSAxIDQtNCA0IDQgMS0xLTQtNCA0LTQtMS0xLTQgNC00LTR6Ij48L3BhdGg+PC9zdmc+);
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover
  }

  @media (max-width: 768px) {
    ._stores_bvfaj_25 {
      display: none !important
    }
  }

  ._location_bvfaj_24 {
    display: flex;
    align-items: center;
    gap: 9px
  }

  @media (max-width: 768px) {
    ._location_bvfaj_24 {
      display: none !important
    }
  }

  ._logo_bvfaj_66 {
    display: flex;
    align-items: center;
    gap: 30px;
    cursor: pointer
  }

  @media (max-width: 768px) {
    ._logo_bvfaj_66 {
      margin: 0 auto
    }
  }

  ._search_bvfaj_26 {
    flex-basis: 661px;
    display: flex;
    align-items: center;
    gap: 28px
  }

  @media (max-width: 768px) and (min-width: 500px) {
    ._search_bvfaj_26 {
      display: none
    }
  }

  ._search_bvfaj_26 a {
    display: flex;
    align-items: center;
    gap: 5px;
    flex-shrink: 0
  }

  ._search_bvfaj_26 input {
    outline: none;
    border: none;
    background: var(--control-gray);
    padding: 10px 12px;
    border-radius: 4px;
    letter-spacing: .12px;
    font-weight: 400;
    font-size: var(--small-font-size);
    width: 100%
  }

  ._search_bvfaj_26 input::placeholder {
    color: var(--text-primary)
  }

  @media (max-width: 768px) {
    ._search_bvfaj_26 {
      grid-column: 1/-1;
      order: 3
    }
  }

  ._search__catalog_bvfaj_115 {
    cursor: pointer
  }

  @media (max-width: 768px) {
    ._search__catalog_bvfaj_115 {
      display: none !important
    }
  }

  ._sections_bvfaj_27 {
    display: flex;
    align-items: center;
    gap: 12px
  }

  @media (max-width: 768px) {
    ._sections_bvfaj_27 {
      margin-left: auto
    }
  }

  ._profile_bvfaj_135 {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background .3s ease-in-out;
    position: relative
  }

  ._profile_bvfaj_135:hover {
    background: var(--hover-minor)
  }

  ._profile_bvfaj_135 span {
    width: 20px;
    height: 20px;
    display: block
  }

  ._profile__counter_bvfaj_153 {
    position: absolute;
    background: var(--attention-primary);
    color: var(--color-white);
    font-weight: 500;
    font-size: var(--tiny-font-size);
    border-radius: 100px;
    padding: 0 4.5px;
    border: 2px solid var(--color-white);
    top: -6px;
    right: -6px;
    line-height: 16px
  }

  @media (max-width: 768px) {
    ._profile_bvfaj_135 {
      display: none !important
    }
  }

  ._cart_bvfaj_172 {
    color: var(--color-white);
    position: relative;
    display: flex;
    align-items: center;
    gap: 8px
  }

  ._cart__icon_bvfaj_179 {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    background: var(--control-primary);
    border-radius: 50%
  }

  @media (max-width: 768px) {
    ._cart__icon_bvfaj_179 {
      background: transparent;
      color: var(--text-primary)
    }
  }

  ._cart__counter_bvfaj_194 {
    position: absolute;
    background: var(--attention-primary);
    color: var(--color-white);
    font-weight: 500;
    font-size: var(--tiny-font-size);
    border-radius: 100px;
    padding: 0 4.5px;
    border: 2px solid var(--color-white);
    top: -6px;
    right: 55px;
    line-height: 16px
  }

  @media (max-width: 768px) {
    ._cart__counter_bvfaj_194 {
      display: none !important
    }
  }

  ._cart_bvfaj_172 span {
    color: var(--text-primary)
  }

  @media (max-width: 768px) {
    ._cart_bvfaj_172 span {
      display: none !important
    }
  }

  ._burger_bvfaj_221 {
    width: 20px;
    height: 3px;
    background: var(--text-primary);
    position: relative;
    border-radius: 5px;
    cursor: pointer;
    display: none
  }

  ._burger_bvfaj_221:after, ._burger_bvfaj_221:before {
    display: block;
    content: "";
    position: absolute;
    background: var(--text-primary);
    height: 3px;
    width: 20px;
    border-radius: 5px
  }

  ._burger_bvfaj_221:after {
    top: 5px
  }

  ._burger_bvfaj_221:before {
    bottom: 5px
  }

  @media (max-width: 768px) {
    ._burger_bvfaj_221 {
      display: block !important
    }
  }

  ._cities-popup_1m26c_1 {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: var(--color-white);
    z-index: 999;
    max-height: 100vh;
    overflow: scroll
  }

  ._cities-popup__body_1m26c_12 {
    padding-top: 8%;
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    padding-left: 25px;
    gap: 20px
  }

  @media (max-width: 768px) {
    ._cities-popup__body_1m26c_12 {
      padding-top: 10%
    }
  }

  ._cities-popup__body_1m26c_12 span:first-of-type {
    grid-column: 1/5;
    font-weight: 500;
    font-size: 26px;
    line-height: 32px
  }

  ._cities-popup__body_1m26c_12 ._body__list_1m26c_33 {
    display: grid;
    grid-template-columns:repeat(4, 1fr)
  }

  @media (max-width: 500px) {
    ._cities-popup__body_1m26c_12 ._body__list_1m26c_33 {
      display: flex;
      flex-direction: column
    }
  }

  ._cities-popup__body_1m26c_12 ._popup__link-item_1m26c_43 {
    padding: 10px 0
  }

  ._cities-popup__body_1m26c_12 ._popup__link-item_1m26c_43:nth-child(1) {
    font-weight: 500
  }

  ._cities-popup__body_1m26c_12 ._popup__link-item_1m26c_43:nth-child(2) {
    font-weight: 500
  }

  ._cities-popup__body_1m26c_12 input {
    outline: none;
    border: none;
    background: var(--control-gray);
    padding: 16px;
    border-radius: 4px;
    letter-spacing: .12px;
    font-weight: 400;
    font-size: var(--small-font-size);
    width: 50%
  }

  ._cities-popup__body_1m26c_12 input::placeholder {
    color: var(--text-primary)
  }

  ._cities-popup_1m26c_1 ._top_1m26c_66 {
    cursor: pointer;
    position: fixed;
    top: 31px;
    right: 9%;
    width: 16px;
    height: 16px;
    z-index: 1001;
    background: url(data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTAgMTAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xIDBMMCAxbDQgNC00IDQgMSAxIDQtNCA0IDQgMS0xLTQtNCA0LTQtMS0xLTQgNC00LTR6Ij48L3BhdGg+PC9zdmc+);
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover
  }

  ._cities-popup_1m26c_1 ._body__header_1m26c_79 {
    display: flex;
    flex-direction: column
  }

  ._cities-popup_1m26c_1 ._body__header_1m26c_79 span {
    font-weight: 500;
    font-size: 26px;
    line-height: 32px;
    color: var(--text-primary)
  }

  ._sidebar_1yloj_1 {
    position: fixed;
    top: 0;
    left: -260px;
    bottom: 0;
    overflow-y: scroll;
    z-index: 999;
    transition: all .3s ease-in-out;
    background: white;
    padding-top: 60px;
    max-width: 254px;
    color: var(--text-primary)
  }

  ._sidebar__open_1yloj_14 {
    left: 0
  }

  ._sidebar__sections_1yloj_17 {
    display: flex;
    flex-direction: column
  }

  ._sidebar__sections_1yloj_17 div {
    padding: 16px;
    border-bottom: 1px solid #e5e5e5
  }

  ._sidebar__location_1yloj_25 {
    display: flex;
    flex-direction: column;
    gap: 20px;
    font-size: 16px;
    font-weight: 400;
    line-height: 22px
  }

  ._sidebar__catalog_1yloj_33, ._sidebar__stores_1yloj_41, ._sidebar__cart_1yloj_49, ._sidebar__city_1yloj_57 {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 16px;
    font-weight: 400;
    line-height: 22px
  }

  ._sidebar_1yloj_1 svg {
    fill: var(--control-gray);
    width: 24px;
    height: 24px
  }

  ._overcover_1yloj_71 {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: black;
    opacity: .5;
    z-index: 998
  }

  ._close__btn_1yloj_82 {
    cursor: pointer;
    position: absolute;
    top: 20px;
    left: 20px;
    width: 16px;
    height: 16px;
    background: url(data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTAgMTAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xIDBMMCAxbDQgNC00IDQgMSAxIDQtNCA0IDQgMS0xLTQtNCA0LTQtMS0xLTQgNC00LTR6Ij48L3BhdGg+PC9zdmc+);
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover
  }

  ._footer_1ey5s_1 {
    padding: .7143rem 0 2.1429rem;
    grid-auto-flow: column;
    display: grid;
    margin-right: auto;
    margin-left: auto;
    width: 1200px
  }

  @media (max-width: 1024px) {
    ._footer_1ey5s_1 {
      display: flex;
      flex-direction: column;
      width: auto;
      gap: 25px
    }
  }

  ._footer__bg_1ey5s_17 {
    background: rgb(241, 241, 241);
    border-top: 5px solid rgb(102, 192, 93);
    padding: .7143rem 0 2.1429rem
  }

  ._footer__accordion_1ey5s_22 {
    display: flex
  }

  ._footer__accordion_1ey5s_22 ul, ._footer__accordion_1ey5s_22 li {
    list-style-type: none
  }

  ._footer__accordion_1ey5s_22 div {
    border-right: 1px dashed rgb(221, 221, 221);
    padding-right: .7143rem;
    padding-left: .7143rem
  }

  ._footer__accordion_1ey5s_22 div:last-of-type {
    border-right: none
  }

  @media (max-width: 600px) {
    ._footer__accordion_1ey5s_22 {
      flex-direction: column
    }

    ._footer__accordion_1ey5s_22 ._footer__column_1ey5s_41 {
      border-bottom: 1px solid rgb(221, 221, 221)
    }

    ._footer__accordion_1ey5s_22 ._footer__column_1ey5s_41 ._opened_1ey5s_44 {
      display: flex
    }

    ._footer__accordion_1ey5s_22 ._footer__column_1ey5s_41:first-of-type h3 {
      margin-top: 0
    }

    ._footer__accordion_1ey5s_22 ._footer__column_1ey5s_41 h3 {
      margin-top: 20px;
      display: flex;
      align-items: center;
      justify-content: space-between
    }

    ._footer__accordion_1ey5s_22 ._footer__column_1ey5s_41 h3 svg {
      display: block
    }

    ._footer__accordion_1ey5s_22 ._footer__column_1ey5s_41 div {
      display: flex;
      flex-wrap: wrap;
      gap: 10px
    }

    ._footer__accordion_1ey5s_22 ._footer__column_1ey5s_41 ul {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
      display: none
    }

    ._footer__accordion_1ey5s_22 ._footer__column_1ey5s_41 ul li {
      color: var(--text-secondary)
    }
  }

  ._footer__column_1ey5s_41 {
    display: flex;
    flex-direction: column
  }

  ._footer__column_1ey5s_41 li {
    color: var(--green);
    font-size: 12px
  }

  ._footer__column_1ey5s_41 li a {
    line-height: 1.398
  }

  ._footer__column_1ey5s_41 li a:hover {
    text-decoration: underline
  }

  ._footer__column_1ey5s_41 div {
    display: flex;
    flex-direction: row;
    gap: 25px
  }

  ._footer__column_1ey5s_41 h3 {
    color: var(--text-primary);
    font-size: 18px;
    font-weight: 600;
    white-space: nowrap;
    margin-top: 0
  }

  ._footer__column_1ey5s_41 h3 svg {
    display: none
  }

  ._footer__links-block_1ey5s_103 {
    display: grid;
    grid-template-rows:repeat(2, minmax(0px, 50px)) minmax(0px, 70px) repeat(2, minmax(0px, 50px));
    gap: 1.1429rem
  }

  ._footer__links-block_1ey5s_103 form {
    position: relative;
    display: flex;
    box-sizing: border-box;
    width: 100%
  }

  ._footer__links-block_1ey5s_103 form input {
    width: 100%;
    flex: 1 1 70%;
    box-sizing: border-box;
    padding: .5714rem .5714rem .5714rem 2.5714rem;
    margin: 0;
    border-top: 3px solid rgb(102, 192, 93);
    border-bottom: 3px solid rgb(102, 192, 93);
    border-left: 3px solid rgb(102, 192, 93);
    border-image: initial;
    border-right: none;
    border-radius: 0
  }

  ._footer__links-block_1ey5s_103 form label {
    position: absolute;
    top: 50%;
    left: 15px;
    width: 16px;
    height: 12px;
    font-size: 0;
    background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDE2IDEyIj4gICAgPHBhdGggZmlsbD0iI0IyQjJCMiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMS4xODIgMGw2LjYwNiA2LjZMMTQuMzg5IDBIMS4xODJ6TTguNzMgNy41NWwtLjk0My45NDItLjk0MS0uOTQyTDAgLjcwNXYxMC41MTNsNC42OTMtNC42OTIuOTQyLjk0Mi00LjQ1OCA0LjQ1OGgxMy4yMjFMOS45NCA3LjQ2OGwuOTQyLS45NDIgNC42OTIgNC42OTZWLjcwNUw4LjczIDcuNTV6Ii8+PC9zdmc+);
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    transform: translateY(-50%)
  }

  ._footer__links-block_1ey5s_103 form button {
    z-index: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    font-weight: 400;
    font-family: inherit;
    line-height: 1em;
    text-decoration: none;
    border: 1px solid var(--button-border-color);
    border-radius: var(--button-border-radius);
    color: var(--color-white) !important;
    background-color: var(--green) !important;
    height: 100%;
    padding: 10px;
    margin: 0;
    border: none;
    line-height: 13px;
    font-size: 11px
  }

  ._footer__info_1ey5s_163 {
    font-size: 12px;
    letter-spacing: .2px
  }

  ._footer__apps_1ey5s_167 {
    display: flex;
    gap: 5px
  }

  ._footer__apps_1ey5s_167 a {
    width: 217px;
    height: 52px;
    display: block
  }

  @media (max-width: 600px) {
    ._footer__apps_1ey5s_167 a {
      width: auto
    }
  }

  ._footer__apps_1ey5s_167 a svg {
    width: 100%;
    height: 100%
  }

  ._footer__adeo_1ey5s_185 {
    display: flex;
    align-items: center;
    gap: 10px
  }

  ._footer__adeo_1ey5s_185 a {
    z-index: 1;
    width: 100%;
    height: 100%;
    padding: 1.1429rem .7143rem 1.1429rem 4.5000rem;
    font-size: 13px;
    background: rgb(228, 228, 228);
    display: inline-flex;
    align-items: center;
    justify-content: center
  }

  ._footer__payment_1ey5s_204 {
    display: flex;
    flex-wrap: wrap;
    height: 100%;
    align-items: center;
    gap: 10px
  }

  ._footer__payment_1ey5s_204 div {
    display: flex;
    flex: 1 0 auto;
    align-items: center;
    justify-content: space-between
  }

  ._footer__main-link_1ey5s_217 {
    display: flex;
    align-items: center;
    gap: 15px;
    color: var(--green);
    font-size: 14px
  }

  ._footer__main-link_1ey5s_217:before {
    content: "";
    display: flex;
    flex: 1 1 25%;
    max-width: 100%;
    height: 1px;
    background-color: #d9d9d9
  }

  .kitchen-sink__section {
    max-width: 1180px;
    margin: 47px auto;
    padding: 0 15px;
  }

  .kitchen-sink__section p {
    font-size: 18px;
    line-height: 140%;
  }

  .kitchen-sink__section p:last-child {
    margin-bottom: 0;
  }

  .kitchen-sink__section .bold-font {
    font-weight: 500;
  }

  .kitchen-sink__section a {
    -webkit-text-decoration-line: underline;
    text-decoration-line: underline;
    color: #000;
  }

  .kitchen-sink__section a:hover {
    text-decoration: none;
  }

  .kitchen-sink__h3 {
    font-weight: 500;
    font-size: 24px;
  }

  .kitchen-sink_flex-type-1, .kitchen-sink_flex-type-2, .kitchen-sink_flex-type-3 {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }

  .kitchen-sink_flex-type-3 {
    align-items: center;
  }

  .kitchen-sink_flex-type-2 {
    margin-bottom: 68px;
  }

  .kitchen-sink_flex-type-1 img {
    width: 26%;
  }

  .kitchen-sink_flex-type-2 img {
    width: 40%;
  }

  .kitchen-sink_flex-type-3 img {
    width: 170px;
  }

  .kitchen-sink_flex-type-1 .kitchen-sink_flex__text {
    width: 70%;
  }

  .kitchen-sink_flex-type-2 .kitchen-sink_flex__text {
    width: 55%;
  }

  .kitchen-sink_flex-type-3 .kitchen-sink_flex__text {
    width: calc(100% - 210px);
  }

  .kitchen-sink_flex__text p {
    margin-top: 0;
    font-size: 17px;
  }

  .kitchen-sink__h4 {
    font-weight: bold;
    font-size: 18px;
    line-height: 24px;
    margin-bottom: 30px;
  }

  .kitchen-sink__icons-grid {
    display: -webkit-box;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-bottom: 50px;
  }

  .kitchen-sink__icons-grid__item {
    display: flex;
    align-items: center;
    width: 48%;
    margin-bottom: 44px;
  }

  .kitchen-sink__icons-grid__item img {
    width: 170px;
  }

  .kitchen-sink__icons-grid__item p {
    width: calc(100% - 210px);
    margin-left: 40px;
    margin-top: 0;
  }

  .kitchen-sink__img-grid {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .kitchen-sink__img-grid__item {
    width: 48%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .kitchen-sink__img-grid__item p {
    width: calc(100% - 320px);
    margin-left: 40px;
    margin-top: 0;
  }

  .alert-p {
    display: flex;
    align-items: center;
    font-weight: 500;
  }

  .alert-p img {
    margin-right: 19px;
  }

  ul {
    padding: 0 20px;
    margin: 0;
    font-size: 17px;
    line-height: 140%;
  }

  .green-text {
    font-weight: 500;
    font-size: 18px;
    color: #459F3C;
  }

  .green-text a {
    color: #459F3C;
  }

  @media (min-width: 992px) {
    .kitchen-sink__img-grid__item:nth-child(1), .kitchen-sink__img-grid__item:nth-child(2) {
      margin-bottom: 70px;
    }
  }

  /* grid */

  .cust-row {
    display: flex;
    flex-wrap: wrap;
    margin-left: -10px;
    margin-right: -10px;
    margin-top: -20px;
  }

  .cust-row [class^=cust-col] {
    padding-left: 10px;
    padding-right: 10px;
    margin: 0;
    margin-top: 20px;
    flex-shrink: 0;
    flex-grow: 0;
    box-sizing: border-box;
  }

  .cust-col-6 {
    flex-basis: 50%;
    max-width: 50%;
  }

  .cust-col-3 {
    flex-basis: 25%;
    max-width: 25%;
  }

  .cust-col-4 {
    flex-basis: 33.3333%;
    max-width: 33.3333%;
  }

  .cust-col-2 {
    flex-basis: 16.6667%;
    max-width: 16.6667%;
  }

  .cust-col-12 {
    flex-basis: 100%;
    max-width: 100%;
  }

  .hide-me {
    display: none;
  }

  .cust-row [class^=cust-col].mt-0 {
    margin-top: 0;
  }

  p.mb-25, ul.mb-25 {
    margin-top: 0;
    margin-bottom: 25px;
  }

  .cust-row [class^=cust-col].pl-50 {
    padding-left: 50px;
  }

  ul li {
    margin-bottom: 6px;
  }

  /* /grid */

  .cust-row {
    display: flex;
    flex-wrap: wrap;
    margin-left: -10px;
    margin-right: -10px;
    margin-top: -20px;
  }

  .cust-row [class^=cust-col] {
    padding-left: 10px;
    padding-right: 10px;
    margin: 0;
    margin-top: 20px;
    flex-shrink: 0;
    flex-grow: 0;
    box-sizing: border-box;
  }

  .cust-col-6 {
    flex-basis: 50%;
    max-width: 50%;
  }

  .cust-col-4 {
    flex-basis: 33.3333%;
    max-width: 33.3333%;
  }

  .cust-col-2 {
    flex-basis: 16.6667%;
    max-width: 16.6667%;
  }

  .cust-col-12 {
    flex-basis: 100%;
    max-width: 100%;
  }

  .hide-me {
    display: none;
  }

  .show-me {
    display: block;
  }

  @media (max-width: 1024px) {
    .cust-col-tablet-6 {
      flex-basis: 50%;
      max-width: 50%;
    }

    .cust-col-tablet-3 {
      flex-basis: 25%;
      max-width: 25%;
    }

    .cust-col-tablet-12 {
      flex-basis: 100%;
      max-width: 100%;
    }

    .cust-col-3 img {
      width: 100%;
    }
  }
  @media (max-width: 1024px) and (min-width: 769px) {
    .kitchen-sink__icons-grid__item img {
      width: 110px;
    }

    .kitchen-sink__icons-grid__item p {
      width: calc(100% - 160px);
      margin-left: 20px;
    }

    .kitchen-sink__img-grid__item img {
      width: 150px;
    }

    .kitchen-sink__img-grid__item p {
      width: calc(100% - 180px);
      margin-left: 30px;
    }
  }

  @media (max-width: 768px) {
    .cust-row {
      margin-top: -32px;
      margin-left: -16px;
      margin-right: -16px;
    }

    .cust-row [class^=cust-col] {
      margin-top: 32px;
      padding-left: 16px;
      padding-right: 16px;
    }

    .cust-col-v-tablet-6 {
      flex-basis: 50%;
      max-width: 50%;
    }

    .cust-col-v-tablet-12 {
      flex-basis: 100%;
      max-width: 100%;
    }

    .cust-col-v-tablet-3 {
      flex-basis: 25%;
      max-width: 25%;
    }

    .show-me--v-tablet {
      display: block;
    }

    .hide-me--v-tablet {
      display: none;
    }

    .street-light__section {
      margin: 33px 0;
    }

    .street-light__icon_1 {
      width: 48%;
    }

    .street-light_h1 {
      font-size: 22px;
      line-height: 130%;
    }

    .street-light__g-list {
      padding: 20px 15px 0 15px;
    }

    .street-light__gp {
      margin: 15px 15px 0 15px;
      padding-bottom: 15px;
    }

    .street-light__g-item {
      width: 100%;
      margin-bottom: 30px;
    }

    .street-light__types__item {
      width: 48%;
    }

    .street-light__safe-rules__item {
      width: 100%;
    }

    .street-light__house__item {
      width: 48%;
      padding: 15px 15px 5px 15px;
    }

    .cust-row [class^=cust-col].pl-50 {
      padding-left: 6px;
      margin-top: 15px !important;
    }

    .cust-row.pd-30 {
      padding: 20px 15px;
    }

    .kitchen-sink__section {
      margin: 33px 0;
    }

    .kitchen-sink__section p {
      font-size: 16px;
    }

    .kitchen-sink__h3 {
      font-size: 22px;
    }

    .kitchen-sink_flex-type-1, .kitchen-sink_flex-type-2, .kitchen-sink_flex-type-3 {
      flex-wrap: wrap;
    }

    .kitchen-sink_flex-type-1 img {
      max-width: 60%;
      width: auto;
    }

    .kitchen-sink_flex-type-1 .kitchen-sink_flex__text {
      width: 100%;
      margin-top: 25px;
    }

    .kitchen-sink__icons-grid {
      margin-bottom: 30px;
    }

    .kitchen-sink__icons-grid__item {
      width: 100%;
      margin-bottom: 25px;
    }

    .kitchen-sink__icons-grid__item img, .kitchen-sink_flex-type-3 img {
      width: 30%;
    }

    .kitchen-sink__icons-grid__item p, .kitchen-sink_flex-type-3 .kitchen-sink_flex__text {
      width: 65%;
      margin-left: 5%;
    }

    .kitchen-sink__img-grid__item {
      width: 100%;
      margin-bottom: 25px;
    }

    .kitchen-sink__img-grid__item img {
      width: 30%;
    }

    .kitchen-sink__img-grid__item p {
      width: 65%;
      margin-left: 5%;
    }

    .kitchen-sink_flex-type-2 img {
      width: 60%;
    }

    .kitchen-sink_flex-type-2 .kitchen-sink_flex__text {
      width: 100%;
      margin-top: 25px;
    }

    .kitchen-sink_flex-type-2 {
      margin-bottom: 33px;
    }
  }

  @media (max-width: 480px) {
    .cust-row {
      margin-top: -12px;
      margin-left: -6px;
      margin-right: -6px;
    }

    .cust-row [class^=cust-col] {
      margin-top: 12px;
      padding-left: 6px;
      padding-right: 6px;
    }

    .cust-col-mobile-12 {
      flex-basis: 100%;
      max-width: 100%;
    }

  }

  ._1407-wrap {
    overflow-x: hidden;
    max-width: 1366px;
    margin: 0 auto;
  }

  ._1407-container {
    box-sizing: border-box;
    margin: 0 93px;
  }

  .marker {
    position: absolute;
    top: 22px;
    left: 20px;
  }

  ._1407-prevtext {
    position: relative;
    margin: 40px 0;
  }

  ._1407-prevtext__title {
    font-weight: bold;
    font-size: 34px;
    line-height: 40px;
    color: #333333;
    margin-top: 0;
    margin-bottom: 24px;
  }

  ._1407-prevtext__desc {
    font-weight: normal;
    font-size: 20px;
    line-height: 32px;
    color: #333333;
    max-width: 776px;
  }

  ._1407-video {
    margin-bottom: 80px;
    display: flex;
    flex-direction: row;
    align-items: stretch;
    position: relative;
  }

  .video__image {
    width: inherit;
    border-radius: 8px 0 0 8px;
  }

  ._1407-video__user {
    display: flex;
    margin-bottom: 0;
    padding: 64px 64px 0;
  }

  ._1407-video__icon {
    width: 40px;
    height: 40px;
    border-radius: 100px;
    margin-right: 12px;
  }

  ._1407-video__user-content {
    display: flex;
    flex-direction: column;
    align-self: center;
  }

  ._1407-video__content-title {
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    margin-top: 0;
    margin-bottom: 2px;
    color: #333333;
  }

  ._1407-video__content-text {
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    color: #666666;
    margin: 0;
  }

  ._1407-video__slides {
    order: 2;
    position: relative;
  }

  ._1407-video__slide {
    display: flex !important;
    flex-direction: column;
    align-items: stretch;
  }

  ._1407-video__image {
    display: block;
    width: 574px;
    position: relative;
  }

  ._1407-instructions {
    margin-bottom: 80px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    position: relative;
  }

  ._1407-instructions__slides {
    display: flex;
    flex-direction: column;
    width: calc(100% + 80px);
  }

  ._1407-instructions__slide {
    margin-bottom: 40px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }

  ._1407-instructions__container {
    display: flex;
    flex-direction: column;
    width: fit-content;
    height: 100%;
    position: relative;
    box-shadow: 0 0.1660px 2.2138px rgba(0, 0, 0, 0.0196802), 0 0.3990px 5.3201px rgba(0, 0, 0, 0.0282725), 0 0.7513px 10.0172px rgba(0, 0, 0, 0.035), 0 1.3402px 17.869px rgba(0, 0, 0, 0.0417275), 0 2.5067px 33.4221px rgba(0, 0, 0, 0.0503198);
    border-radius: 0 8px 8px 0;
  }

  .step {
    position: absolute;
    top: 40px;
    left: 40px;
    background-color: #ffffff;
    border-radius: 100px;
    width: 48px;
    height: 48px;
    z-index: 100;
    font-size: 29px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  ._1407-instructions__image {
    display: block;
    width: 776px;
    height: 582px;
    position: relative;
  }

  ._1407-instructions__content {
    max-width: 776px;
    padding: 40px 64px;
    order: 3;
  }

  ._1407-instructions__text {
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    color: #333333;
    margin-top: 0;
  }

  ._1407-products {
    margin-bottom: 80px;
  }

  ._1407-products__title {
    font-weight: 500;
    font-size: 26px;
    line-height: 32px;
    color: #333333;
    margin-bottom: 42px;
    margin-top: 0;
  }

  ._1407-products__list {
    width: 100%;
    order: 2;
    position: relative;
    display: flex;
    flex-wrap: wrap;
  }

  ._1407-products__item {
    width: 117px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    position: relative;
  }

  ._1407-products__link {
    margin-right: 32px;
  }

  ._1407-products__link:last-child {
    margin: 0;
  }

  ._1407-products__image {
    width: 117px;
    height: 117px;
    margin-bottom: 8px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    -o-object-fit: contain;
    object-fit: contain;
  }

  ._1407-products__name {
    flex-grow: 1;
    font-weight: normal;
    font-size: 16px;
    line-height: 22px;
    color: #333333;
    margin: 0;
  }

  .card {
    margin-bottom: 15px;
    position: relative;
    width: inherit;
    height: 365px;
    box-shadow: 0 1.17px 2px rgba(0, 0, 0, 0.0196802), 0 1.4px 5px rgba(0, 0, 0, 0.03), 0 2px 10px rgba(0, 0, 0, 0.03), 0 2px 18px rgba(0, 0, 0, 0.04), 0 9px 33px rgba(0, 0, 0, 0.03);
    border-radius: 8px;
    background: #FFFFFF;
  }

  .card--margin {
    margin-right: 32px;
  }

  .card__image {
    width: 271px;
    height: 190px;
    margin-bottom: 19px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }

  .card__span {
    display: grid;
    height: 200px;
  }

  .card__title {
    font-weight: 500;
    font-size: 20px;
    margin: 0 20px;
    line-height: 28px;
    color: #333333;
    max-width: 231px;
  }

  .card__container {
    display: flex;
    padding: 20px;
    position: absolute;
    bottom: 0;
  }

  .card__icon {
    width: 40px;
    height: 40px;
    border-radius: 100px;
    margin-right: 12px;
  }

  .card__content {
    display: flex;
    flex-direction: column;
  }

  .card__content-title {
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    margin-top: 0;
    margin-bottom: 2px;
    color: #333333;
  }

  .card__content-text {
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    color: #666666;
    margin: 0;
  }

  .swiper-button-next-first, .swiper-button-prev-first {
    position: absolute;
    top: 50%;
    z-index: 10;
    cursor: pointer;
    display: none;
    align-items: center;
    justify-content: center;
  }

  @media (max-width: 1024px) {
    .swiper-button-next-first, .swiper-button-prev-first {
      display: flex;
    }
  }

  #swiper-button-prev-first {
    right: auto;
    left: -15px;
  }

  #swiper-button-next-first {
    left: auto;
    right: -20px;
  }

  #swiper-button-next-first, #swiper-button-prev-first {
    outline: none;
    background: #FFFFFF;
    box-shadow: 0 1.17px 2px rgba(0, 0, 0, 0.0196802), 0 1.4px 5px rgba(0, 0, 0, 0.03), 0 2px 10px rgba(0, 0, 0, 0.03), 0 2px 18px rgba(0, 0, 0, 0.04), 0 9px 33px rgba(0, 0, 0, 0.03);
    border-radius: 24px;
    width: 40px;
    height: 40px;
    top: 50%;
  }

  .swiper-button-prev-img {
    transform: rotate(180deg);
    margin: 30%;
  }

  .swiper-button-next-img {
    margin: 30%;
  }

  #swiper-button-prev-first.slick-disabled, #swiper-button-next-first.slick-disabled {
    opacity: 0;
    cursor: auto;
  }

  ._1407-advantages {
    margin-bottom: 7vw;
    position: relative;
  }

  ._1407-advantages__content-link {
    display: flex;
    justify-content: space-between;
    margin-bottom: 32px;
  }

  ._1407-advantages__title {
    font-weight: 500;
    font-size: 26px;
    line-height: 32px;
    margin: 0;
    color: #333333;
  }

  ._1407-advantages__link {
    color: #333333;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    display: flex;
    align-items: center;
    text-align: center;
  }

  ._1407-advantages__arrow {
    width: 20px;
  }

  ._1407-advantages__list {
    display: flex;
    position: relative;
  }


  @media (max-width: 1365px) {
    ._1407-container {
      margin: 0 4.12vw;
    }

    ._1407-prevtext__title {
      max-width: 699px;
    }

    ._1407-prevtext__desc {
      max-width: 697px;
    }

    ._1407-video__image {
      width: 454px;
      height: 100%;
    }

    ._1407-video__user {
      padding: 32px 0 0 32px;
    }

    .video__image {
      width: 454px;
      height: 100%;
    }

    ._1407-instructions__image {
      width: 697px;
      height: 523px;
    }

    ._1407-instructions__content {
      max-width: 697px;
      padding: 16px 32px 46px;
    }

    .card {
      margin-bottom: 15px;
      width: min-content;
      height: 377px;
    }

    .card--margin {
      margin-right: 32px;
    }

    .card__image {
      margin-bottom: 19px;
      width: 292px;
      height: 204px;
    }

    .card__title {
      font-size: 20px;
      margin: 0 20px;
      line-height: 28px;
      max-width: 231px;
    }

    .card__container {
      padding: 20px;
    }

    .card__icon {
      width: 40px;
      height: 40px;
      margin-right: 12px;
    }

    .card__content-title {
      font-size: 16px;
      line-height: 22px;
      margin-bottom: 2px;
    }

    .card__content-text {
      font-size: 12px;
      line-height: 16px;
    }

    ._1407-products__item {
      width: 10.1vw;
    }

    ._1407-products__link {
      margin-right: 3.13vw;
      margin-bottom: 6vw;
    }

    ._1407-products__link:nth-child(7) {
      margin-right: 0;
    }

    #swiper-button-next-first, #swiper-button-prev-first {
      display: none;
    }

    ._1407-advantages {
      margin-bottom: 80px;
    }
  }

  @media (max-width: 1023px) {
    ._1407-container {
      margin: 0 7.1vw;
    }

    ._1407-prevtext__title {
      max-width: 545px;
    }

    ._1407-prevtext__desc {
      max-width: 545px;
    }

    ._1407-video__image {
      width: inherit;
    }

    ._1407-video {
      flex-direction: column;
    }

    .video__image {
      width: 70.6vw;
      height: inherit;
      border-radius: 8px 8px 0 0;
    }

    ._1407-instructions__container {
      border-radius: 0 0 8px 8px;
    }

    ._1407-instructions__image {
      width: 660px;
      height: 495px;
    }

    ._1407-instructions__content {
      max-width: 70.6vw;
      padding: 16px 6.3vw 6.3vw;
    }

    ._1407-video__user {
      padding: 6.3vw 6.3vw 0;
    }

    .card {
      margin-bottom: 15px;
      height: 307px;
    }

    .card--margin {
      margin-right: 3.2vw;
    }

    .card__image {
      margin-bottom: 1.9vw;
      width: 258px;
      height: 180px;
    }

    .card__title {
      font-size: 15px;
      margin: 0 15px;
      line-height: 21px;
      max-width: 177px;
    }

    .card__container {
      padding: 15px;
    }

    .card__icon {
      width: 31px;
      height: 31px;
      margin-right: 10px;
    }

    .card__content-title {
      font-size: 12px;
      line-height: 17px;
      margin-bottom: 1px;
    }

    .card__content-text {
      font-size: 9px;
      line-height: 12px;
    }

    ._1407-advantages__link {
      position: absolute;
      bottom: -40px;
    }

    ._1407-products__item {
      width: 14.2vw;
    }

    ._1407-products__link {
      margin-right: 3.13vw;
      margin-bottom: 6vw;
    }

    ._1407-products__link:nth-child(7) {
      margin-right: 3.13vw;
    }

    ._1407-products__link:nth-child(5) {
      margin-right: 0;
    }

    .step {
      font-size: 23px;
      top: 24px;
      left: 24px;
    }
  }

  @media (max-width: 767px) {
    ._1407-products__list {
      flex-wrap: nowrap;
    }

    ._1407-container {
      margin: 0 5vw;
    }

    ._1407-prevtext {
      margin: 32px 0;
    }

    ._1407-prevtext__title {
      max-width: 80vw;
      margin-bottom: 16px;
    }

    ._1407-prevtext__desc {
      font-size: 14px;
      line-height: 20px;
      max-width: 80vw;
    }

    ._1407-instructions__image {
      order: 3;
      width: 350px;
      height: 260px;
    }

    ._1407-instructions__content {
      padding: 0;
      max-width: 80vw;
      margin-bottom: 32px;
      order: 2;
    }

    .card {
      margin-bottom: 15px;
      height: 305px;
    }

    .card__span {
      height: 205px;
    }

    .card--margin {
      margin-right: 32px;
    }

    ._1407-video__image {
      width: 80vw;
    }

    .card__image {
      margin-bottom: 15px;
      width: 238px;
      height: 168px;
    }

    .card__title {
      font-size: 16px;
      margin: 0 20px;
      line-height: 22px;
      max-width: 206px;
    }

    .card__container {
      padding: 16px;
    }

    .card__icon {
      width: 40px;
      height: 40px;
      margin-right: 8px;
    }

    .card__content-title {
      font-size: 14px;
      line-height: 18px;
      margin-bottom: 2px;
    }

    .card__content-text {
      font-size: 12px;
      line-height: 16px;
    }

    ._1407-products__item {
      width: 162px;
    }

    ._1407-products__link {
      margin-right: 18px;
      margin-bottom: 0;
    }

    ._1407-products__link:nth-child(7) {
      margin-right: 18px;
    }

    ._1407-products__link:nth-child(5) {
      margin-right: 18px;
    }

    ._1407-instructions__container {
      box-shadow: none;
    }

    .step {
      position: relative;
      background: #464C5C;
      color: #fff;
      order: 1;
      width: 43px;
      height: 43px;
      font-size: 28px;
      margin-bottom: 32px;
      top: auto;
      left: auto;
    }

    ._1407-instructions__text {
      font-size: 19px;
      line-height: 27px;
    }

    ._1407-video__slides {
      margin-bottom: 24px;
    }

    ._1407-video__user {
      padding: 0;
      margin: 32px 0 16px;
    }

    .video__image {
      width: inherit;
      border-radius: 8px;
    }

    ._1407-video {
      align-items: center;
      margin-bottom: 0;
    }
  }

  @media (max-width: 425px) {
    .card {
      margin-bottom: 15px;
      height: 307px;
    }

    .card__span {
      height: 227px;
    }

    .card--margin {
      margin-right: 12px;
    }

    ._1407-products__item {
      width: 38.1vw;
    }

    ._1407-products__link {
      margin-right: 4.13vw;
      margin-bottom: 0;
    }

    ._1407-products__link:nth-child(7) {
      margin-right: 4.13vw;
    }

    ._1407-products__link:nth-child(5) {
      margin-right: 4.13vw;
    }

    .step {
      width: 10vw;
      height: 10vw;
      font-size: 6.5vw;
      margin-bottom: 7.5vw;
    }

    ._1407-instructions__image {
      width: 84.4vw;
      height: 62.5vw;
    }

    ._1407-instructions__content {
      max-width: 84.4vw;
      margin-bottom: 7.5vw;
    }

    ._1407-instructions__text {
      font-size: 4.4vw;
      line-height: 6.3vw;
    }

    ._1407-video__image {
      width: 84.4vw;
    }

    .video__image {
      width: inherit;
      height: 84.5vw;
    }
  }

  .social-share-buttons, ._1407-advantages__arrow {
    display: none;
  }

  a {
    color: #66c05d;
    -webkit-transition: all 0.2s ease;
    transition: all 0.2s ease
  }

  a, a:focus, a:hover {
    text-decoration: none
  }

  a:focus, a:hover {
    color: #4ba842
  }

  a:focus {
    outline: 5px auto -webkit-focus-ring-color;
    outline-offset: -2px
  }

  .container {
    margin-right: auto;
    margin-left: auto;
    padding-left: 10px;
    padding-right: 10px
  }

  @media (min-width: 768px) {
    .container {
      width: 768px
    }
  }

  @media (min-width: 992px) {
    .container {
      width: 972px
    }
  }

  @media (min-width: 1200px) {
    .container {
      width: 1200px
    }
  }

  .container-fluid {
    margin-right: auto;
    margin-left: auto;
    padding-left: 10px;
    padding-right: 10px
  }

  .article-step {
    margin-top: 15px;
  }

  .article-step__block--1 {
    margin-left: 10px;
  }

  .article-step__block--3 {
    margin-left: 10px;
  }

  .article-step__number--circle {
    background-color: #66c05d;
    border-radius: 50%;
    display: inline-block;
    font-size: 23px;
    color: #ffffff;
    text-align: center;
    margin-bottom: 20px;
  }

  .article-step__number--line {
    width: 61px;
    font-size: 16px;
    line-height: 30px;
    color: #000000;
    margin-bottom: 10px;
    border-top: 2px solid #66c05d;
  }

  .article-step__content {
    margin-bottom: 15px;
  }

  .article-step__header {
    font-size: 24px;
    font-weight: bold;
    display: inline;
  }

  @media (min-width: 1200px) {
    .article-step__block--2 {
      margin-left: -80px;
    }

    .article-step__number--circle {
      margin-left: 7px;
    }

    .article-step__number--line {
      text-align: right;
      width: 61px;
    }

    .article-step__content {
      margin-left: 80px;
    }

    .article-step__header {
      margin-left: 33px;
    }
  }
  @media (min-width: 992px) {
    .article-step__number--circle {
      height: 47px;
      width: 47px;
      line-height: 47px;
    }
  }
  @media (max-width: 991px) {
    .article-step__number--circle {
      height: 44px;
      width: 44px;
      line-height: 44px;
    }

    .article-step__number--line {
      width: 44px;
    }

    .article-step__header {
      margin-left: 20px;
    }
  }
  @media (max-width: 767px) {
    .article-step__number--circle {
      height: 41px;
      width: 41px;
      line-height: 41px;
    }

    .article-step__number--line {
      width: 41px;
    }
  }
  @media (max-width: 767px) and (max-width: 767px) {
    .article-step__number--line {
      text-align: left;
    }
  }

  .article-with-image:not(.section) {
    margin-bottom: 40px;
  }

  .article-with-image:not(.section):before,
  .article-with-image:not(.section):after {
    content: " ";
    display: table;
  }

  .article-with-image:not(.section):after {
    clear: both;
  }

  @media (max-width: 480px) {
    .article-with-image:not(.section) {
      margin-bottom: 20px;
    }
  }

  .article-with-image__image {
    max-width: 260px;
    max-height: 260px;
    display: block;
    margin-right: auto;
    margin-left: auto;
    margin-bottom: 6px;
  }

  @media (min-width: 480px) {
    .article-with-image__image {
      float: left;
      margin-right: 20px;
      margin-bottom: 20px;
    }
  }

  .article-with-image__text ul,
  .article-with-image__text ol,
  .article-with-image__text li {
    list-style-position: inside;
  }

  .adaptive-column-size-control {
    display: block;
    position: relative
  }

  .adaptive-column-size-control .column-0, .adaptive-column-size-control .column-1 {
    margin: 0 0 20px;
    padding-top: 0;
    padding-bottom: 0
  }

  .row {
    margin-left: -10px;
    margin-right: -10px
  }

  .col-lg-1, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-10, .col-lg-11, .col-lg-12, .col-md-1, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-10, .col-md-11, .col-md-12, .col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12, .col-xs-1, .col-xs-2, .col-xs-3, .col-xs-4, .col-xs-5, .col-xs-6, .col-xs-7, .col-xs-8, .col-xs-9, .col-xs-10, .col-xs-11, .col-xs-12 {
    position: relative;
    min-height: 1px;
    padding-left: 10px;
    padding-right: 10px
  }

  .col-xs-1, .col-xs-2, .col-xs-3, .col-xs-4, .col-xs-5, .col-xs-6, .col-xs-7, .col-xs-8, .col-xs-9, .col-xs-10, .col-xs-11, .col-xs-12 {
    float: left
  }

  .col-xs-12 {
    width: 100%
  }

  .col-xs-11 {
    width: 91.6667%
  }

  .col-xs-10 {
    width: 83.3333%
  }

  .col-xs-9 {
    width: 75%
  }

  .col-xs-8 {
    width: 66.6667%
  }

  .col-xs-7 {
    width: 58.3333%
  }

  .col-xs-6 {
    width: 50%
  }

  .col-xs-5 {
    width: 41.6667%
  }

  .col-xs-4 {
    width: 33.3333%
  }

  .col-xs-3 {
    width: 25%
  }

  .col-xs-2 {
    width: 16.6667%
  }

  .col-xs-1 {
    width: 8.3333%
  }

  .col-xs-pull-12 {
    right: 100%
  }

  .col-xs-pull-11 {
    right: 91.6667%
  }

  .col-xs-pull-10 {
    right: 83.3333%
  }

  .col-xs-pull-9 {
    right: 75%
  }

  .col-xs-pull-8 {
    right: 66.6667%
  }

  .col-xs-pull-7 {
    right: 58.3333%
  }

  .col-xs-pull-6 {
    right: 50%
  }

  .col-xs-pull-5 {
    right: 41.6667%
  }

  .col-xs-pull-4 {
    right: 33.3333%
  }

  .col-xs-pull-3 {
    right: 25%
  }

  .col-xs-pull-2 {
    right: 16.6667%
  }

  .col-xs-pull-1 {
    right: 8.3333%
  }

  .col-xs-pull-0 {
    right: auto
  }

  .col-xs-push-12 {
    left: 100%
  }

  .col-xs-push-11 {
    left: 91.6667%
  }

  .col-xs-push-10 {
    left: 83.3333%
  }

  .col-xs-push-9 {
    left: 75%
  }

  .col-xs-push-8 {
    left: 66.6667%
  }

  .col-xs-push-7 {
    left: 58.3333%
  }

  .col-xs-push-6 {
    left: 50%
  }

  .col-xs-push-5 {
    left: 41.6667%
  }

  .col-xs-push-4 {
    left: 33.3333%
  }

  .col-xs-push-3 {
    left: 25%
  }

  .col-xs-push-2 {
    left: 16.6667%
  }

  .col-xs-push-1 {
    left: 8.3333%
  }

  .col-xs-push-0 {
    left: auto
  }

  .col-xs-offset-12 {
    margin-left: 100%
  }

  .col-xs-offset-11 {
    margin-left: 91.6667%
  }

  .col-xs-offset-10 {
    margin-left: 83.3333%
  }

  .col-xs-offset-9 {
    margin-left: 75%
  }

  .col-xs-offset-8 {
    margin-left: 66.6667%
  }

  .col-xs-offset-7 {
    margin-left: 58.3333%
  }

  .col-xs-offset-6 {
    margin-left: 50%
  }

  .col-xs-offset-5 {
    margin-left: 41.6667%
  }

  .col-xs-offset-4 {
    margin-left: 33.3333%
  }

  .col-xs-offset-3 {
    margin-left: 25%
  }

  .col-xs-offset-2 {
    margin-left: 16.6667%
  }

  .col-xs-offset-1 {
    margin-left: 8.3333%
  }

  .col-xs-offset-0 {
    margin-left: 0%
  }

  @media (min-width: 768px) {
    .col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12 {
      float: left
    }

    .col-sm-12 {
      width: 100%
    }

    .col-sm-11 {
      width: 91.6667%
    }

    .col-sm-10 {
      width: 83.3333%
    }

    .col-sm-9 {
      width: 75%
    }

    .col-sm-8 {
      width: 66.6667%
    }

    .col-sm-7 {
      width: 58.3333%
    }

    .col-sm-6 {
      width: 50%;
    }

    .col-sm-5 {
      width: 41.6667%
    }

    .col-sm-4 {
      width: 33.3333%
    }

    .col-sm-3 {
      width: 25%
    }

    .col-sm-2 {
      width: 16.6667%
    }

    .col-sm-1 {
      width: 8.3333%
    }

    .col-sm-pull-12 {
      right: 100%
    }

    .col-sm-pull-11 {
      right: 91.6667%
    }

    .col-sm-pull-10 {
      right: 83.3333%
    }

    .col-sm-pull-9 {
      right: 75%
    }

    .col-sm-pull-8 {
      right: 66.6667%
    }

    .col-sm-pull-7 {
      right: 58.3333%
    }

    .col-sm-pull-6 {
      right: 50%
    }

    .col-sm-pull-5 {
      right: 41.6667%
    }

    .col-sm-pull-4 {
      right: 33.3333%
    }

    .col-sm-pull-3 {
      right: 25%
    }

    .col-sm-pull-2 {
      right: 16.6667%
    }

    .col-sm-pull-1 {
      right: 8.3333%
    }

    .col-sm-pull-0 {
      right: auto
    }

    .col-sm-push-12 {
      left: 100%
    }

    .col-sm-push-11 {
      left: 91.6667%
    }

    .col-sm-push-10 {
      left: 83.3333%
    }

    .col-sm-push-9 {
      left: 75%
    }

    .col-sm-push-8 {
      left: 66.6667%
    }

    .col-sm-push-7 {
      left: 58.3333%
    }

    .col-sm-push-6 {
      left: 50%
    }

    .col-sm-push-5 {
      left: 41.6667%
    }

    .col-sm-push-4 {
      left: 33.3333%
    }

    .col-sm-push-3 {
      left: 25%
    }

    .col-sm-push-2 {
      left: 16.6667%
    }

    .col-sm-push-1 {
      left: 8.3333%
    }

    .col-sm-push-0 {
      left: auto
    }

    .col-sm-offset-12 {
      margin-left: 100%
    }

    .col-sm-offset-11 {
      margin-left: 91.6667%
    }

    .col-sm-offset-10 {
      margin-left: 83.3333%
    }

    .col-sm-offset-9 {
      margin-left: 75%
    }

    .col-sm-offset-8 {
      margin-left: 66.6667%
    }

    .col-sm-offset-7 {
      margin-left: 58.3333%
    }

    .col-sm-offset-6 {
      margin-left: 50%
    }

    .col-sm-offset-5 {
      margin-left: 41.6667%
    }

    .col-sm-offset-4 {
      margin-left: 33.3333%
    }

    .col-sm-offset-3 {
      margin-left: 25%
    }

    .col-sm-offset-2 {
      margin-left: 16.6667%
    }

    .col-sm-offset-1 {
      margin-left: 8.3333%
    }

    .col-sm-offset-0 {
      margin-left: 0%
    }
  }

  @media (min-width: 992px) {
    .col-md-1, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-10, .col-md-11, .col-md-12 {
      float: left
    }

    .col-md-12 {
      width: 100%
    }

    .col-md-11 {
      width: 91.6667%
    }

    .col-md-10 {
      width: 83.3333%
    }

    .col-md-9 {
      width: 75%
    }

    .col-md-8 {
      width: 66.6667%
    }

    .col-md-7 {
      width: 58.3333%
    }

    .col-md-6 {
      width: 50%
    }

    .col-md-5 {
      width: 41.6667%
    }

    .col-md-4 {
      width: 33.3333%
    }

    .col-md-3 {
      width: 25%
    }

    .col-md-2 {
      width: 16.6667%
    }

    .col-md-1 {
      width: 8.3333%
    }

    .col-md-pull-12 {
      right: 100%
    }

    .col-md-pull-11 {
      right: 91.6667%
    }

    .col-md-pull-10 {
      right: 83.3333%
    }

    .col-md-pull-9 {
      right: 75%
    }

    .col-md-pull-8 {
      right: 66.6667%
    }

    .col-md-pull-7 {
      right: 58.3333%
    }

    .col-md-pull-6 {
      right: 50%
    }

    .col-md-pull-5 {
      right: 41.6667%
    }

    .col-md-pull-4 {
      right: 33.3333%
    }

    .col-md-pull-3 {
      right: 25%
    }

    .col-md-pull-2 {
      right: 16.6667%
    }

    .col-md-pull-1 {
      right: 8.3333%
    }

    .col-md-pull-0 {
      right: auto
    }

    .col-md-push-12 {
      left: 100%
    }

    .col-md-push-11 {
      left: 91.6667%
    }

    .col-md-push-10 {
      left: 83.3333%
    }

    .col-md-push-9 {
      left: 75%
    }

    .col-md-push-8 {
      left: 66.6667%
    }

    .col-md-push-7 {
      left: 58.3333%
    }

    .col-md-push-6 {
      left: 50%
    }

    .col-md-push-5 {
      left: 41.6667%
    }

    .col-md-push-4 {
      left: 33.3333%
    }

    .col-md-push-3 {
      left: 25%
    }

    .col-md-push-2 {
      left: 16.6667%
    }

    .col-md-push-1 {
      left: 8.3333%
    }

    .col-md-push-0 {
      left: auto
    }

    .col-md-offset-12 {
      margin-left: 100%
    }

    .col-md-offset-11 {
      margin-left: 91.6667%
    }

    .col-md-offset-10 {
      margin-left: 83.3333%
    }

    .col-md-offset-9 {
      margin-left: 75%
    }

    .col-md-offset-8 {
      margin-left: 66.6667%
    }

    .col-md-offset-7 {
      margin-left: 58.3333%
    }

    .col-md-offset-6 {
      margin-left: 50%
    }

    .col-md-offset-5 {
      margin-left: 41.6667%
    }

    .col-md-offset-4 {
      margin-left: 33.3333%
    }

    .col-md-offset-3 {
      margin-left: 25%
    }

    .col-md-offset-2 {
      margin-left: 16.6667%
    }

    .col-md-offset-1 {
      margin-left: 8.3333%
    }

    .col-md-offset-0 {
      margin-left: 0%
    }
  }

  @media (min-width: 1200px) {
    .col-lg-1, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-10, .col-lg-11, .col-lg-12 {
      float: left
    }

    .col-lg-12 {
      width: 100%
    }

    .col-lg-11 {
      width: 91.6667%
    }

    .col-lg-10 {
      width: 83.3333%
    }

    .col-lg-9 {
      width: 75%
    }

    .col-lg-8 {
      width: 66.6667%
    }

    .col-lg-7 {
      width: 58.3333%
    }

    .col-lg-6 {
      width: 50%
    }

    .col-lg-5 {
      width: 41.6667%
    }

    .col-lg-4 {
      width: 33.3333%
    }

    .col-lg-3 {
      width: 25%
    }

    .col-lg-2 {
      width: 16.6667%
    }

    .col-lg-1 {
      width: 8.3333%
    }

    .col-lg-pull-12 {
      right: 100%
    }

    .col-lg-pull-11 {
      right: 91.6667%
    }

    .col-lg-pull-10 {
      right: 83.3333%
    }

    .col-lg-pull-9 {
      right: 75%
    }

    .col-lg-pull-8 {
      right: 66.6667%
    }

    .col-lg-pull-7 {
      right: 58.3333%
    }

    .col-lg-pull-6 {
      right: 50%
    }

    .col-lg-pull-5 {
      right: 41.6667%
    }

    .col-lg-pull-4 {
      right: 33.3333%
    }

    .col-lg-pull-3 {
      right: 25%
    }

    .col-lg-pull-2 {
      right: 16.6667%
    }

    .col-lg-pull-1 {
      right: 8.3333%
    }

    .col-lg-pull-0 {
      right: auto
    }

    .col-lg-push-12 {
      left: 100%
    }

    .col-lg-push-11 {
      left: 91.6667%
    }

    .col-lg-push-10 {
      left: 83.3333%
    }

    .col-lg-push-9 {
      left: 75%
    }

    .col-lg-push-8 {
      left: 66.6667%
    }

    .col-lg-push-7 {
      left: 58.3333%
    }

    .col-lg-push-6 {
      left: 50%
    }

    .col-lg-push-5 {
      left: 41.6667%
    }

    .col-lg-push-4 {
      left: 33.3333%
    }

    .col-lg-push-3 {
      left: 25%
    }

    .col-lg-push-2 {
      left: 16.6667%
    }

    .col-lg-push-1 {
      left: 8.3333%
    }

    .col-lg-push-0 {
      left: auto
    }

    .col-lg-offset-12 {
      margin-left: 100%
    }

    .col-lg-offset-11 {
      margin-left: 91.6667%
    }

    .col-lg-offset-10 {
      margin-left: 83.3333%
    }

    .col-lg-offset-9 {
      margin-left: 75%
    }

    .col-lg-offset-8 {
      margin-left: 66.6667%
    }

    .col-lg-offset-7 {
      margin-left: 58.3333%
    }

    .col-lg-offset-6 {
      margin-left: 50%
    }

    .col-lg-offset-5 {
      margin-left: 41.6667%
    }

    .col-lg-offset-4 {
      margin-left: 33.3333%
    }

    .col-lg-offset-3 {
      margin-left: 25%
    }

    .col-lg-offset-2 {
      margin-left: 16.6667%
    }

    .col-lg-offset-1 {
      margin-left: 8.3333%
    }

    .col-lg-offset-0 {
      margin-left: 0%
    }
  }

  uc-gap {
    display: grid;
    width: 100%;
    grid-template-columns: 100%;
    margin-bottom: 2.1429rem;
    grid-row-gap: 2.1429rem;
  }

  .com-notification {
    background-color: #fffde9;
    border: 1px solid #fff595;
    padding: 22px 30px 24px;
    margin: 30px 0
  }

  @media (max-width: 480px) {
    .com-notification {
      padding: 22px 22px 24px 25px
    }
  }

  .com-notification__deck {
    font-size: 14px;
    font-weight: 400;
    line-height: 1.64;
    color: #5b5b5b
  }

  .com-notification__deck, .com-notification__title {
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal
  }

  .com-notification__title {
    font-size: 16px;
    font-weight: 700;
    line-height: 1.44;
    color: #333;
    margin-bottom: 8px
  }

  .com-notification__icon {
    display: inline-block;
    width: 17px;
    height: 17px;
    background-color: #d8dd32;
    border-radius: 50%;
    margin-right: 11px;
    text-align: center;
    color: #fff;
    line-height: 18px;
    position: relative;
    top: 2px
  }

  .custom-text-block {
    font-size: 14px;
    font-weight: 400;
    font-style: normal;
    font-stretch: normal;
    line-height: 26px;
    letter-spacing: normal;
    text-align: left;
    display: block
  }

  @media (max-width: 767px) {
    .custom-text-block {
      line-height: 21px
    }

    .custom-text-block:first-letter {
      font-size: 71px;
      line-height: 57px;
      letter-spacing: 5px
    }
  }

  @media (max-width: 767px) {
    .custom-text-block--stick {
      font-size: 15px;
      line-height: 22px;
      padding: 5px 5px 5px 20px
    }
  }

  .selectLights-main {
    max-width: 1180px;
    margin: 0 auto;
    padding: 0 15px;
    padding-bottom: 10px;
  }

  .selectLights-sect {
    margin: 47px 0;
  }

  .selectLights-main img {
    max-width: 100%;
    border-radius: 4px;
  }

  .selectLights-sect a {
    color: #66c05d;
    text-decoration: none;
  }

  .selectLights-sect a:hover {
    text-decoration: underline;
  }

  .selectLights-sect p {
    font-size: 16px;
    line-height: 140%;
    letter-spacing: 0.05px;
    margin: 10px 0;
  }

  .selectLights-sect__grey-bg {
    background: #F3F3F5;
    border-radius: 4px;
  }

  .selectLights-sect__for-bath {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin: 0 30px 0 30px;
  }

  .selectLights-sect__for-bath__item {
    width: 31.5%;
    margin-top: 35px;
  }

  .selectLights-sect__for-bath__item p span {
    font-weight: 500;
    display: block;
    margin-bottom: 10px;
  }

  .selectLights-sect__for-bath__item p b {
    font-weight: 500;
  }

  .selectLights-sect p.after-sect__for-bath {
    margin: 25px 30px 0 30px;
    padding-bottom: 15px;
  }

  .selectLights__50-50 {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .selectLights-sect__grey-bg .selectLights__50-50 {
    padding: 33px 38px 20px 38px;
  }

  .selectLights-50-item {
    width: 48%;
  }

  .selectLights-50-item span.descr-img {
    font-size: 14px;
    line-height: 140%;
    letter-spacing: 0.05px;
    color: #000000;
    margin-top: 10px;
    display: block;
  }

  .selectLights-50-item p {
    margin-top: 0;
    margin-bottom: 20px;
  }

  .selectLights-50-item p span {
    font-weight: 500;
  }

  .selectLights-50-item p:last-child {
    margin-bottom: 10px;
  }

  .selectLights-like-h2 {
    font-weight: bold;
    font-size: 28px;
    line-height: 140%;
    color: #333333;
  }

  .selectLights-class-protect {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .selectLights-class-protect__item {
    width: 32%;
  }

  .red-text {
    color: #EB5757;
    font-weight: 500;
  }

  .selectLights-like-h3 {
    font-weight: bold;
    font-size: 18px;
    line-height: 135%;
    color: #333333;
  }

  .selectLights-like-h4 {
    font-size: 16px;
    font-weight: 700;
  }

  .selectLights__50-50.selectLights__50-50-no-marg .selectLights-50-item span {
    font-weight: 500;
    font-size: 14px;
    line-height: 140%;
    letter-spacing: 0.05px;
    color: #000000;
    margin-top: 4px;
    display: block;
  }

  .selectLights-like-h2 p {
    font-weight: 400;
    margin-top: 25px;
  }

  .selectLights_plan {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .selectLights__plan-item {
    width: 31%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 35px;
  }

  .selectLights__plan-img {
    min-width: 127px;
    margin-right: 40px;
  }

  .selectLights__plan-text {
    width: calc(100% - 167px);
  }

  .selectLights__plan-text p {
    font-size: 16px;
    line-height: 150%;
    color: #333333;
  }

  .selectLights-like-h1 {
    font-weight: 500;
    font-size: 38px;
    line-height: 45px;
    color: #333333;
  }

  .selectLights__lvls {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .selectLights__lvls-item {
    width: 48%;
    background: #F3F3F5;
    border-radius: 4px;
    padding: 20px 30px;
  }

  .selectLights__lvls-item span {
    font-size: 14px;
    line-height: 140%;
    letter-spacing: 0.05px;
    color: #464C5C;
    display: block;
    margin-bottom: 15px;
    margin-top: 4px;
  }

  ol, ul {
    padding: 0;
    margin: 0 25px;
  }

  ol li, ul li {
    font-size: 16px;
    line-height: 140%;
    letter-spacing: 0.05px;
    color: #333333;
  }

  .selectLights__lvls-item:first-child p {
    margin-top: 40px;
    margin-bottom: 15px;
  }

  ol li {
    margin-top: 12px;
  }

  .selectLights__lvls-item:not(:nth-child(2)) p {
    margin-bottom: 25px;
  }

  .selectLights__lvls-item p:last-child {
    margin-bottom: 0;
  }

  @media (min-width: 992px) {
    .selectLights__lvls-item:nth-last-child(1), .selectLights__lvls-item:nth-last-child(2) {
      margin-top: 30px;
    }
  }

  @media (max-width: 600px) {
    .selectLights-sect {
      margin: 30px 0;
    }

    .selectLights-sect__for-bath__item {
      width: 100%;
    }

    .selectLights-50-item {
      width: 100%;
    }

    .selectLights-sect__grey-bg .selectLights__50-50 {
      padding: 15px 20px;
    }

    .selectLights-50-item:nth-child(2) {
      margin-top: 25px;
    }

    .selectLights-class-protect__item {
      width: 100%;
    }

    .selectLights__50-50.selectLights__50-50-no-marg .selectLights-50-item:last-child {
      width: 100%;
    }

    .selectLights__plan-item {
      width: 100%;
      margin-bottom: 15px;
    }

    .selectLights__lvls-item {
      width: 100%;
      margin-bottom: 30px;
      padding: 15px 20px;
    }

    .selectLights-sect__for-bath {
      margin: 0 20px 0 20px;
    }

    .selectLights-sect__for-bath__item {
      margin-top: 20px;
    }

    .selectLights-like-h2 {
      font-size: 22px;
    }

    .selectLights-like-h1 {
      font-size: 22px;
    }

    .selectLights__plan-img {
      min-width: 72px;
      width: 72px;
      margin-right: 25px;
    }

    .selectLights__plan-text {
      width: calc(100% - 100px);
    }

    .selectLights-sect p.after-sect__for-bath {
      margin: 15px 20px 0 20px;
    }
  }

  .adaptive-column-size-control {
    display: block;
    position: relative
  }

  .adaptive-column-size-control .column-0, .adaptive-column-size-control .column-1 {
    margin: 0 0 20px;
    padding-top: 0;
    padding-bottom: 0
  }

  .section:after, .section:before {
    content: " ";
    display: table
  }

  .section:after {
    clear: both
  }

  .awg__section {
    max-width: 1180px;
    margin: 47px auto;
    padding: 0 15px;
    font-size: 16px;
    line-height: 140%;
  }

  .awg__section p {
    font-size: 16px;
    line-height: 140%;
    margin-top: 16px;
  }

  .awg__section p.mt-0 {
    margin-top: 0;
  }

  .awg__section p:last-child {
    margin-bottom: 0;
  }

  .awg__section .bold-font {
    font-weight: 500;
  }

  .awg__section a {
    text-decoration-line: underline;
    color: #000;
  }

  .awg__section a:hover {
    text-decoration: none;
  }

  .awg__section__h1 {
    font-weight: 500;
    font-size: 38px;
    line-height: normal;
  }

  .awg__grey {
    background: #F3F3F5;
    border-radius: 4px;
    padding: 20px 30px;
    height: 100%;
  }

  .awg__section__h2 {
    font-size: 24px;
    font-weight: 500;
    line-height: normal;
  }

  /* grid */


  .cust-row [class^=cust-col].mt-0 {
    margin-top: 0;
  }

  .cust-row [class^=cust-col].pl-50 {
    padding-left: 50px;
  }

  ul li {
    margin-bottom: 6px;
  }

  ul {
    margin: 16px 26px;
    padding: 0;
  }

  ul.mt-0 {
    margin-top: 0;
  }

  .awg__type-1 {
    display: flex;
    align-items: center;
  }

  .awg__type-1 img {
    width: 120px;
  }

  .awg__type-1 p {
    margin: 0;
    width: calc(100% - 140px);
    margin-left: 20px;
    text-align: left;
  }

  .red-text {
    font-weight: 500;
    color: #E93838;
    display: block;
  }

  .awg__grey > p:first-child {
    margin-top: 0;
  }

  .awg__type-2 img {
    margin: 0 auto;
    display: block;
  }

  .awg__type-2 p {
    text-align: center;
  }

  .awg__type-2 p:last-child {
    text-align: justify;
  }

  .awg__grey__text img {
    display: block;
  }

  .cust-col-5 {
    overflow: hidden;
  }

  .awg__grey__text {
    height: 100%;
  }

  .awg__grey__text p {
    padding: 15px 14px;
    background: #F3F3F5;
    margin: 0;
    font-size: 14px;
    height: 100%;
  }

  /* /grid */

  .cust-row {
    display: flex;
    flex-wrap: wrap;
    margin-left: -10px;
    margin-right: -10px;
    margin-top: -20px;
  }

  .cust-row [class^=cust-col] {
    padding-left: 10px;
    padding-right: 10px;
    margin: 0;
    margin-top: 20px;
    flex-shrink: 0;
    flex-grow: 0;
    box-sizing: border-box;
  }

  .cust-col-6 {
    flex-basis: 50%;
    max-width: 50%;
  }

  .cust-col-6-1 {
    flex-basis: 45%;
    max-width: 45%;
  }

  .cust-col-6-2 {
    flex-basis: 55%;
    max-width: 55%;
  }

  .cust-col-5 {
    flex-basis: 20%;
    max-width: 20%;
  }

  .cust-col-4 {
    flex-basis: 33.3333%;
    max-width: 33.3333%;
  }

  .cust-col-2 {
    flex-basis: 16.6667%;
    max-width: 16.6667%;
  }

  .cust-col-12 {
    flex-basis: 100%;
    max-width: 100%;
  }

  .hide-me {
    display: none;
  }

  .show-me {
    display: block;
  }

  @media (max-width: 1024px) {
    .cust-col-tablet-6 {
      flex-basis: 50%;
      max-width: 50%;
    }

    .cust-col-tablet-3 {
      flex-basis: 25%;
      max-width: 25%;
    }

    .cust-col-tablet-12 {
      flex-basis: 100%;
      max-width: 100%;
    }

    .cust-col-3 img {
      width: 100%;
    }
  }


  @media (max-width: 768px) {
    .cust-row {
      margin-top: -32px;
      margin-left: -16px;
      margin-right: -16px;
    }

    .cust-row [class^=cust-col] {
      margin-top: 32px;
      padding-left: 16px;
      padding-right: 16px;
    }

    .cust-col-v-tablet-6 {
      flex-basis: 50%;
      max-width: 50%;
    }

    .cust-col-v-tablet-12 {
      flex-basis: 100%;
      max-width: 100%;
    }

    .cust-col-v-tablet-3 {
      flex-basis: 25%;
      max-width: 25%;
    }

    .show-me--v-tablet {
      display: block;
    }

    .hide-me--v-tablet {
      display: none;
    }

    .awg__section {
      margin: 33px 0;
    }

    .awg__section__h1, .awg__section__h2 {
      font-size: 22px;
    }

  }

  @media (max-width: 480px) {
    .cust-row {
      margin-top: -12px;
      margin-left: -6px;
      margin-right: -6px;
    }

    .cust-row [class^=cust-col] {
      margin-top: 12px;
      padding-left: 6px;
      padding-right: 6px;
    }

    .cust-col-mobile-12 {
      flex-basis: 100%;
      max-width: 100%;
    }

    .cust-col-mobile-6 {
      flex-basis: 50%;
      max-width: 50%;
    }

    .awg__type-1 {
      margin-bottom: 20px;
    }

    .awg__type-1 img {
      width: 80px;
    }

    .awg__type-1 p {
      margin: 0;
      width: calc(100% - 100px);
      margin-left: 20px;
    }

    .awg__grey {
      padding: 15px 20px;
    }

  }

  .grinder__section {
    max-width: 1180px;
    margin: 47px auto;
    padding: 0 15px;
  }

  .grinder__section p {
    font-size: 16px;
    line-height: 140%;
    margin-top: 16px;
  }

  .grinder__section p:last-child {
    margin-bottom: 0;
  }

  .grinder__section p span {
    font-weight: 500;
  }

  .grinder__section a {
    text-decoration-line: underline;
    color: #333333;
  }

  .grinder__section a:hover {
    text-decoration: none;
  }

  .cust-col-6 p {
    margin-top: 0;
  }

  /* grid */

  .cust-row {
    display: flex;
    flex-wrap: wrap;
    margin-left: -10px;
    margin-right: -10px;
    margin-top: -20px;
  }

  .cust-row [class^=cust-col] {
    padding-left: 10px;
    padding-right: 10px;
    margin: 0;
    margin-top: 20px;
    flex-shrink: 0;
    flex-grow: 0;
    box-sizing: border-box;
  }

  .cust-col-6 {
    flex-basis: 50%;
    max-width: 50%;
  }

  .cust-col-3 {
    flex-basis: 25%;
    max-width: 25%;
  }

  .cust-col-4 {
    flex-basis: 33.3333%;
    max-width: 33.3333%;
  }

  .cust-col-2 {
    flex-basis: 16.6667%;
    max-width: 16.6667%;
  }

  .cust-col-12 {
    flex-basis: 100%;
    max-width: 100%;
  }

  .hide-me {
    display: none;
  }

  .cust-row [class^=cust-col].mt-0 {
    margin-top: 0;
  }

  p.mb-25, ul.mb-25 {
    margin-top: 0;
    margin-bottom: 25px;
  }

  .cust-row [class^=cust-col].pl-50 {
    padding-left: 50px;
  }

  ul li {
    margin-bottom: 15px;
    font-size: 16px;
    line-height: 140%;
  }

  .grinder_h1 {
    font-weight: 500;
    font-size: 38px;
  }

  .grinder__grey-bg {
    background: #F3F3F5;
    border-radius: 4px;
    padding: 25px 35px;
    height: 100%;
  }

  .grinder_h2 {
    font-weight: 500;
    font-size: 26px;
    margin-bottom: 15px;
  }

  .grinder_h4 {
    margin: 20px 0 15px 0;
    font-weight: 500;
    font-size: 16px;
  }

  .list-pluses p {
    background: url('https://cdn.lemanapro.ru/lmru/image/upload/v1645595851/fudzi/elbrus/advice-new/instrumenty/kak-vybrat-bolgarku/004-1.svg/004-1.svg');
    background-repeat: no-repeat;
    background-position: left center;
    padding-left: 33px;
    margin: 15px 0;
  }

  .list-minuses p {
    background: url('https://cdn.lemanapro.ru/lmru/image/upload/v1645595851/fudzi/elbrus/advice-new/instrumenty/kak-vybrat-bolgarku/005-1.svg/005-1.svg');
    background-repeat: no-repeat;
    background-position: left center;
    padding-left: 33px;
    margin: 15px 0;
  }

  .red-text {
    color: #E93838;
  }

  /* /grid */

  .cust-row {
    display: flex;
    flex-wrap: wrap;
    margin-left: -10px;
    margin-right: -10px;
    margin-top: -20px;
  }

  .cust-row [class^=cust-col] {
    padding-left: 10px;
    padding-right: 10px;
    margin: 0;
    margin-top: 20px;
    flex-shrink: 0;
    flex-grow: 0;
    box-sizing: border-box;
  }

  .cust-col-6 {
    flex-basis: 50%;
    max-width: 50%;
  }

  .cust-col-4 {
    flex-basis: 33.3333%;
    max-width: 33.3333%;
  }

  .cust-col-2 {
    flex-basis: 16.6667%;
    max-width: 16.6667%;
  }

  .cust-col-12 {
    flex-basis: 100%;
    max-width: 100%;
  }

  .hide-me {
    display: none;
  }

  .show-me {
    display: block;
  }

  @media (max-width: 1024px) {
    .cust-col-tablet-6 {
      flex-basis: 50%;
      max-width: 50%;
    }

    .cust-col-tablet-3 {
      flex-basis: 25%;
      max-width: 25%;
    }

    .cust-col-tablet-12 {
      flex-basis: 100%;
      max-width: 100%;
    }

    .cust-col-3 img {
      width: 100%;
    }
  }


  @media (max-width: 768px) {
    .cust-row {
      margin-top: -32px;
      margin-left: -16px;
      margin-right: -16px;
    }

    .cust-row [class^=cust-col] {
      margin-top: 32px;
      padding-left: 16px;
      padding-right: 16px;
    }

    .cust-col-v-tablet-6 {
      flex-basis: 50%;
      max-width: 50%;
    }

    .cust-col-v-tablet-12 {
      flex-basis: 100%;
      max-width: 100%;
    }

    .cust-col-v-tablet-3 {
      flex-basis: 25%;
      max-width: 25%;
    }

    .show-me--v-tablet {
      display: block;
    }

    .hide-me--v-tablet {
      display: none;
    }

    .grinder__section {
      margin: 33px 0;
    }

    .grinder_h1 {
      font-size: 22px;
    }

    .grinder_h2 {
      font-size: 20px;
    }

    .grinder__grey-bg {
      padding: 15px 20px;
      height: 100%;
    }
  }

  @media (max-width: 480px) {
    .cust-row {
      margin-top: -12px;
      margin-left: -6px;
      margin-right: -6px;
    }

    .cust-row [class^=cust-col] {
      margin-top: 12px;
      padding-left: 6px;
      padding-right: 6px;
    }

    .cust-col-mobile-12 {
      flex-basis: 100%;
      max-width: 100%;
    }

  }

  .home-workshop__section {
    max-width: 1180px;
    margin: 43px auto;
    padding: 0 15px;
    font-size: 16px;
    line-height: 140%;
  }

  .home-workshop__section p {
    font-size: 16px;
    line-height: 140%;
    margin-top: 16px;
  }

  p.text-jst {
    text-align: justify;
  }

  .home-workshop__section p:last-child {
    margin-bottom: 0;
  }

  .home-workshop__section .bold-font {
    font-weight: 500;
  }

  .home-workshop__section a {
    text-decoration-line: underline;
    color: #000;
  }

  .home-workshop_section a:hover {
    text-decoration: none;
  }

  .grey-p {
    background: #F3F3F5;
    border-radius: 4px;
    padding: 20px 30px;
  }

  ul {
    padding: 0 25px;
  }

  /* grid */

  .cust-row {
    display: flex;
    flex-wrap: wrap;
    margin-left: -10px;
    margin-right: -10px;
    margin-top: -20px;
  }

  .cust-row [class^=cust-col] {
    padding-left: 10px;
    padding-right: 10px;
    margin: 0;
    margin-top: 20px;
    flex-shrink: 0;
    flex-grow: 0;
    box-sizing: border-box;
  }

  .cust-col-6 {
    flex-basis: 50%;
    max-width: 50%;
  }

  .cust-col-3 {
    flex-basis: 25%;
    max-width: 25%;
  }

  .cust-col-4 {
    flex-basis: 33.3333%;
    max-width: 33.3333%;
  }

  .cust-col-2 {
    flex-basis: 16.6667%;
    max-width: 16.6667%;
  }

  .cust-col-12 {
    flex-basis: 100%;
    max-width: 100%;
  }

  .hide-me {
    display: none;
  }

  .cust-row [class^=cust-col].mt-0 {
    margin-top: 0;
  }

  p.mb-25, ul.mb-25 {
    margin-top: 0;
    margin-bottom: 25px;
  }

  .cust-row [class^=cust-col].pl-50 {
    padding-left: 50px;
  }

  ul li {
    margin-bottom: 6px;
  }

  .home-workshop__flex-type-1 {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .home-workshop__flex__item {
    width: 20%;
    text-align: center;
  }

  .home-workshop__h1 {
    font-weight: 500;
    font-size: 38px;
    line-height: normal;
  }

  .home-workshop__h2 {
    font-weight: 500;
    font-size: 24px;
    line-height: normal;
  }

  .cust-row.mt-10 > div {
    margin-top: 10px;
  }

  .cust-col-6 p:first-child {
    margin-top: 0;
  }

  .home-workshop__grey {
    padding: 25px 35px;
    background: #F3F3F5;
    border-radius: 4px;
    height: 100%;
  }

  .home-workshop__what-item {
    position: relative;
  }

  .home-workshop__what-span {
    position: absolute;
    color: #fff;
    bottom: 12px;
    left: 15px;
    right: 10px;
  }

  /* /grid */

  .cust-row {
    display: flex;
    flex-wrap: wrap;
    margin-left: -10px;
    margin-right: -10px;
    margin-top: -20px;
  }

  .cust-row [class^=cust-col] {
    padding-left: 10px;
    padding-right: 10px;
    margin: 0;
    margin-top: 20px;
    flex-shrink: 0;
    flex-grow: 0;
    box-sizing: border-box;
  }

  .cust-col-6 {
    flex-basis: 50%;
    max-width: 50%;
  }

  .cust-col-4 {
    flex-basis: 33.3333%;
    max-width: 33.3333%;
  }

  .cust-col-2 {
    flex-basis: 16.6667%;
    max-width: 16.6667%;
  }

  .cust-col-12 {
    flex-basis: 100%;
    max-width: 100%;
  }

  .hide-me {
    display: none;
  }

  .show-me {
    display: block;
  }

  @media (max-width: 1024px) {
    .cust-col-tablet-6 {
      flex-basis: 50%;
      max-width: 50%;
    }

    .cust-col-tablet-3 {
      flex-basis: 25%;
      max-width: 25%;
    }

    .cust-col-tablet-12 {
      flex-basis: 100%;
      max-width: 100%;
    }

    .cust-col-3 img {
      width: 100%;
    }
  }


  @media (max-width: 768px) {
    .cust-row {
      margin-top: -32px;
      margin-left: -16px;
      margin-right: -16px;
    }

    .cust-row [class^=cust-col] {
      margin-top: 32px;
      padding-left: 16px;
      padding-right: 16px;
    }

    .cust-col-v-tablet-6 {
      flex-basis: 50%;
      max-width: 50%;
    }

    .cust-col-v-tablet-12 {
      flex-basis: 100%;
      max-width: 100%;
    }

    .cust-col-v-tablet-3 {
      flex-basis: 25%;
      max-width: 25%;
    }

    .show-me--v-tablet {
      display: block;
    }

    .hide-me--v-tablet {
      display: none;
    }

    .home-workshop__section {
      margin: 33px 0;
    }

    .home-workshop__h1, .home-workshop__h2 {
      font-size: 22px;
    }

    .cust-col-6 img {
      width: 100%;
    }

    .home-workshop__grey {
      padding: 15px 20px;
    }
  }

  @media (max-width: 480px) {
    .cust-row {
      margin-top: -12px;
      margin-left: -6px;
      margin-right: -6px;
    }

    .cust-row [class^=cust-col] {
      margin-top: 12px;
      padding-left: 6px;
      padding-right: 6px;
    }

    .cust-col-mobile-12 {
      flex-basis: 100%;
      max-width: 100%;
    }

    .home-workshop__flex__item {
      width: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 20px;
    }

    .home-workshop__flex__item img {
      width: 80px;
    }

    .home-workshop__flex__item p {
      width: calc(100% - 100px);
      margin: 0;
      text-align: left;
      margin-left: 20px;
    }

    .mt-mobile-20 {
      margin-top: 20px !important;
    }

  }

  .nivelir__section {
    max-width: 1180px;
    margin: 47px auto;
    padding: 0 15px;
    font-size: 16px;
    line-height: 140%;
  }

  .nivelir__section p {
    font-size: 16px;
    line-height: 140%;
    margin-top: 16px;
  }

  .nivelir__section p:last-child {
    margin-bottom: 0;
  }

  .nivelir__section .bold-font {
    font-weight: 500;
  }

  .nivelir__sectiona {
    text-decoration-line: underline;
    color: #000;
  }

  .nivelir__section a:hover {
    text-decoration: none;
  }

  .nivelir__grey {
    background: #F3F3F5;
    border-radius: 4px;
    padding: 25px 35px;
    height: 100%;
  }

  .nivelir__h2 {
    font-weight: 500;
    font-size: 20px;
    line-height: 140%;
  }

  @media (min-width: 768px) {
    .cust-col-6 p:first-child {
      margin-top: 0;
    }
  }

  /* grid */

  .cust-row {
    display: flex;
    flex-wrap: wrap;
    margin-left: -10px;
    margin-right: -10px;
    margin-top: -20px;
  }

  .cust-row [class^=cust-col] {
    padding-left: 10px;
    padding-right: 10px;
    margin: 0;
    margin-top: 20px;
    flex-shrink: 0;
    flex-grow: 0;
    box-sizing: border-box;
  }

  .cust-col-6 {
    flex-basis: 50%;
    max-width: 50%;
  }

  .cust-col-3 {
    flex-basis: 25%;
    max-width: 25%;
  }

  .cust-col-4 {
    flex-basis: 33.3333%;
    max-width: 33.3333%;
  }

  .cust-col-2 {
    flex-basis: 16.6667%;
    max-width: 16.6667%;
  }

  .cust-col-12 {
    flex-basis: 100%;
    max-width: 100%;
  }

  .hide-me {
    display: none;
  }

  .cust-row [class^=cust-col].mt-0 {
    margin-top: 0;
  }

  p.mb-25, ul.mb-25 {
    margin-top: 0;
    margin-bottom: 25px;
  }

  /* /grid */

  .cust-row {
    display: flex;
    flex-wrap: wrap;
    margin-left: -10px;
    margin-right: -10px;
    margin-top: -20px;
  }

  .cust-row [class^=cust-col] {
    padding-left: 10px;
    padding-right: 10px;
    margin: 0;
    margin-top: 20px;
    flex-shrink: 0;
    flex-grow: 0;
    box-sizing: border-box;
  }

  .cust-col-6 {
    flex-basis: 50%;
    max-width: 50%;
  }

  .cust-col-4 {
    flex-basis: 33.3333%;
    max-width: 33.3333%;
  }

  .cust-col-2 {
    flex-basis: 16.6667%;
    max-width: 16.6667%;
  }

  .cust-col-12 {
    flex-basis: 100%;
    max-width: 100%;
  }

  .hide-me {
    display: none;
  }

  .show-me {
    display: block;
  }

  @media (max-width: 1024px) {
    .cust-col-tablet-6 {
      flex-basis: 50%;
      max-width: 50%;
    }

    .cust-col-tablet-3 {
      flex-basis: 25%;
      max-width: 25%;
    }

    .cust-col-tablet-12 {
      flex-basis: 100%;
      max-width: 100%;
    }

    .cust-col-3 img {
      width: 100%;
    }
  }


  @media (max-width: 768px) {
    .cust-row {
      margin-top: -32px;
      margin-left: -16px;
      margin-right: -16px;
    }

    .cust-row [class^=cust-col] {
      margin-top: 32px;
      padding-left: 16px;
      padding-right: 16px;
    }

    .cust-col-v-tablet-6 {
      flex-basis: 50%;
      max-width: 50%;
    }

    .cust-col-v-tablet-12 {
      flex-basis: 100%;
      max-width: 100%;
    }

    .cust-col-v-tablet-3 {
      flex-basis: 25%;
      max-width: 25%;
    }

    .show-me--v-tablet {
      display: block;
    }

    .hide-me--v-tablet {
      display: none;
    }

    .street-light__section {
      margin: 33px 0;
    }

  }

  @media (max-width: 480px) {
    .cust-row {
      margin-top: -12px;
      margin-left: -6px;
      margin-right: -6px;
    }

    .cust-row [class^=cust-col] {
      margin-top: 12px;
      padding-left: 6px;
      padding-right: 6px;
    }

    .cust-col-mobile-12 {
      flex-basis: 100%;
      max-width: 100%;
    }

    .nivelir__grey {
      padding: 15px 20px;
    }
  }

  .electric-saws__section {
    max-width: 1180px;
    margin: 47px auto;
    padding: 0 15px;
  }

  .electric-saws__section p {
    font-size: 16px;
    line-height: 140%;
    margin-top: 16px;
  }

  .electric-saws__section p:last-child {
    margin-bottom: 0;
  }

  .electric-saws__section .font-bold {
    font-weight: 500;
  }

  .electric-saws__section a {
    text-decoration-line: underline;
    color: #333333;
  }

  .electric-saws__section a:hover {
    text-decoration: none;
  }

  .electric-saws__section .electric-saws__item {
    height: 186px;
    width: 100%;
    display: flex;
    align-items: flex-end;
    text-decoration-line: none;
    transition: all .2s;
  }

  .electric-saws__section a.electric-saws__item:hover {
    opacity: 0.85;
  }

  .electric-saws__item span {
    color: #fff;
    text-decoration-line: none;
    padding: 10px 10px;
    margin: 0;
    letter-spacing: 0.03em;
    font-weight: 500;
  }

  .electric-saws__item-1 {
    background: url('https://cdn.lemanapro.ru/lmru/image/upload/v1587043268/fudzi/elbrus/advice-new/instrumenty/vybiraem-elektropily-i-raspilovochnye-stanki-dlya-raboty-po-derevu/002.png/002.png');
    background-repeat: no-repeat;
    background-size: cover;
  }

  .electric-saws__item-2 {
    background: url('https://cdn.lemanapro.ru/lmru/image/upload/v1587043269/fudzi/elbrus/advice-new/instrumenty/vybiraem-elektropily-i-raspilovochnye-stanki-dlya-raboty-po-derevu/003.png/003.png');
    background-repeat: no-repeat;
    background-size: cover;
  }

  .electric-saws__item-3 {
    background: url('https://cdn.lemanapro.ru/lmru/image/upload/v1587043269/fudzi/elbrus/advice-new/instrumenty/vybiraem-elektropily-i-raspilovochnye-stanki-dlya-raboty-po-derevu/004.png/004.png');
    background-repeat: no-repeat;
    background-size: cover;
  }

  .electric-saws__item-4 {
    background: url('https://cdn.lemanapro.ru/lmru/image/upload/v1587043269/fudzi/elbrus/advice-new/instrumenty/vybiraem-elektropily-i-raspilovochnye-stanki-dlya-raboty-po-derevu/005.png/005.png');
    background-repeat: no-repeat;
    background-size: cover;
  }

  .cust-row.mt-16 {
    margin-top: 16px;
  }

  .electric-saws__h1 {
    font-weight: 500;
    font-size: 38px;
    line-height: normal;
  }

  .electric-saws__flex-5 {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .electric-saws__flex-5__item {
    width: 180px;
    text-align: center;
  }

  .electric-saws__h2 {
    font-weight: 500;
    font-size: 28px;
    line-height: normal;
  }

  ul {
    padding: 0 27px;
    margin-top: 8px;
  }

  .electric-saws__grey {
    background: #F3F3F5;
    border-radius: 4px;
    padding: 25px 35px;
    height: 100%;
  }

  .cust-col-6 p {
    margin-top: 0;
    margin-bottom: 24px;
  }

  .red-text {
    color: #E93838;
    font-weight: 500;
  }

  /* grid */

  .cust-row {
    display: flex;
    flex-wrap: wrap;
    margin-left: -10px;
    margin-right: -10px;
    margin-top: -20px;
  }

  .cust-row [class^=cust-col] {
    padding-left: 10px;
    padding-right: 10px;
    margin: 0;
    margin-top: 20px;
    flex-shrink: 0;
    flex-grow: 0;
    box-sizing: border-box;
  }

  .cust-col-6 {
    flex-basis: 50%;
    max-width: 50%;
  }

  .cust-col-3 {
    flex-basis: 25%;
    max-width: 25%;
  }

  .cust-col-4 {
    flex-basis: 33.3333%;
    max-width: 33.3333%;
  }

  .cust-col-2 {
    flex-basis: 16.6667%;
    max-width: 16.6667%;
  }

  .cust-col-12 {
    flex-basis: 100%;
    max-width: 100%;
  }

  .hide-me {
    display: none;
  }

  .cust-row [class^=cust-col].mt-0 {
    margin-top: 0;
  }

  p.mb-25, ul.mb-25 {
    margin-top: 0;
    margin-bottom: 25px;
  }

  .cust-row [class^=cust-col].pl-50 {
    padding-left: 50px;
  }

  ul li, ol li {
    margin-bottom: 6px;
    line-height: 140%;
  }

  ol {
    margin: 0;
    padding: 10px 25px;
  }

  .no-margin-ul {
    margin-top: 0;
  }

  .no-margin-ul li {
    margin-bottom: 0;
  }

  .electric-saws__flex-type-2 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .electric-saws__flex-type-2__item {
    width: 25%;
    display: flex;
    align-items: center;
  }

  .electric-saws__flex-type-2__item img {
    width: 100px;
    margin-right: 15px;
  }

  .electric-saws__flex-type-2__item p {
    margin: 0;
    font-size: 14px;
    width: calc(100% - 115px);
  }

  .electric-saws__section a.absolute-link {
    position: relative;
    bottom: 12px;
    width: 100%;
    text-align: center;
    font-size: 14px;
    text-decoration-line: underline;
    color: #459F3C;
    position: absolute;
    left: 0;
  }

  .electric-saws__section a.absolute-link:hover {
    text-decoration: none;
  }

  /* /grid */

  .cust-row {
    display: flex;
    flex-wrap: wrap;
    margin-left: -10px;
    margin-right: -10px;
    margin-top: -20px;
  }

  .cust-row [class^=cust-col] {
    padding-left: 10px;
    padding-right: 10px;
    margin: 0;
    margin-top: 20px;
    flex-shrink: 0;
    flex-grow: 0;
    box-sizing: border-box;
  }

  .cust-col-6 {
    flex-basis: 50%;
    max-width: 50%;
    position: relative;
  }

  .cust-col-4 {
    flex-basis: 33.3333%;
    max-width: 33.3333%;
  }

  .cust-col-2 {
    flex-basis: 16.6667%;
    max-width: 16.6667%;
  }

  .cust-col-12 {
    flex-basis: 100%;
    max-width: 100%;
  }

  .hide-me {
    display: none;
  }

  .show-me {
    display: block;
  }

  @media (max-width: 1024px) {
    .cust-col-tablet-6 {
      flex-basis: 50%;
      max-width: 50%;
    }

    .cust-col-tablet-3 {
      flex-basis: 25%;
      max-width: 25%;
    }

    .cust-col-tablet-12 {
      flex-basis: 100%;
      max-width: 100%;
    }

    .cust-col-3 img {
      width: 100%;
    }

    .electric-saws__flex-type-2__item {
      width: 48%;
      margin-bottom: 20px;
    }
  }


  @media (max-width: 768px) {
    .cust-row {
      margin-top: -32px;
      margin-left: -16px;
      margin-right: -16px;
    }

    .cust-row [class^=cust-col] {
      margin-top: 32px;
      padding-left: 16px;
      padding-right: 16px;
    }

    .cust-col-v-tablet-6 {
      flex-basis: 50%;
      max-width: 50%;
    }

    .cust-col-v-tablet-12 {
      flex-basis: 100%;
      max-width: 100%;
    }

    .cust-col-v-tablet-3 {
      flex-basis: 25%;
      max-width: 25%;
    }

    .show-me--v-tablet {
      display: block;
    }

    .hide-me--v-tablet {
      display: none;
    }

    .street-light__section {
      margin: 33px 0;
    }

    .electric-saws__h1, .electric-saws__h2 {
      font-size: 22px;
    }

    .electric-saws__section {
      margin: 33px 0;
    }

    .electric-saws__grey {
      padding: 15px 20px;
    }

    .electric-saws__section a.absolute-link {
      background: #fff;
      display: block;
      position: relative;
      padding: 0 15px 15px 15px;
    }

  }

  @media (max-width: 480px) {
    .cust-row {
      margin-top: -12px;
      margin-left: -6px;
      margin-right: -6px;
    }

    .cust-row [class^=cust-col] {
      margin-top: 12px;
      padding-left: 6px;
      padding-right: 6px;
    }

    .cust-col-mobile-12 {
      flex-basis: 100%;
      max-width: 100%;
    }

    .electric-saws__flex-5__item {
      width: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 15px;
    }

    .electric-saws__flex-5__item img, .electric-saws__flex-type-2__item img {
      width: 72px;
      margin-right: 20px;
    }

    .electric-saws__section p:last-child {
      width: calc(100% - 92px);
      text-align: left;
      margin: 0;
    }

    .electric-saws__flex-type-2__item {
      width: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 15px;
    }

    .electric-saws__section p:last-child {
      width: 100%;
    }

    .cust-col-4 img {
      margin-bottom: 16px;
    }
  }

  .svark__section {
    max-width: 1180px;
    margin: 47px auto;
    padding: 0 15px;
  }

  .svark__section p {
    font-size: 16px;
    line-height: 140%;
    margin-top: 16px;
  }

  .svark__section p:last-child {
    margin-bottom: 0;
  }

  .svark__section .bold-font {
    font-weight: 500;
  }

  .svark__section a {
    text-decoration-line: underline;
    color: #000;
  }

  .svark__section a:hover {
    text-decoration: none;
  }

  .svark_h1 {
    font-weight: 500;
    font-size: 38px;
  }

  .svark__flex-type-1 {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .svark__flex-type-1 img {
    width: 43%;
  }

  .svark__flex__text {
    width: 53%;
  }

  .svark__flex__text p {
    margin-top: 0;
  }

  .svark__grey-block {
    background: #F3F3F5;
    border-radius: 4px;
    padding: 25px 35px;
    height: 100%;
  }

  .alert {
    color: #EB5757;
    font-weight: 500;
    padding: 0;
  }

  /* grid */

  .cust-row {
    display: flex;
    flex-wrap: wrap;
    margin-left: -10px;
    margin-right: -10px;
    margin-top: -20px;
  }

  .cust-row [class^=cust-col] {
    padding-left: 10px;
    padding-right: 10px;
    margin: 0;
    margin-top: 20px;
    flex-shrink: 0;
    flex-grow: 0;
    box-sizing: border-box;
  }

  .cust-col-6 {
    flex-basis: 50%;
    max-width: 50%;
  }

  .cust-col-3 {
    flex-basis: 25%;
    max-width: 25%;
  }

  .cust-col-4 {
    flex-basis: 33.3333%;
    max-width: 33.3333%;
  }

  .cust-col-2 {
    flex-basis: 16.6667%;
    max-width: 16.6667%;
  }

  .cust-col-12 {
    flex-basis: 100%;
    max-width: 100%;
  }

  .hide-me {
    display: none;
  }

  .cust-row [class^=cust-col].mt-0 {
    margin-top: 0;
  }

  p.mb-25, ul.mb-25 {
    margin-top: 0;
    margin-bottom: 25px;
  }

  .cust-row [class^=cust-col].pl-50 {
    padding-left: 50px;
  }

  ul li {
    margin-bottom: 6px;
  }

  /* /grid */

  .cust-row {
    display: flex;
    flex-wrap: wrap;
    margin-left: -10px;
    margin-right: -10px;
    margin-top: -20px;
  }

  .cust-row [class^=cust-col] {
    padding-left: 10px;
    padding-right: 10px;
    margin: 0;
    margin-top: 20px;
    flex-shrink: 0;
    flex-grow: 0;
    box-sizing: border-box;
  }

  .cust-col-6 {
    flex-basis: 50%;
    max-width: 50%;
  }

  .cust-col-4 {
    flex-basis: 33.3333%;
    max-width: 33.3333%;
  }

  .cust-col-2 {
    flex-basis: 16.6667%;
    max-width: 16.6667%;
  }

  .cust-col-12 {
    flex-basis: 100%;
    max-width: 100%;
  }

  .hide-me {
    display: none;
  }

  .show-me {
    display: block;
  }

  @media (max-width: 1024px) {
    .cust-col-tablet-6 {
      flex-basis: 50%;
      max-width: 50%;
    }

    .cust-col-tablet-3 {
      flex-basis: 25%;
      max-width: 25%;
    }

    .cust-col-tablet-12 {
      flex-basis: 100%;
      max-width: 100%;
    }

    .cust-col-3 img {
      width: 100%;
    }
  }


  @media (max-width: 768px) {
    .cust-row {
      margin-top: -32px;
      margin-left: -16px;
      margin-right: -16px;
    }

    .cust-row [class^=cust-col] {
      margin-top: 32px;
      padding-left: 16px;
      padding-right: 16px;
    }

    .cust-col-v-tablet-6 {
      flex-basis: 50%;
      max-width: 50%;
    }

    .cust-col-v-tablet-12 {
      flex-basis: 100%;
      max-width: 100%;
    }

    .cust-col-v-tablet-3 {
      flex-basis: 25%;
      max-width: 25%;
    }

    .show-me--v-tablet {
      display: block;
    }

    .hide-me--v-tablet {
      display: none;
    }

    .svark__section {
      margin: 33px 0;
    }

    .svark__grey-block {
      padding: 15px 20px;
      height: 100%;
    }

    .svark_h1 {
      font-size: 22px;
    }

  }

  @media (max-width: 480px) {
    .cust-row {
      margin-top: -12px;
      margin-left: -6px;
      margin-right: -6px;
    }

    .cust-row [class^=cust-col] {
      margin-top: 12px;
      padding-left: 6px;
      padding-right: 6px;
    }

    .cust-col-mobile-12 {
      flex-basis: 100%;
      max-width: 100%;
    }

    .svark__flex-type-1 img {
      width: 100%;
    }

    .svark__flex__text {
      width: 100%;
      margin-top: 20px;
    }
  }

  .awg__heal__title {
    font-weight: 500;
    margin-bottom: 36px;
  }

  .awg__heal__list {
    display: flex;
    flex-wrap: wrap;
  }

  .awg__heal__item {
    margin-right: 55px;
    text-align: center;
  }

  .awg__heal__item img {
    display: block;
    margin: 0 auto;
  }

  .awg__heal__item:last-child {
    margin-right: 0;
  }

  .awg__heal__item p {
    font-weight: 500;
    font-size: 13px;
    margin-top: 16px;
    margin-bottom: 0;
  }

  .awg__heal__list__small-1 .awg__heal__item {
    margin-right: 18px;
  }

  .awg__heal__list__small-1 .awg__heal__item img {
    height: 162px;
  }

  .awg__heal__list__small-1 .awg__heal__item:last-child {
    margin-right: 0;
  }

  .awg__heal__item img {
    height: 180px;
  }

  .awg__vegs-list {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .awg__vegs-item {
    display: flex;
    align-items: center;
  }

  .awg__vegs-item p {
    margin: 0;
    margin-left: 17px;
  }

  .awg__health-item {
    max-width: 170px;
    text-align: center;
  }

  .awg__health-item p {
    font-weight: 500;
    font-size: 13px;
  }

  .awg__health-item img {
    display: block;
    margin: 0 auto;
  }

  .awg__health-list {
    display: flex;
    justify-content: space-between;
  }

  .awg__health-title {
    margin-bottom: 30px;
    white-space: nowrap;
  }

  .awg__health__content {
    display: flex;
    justify-content: space-between;
  }

  .awg__health-1 .awg__health .awg__health-item {
    width: 150px;
  }

  .awg__health-1 .awg__health:first-child {
    width: 83%;
  }

  .awg__health-1 .awg__health:last-child {
    width: 17%;
  }

  .awg__health-1 .awg__health:last-child .awg__health-list {
    display: flex;
    justify-content: flex-end;
  }

  .awg__health-2 .awg__health:first-child {
    width: 43%;
  }

  .awg__health-2 .awg__health:last-child {
    width: 55%;
  }

  .awg__health-3 .awg__health:first-child {
    width: 70%;
  }

  .awg__health-3 .awg__health:last-child {
    width: 17%;
  }

  .awg__health-3 .awg__health:last-child .awg__health-list {
    display: flex;
    justify-content: center;
  }

  .awg__type-2 {
    display: flex;
    align-items: center;
  }

  .awg__type-2 img {
    width: 110px;
  }

  .awg__type-2 p {
    margin: 0;
    margin-left: 20px;
    width: calc(100% - 130px);
    font-size: 14px;
  }

  /* grid */


  .cust-row [class^=cust-col].mt-0 {
    margin-top: 0;
  }

  .cust-row [class^=cust-col].pl-50 {
    padding-left: 50px;
  }

  ul li {
    margin-bottom: 6px;
  }

  /* /grid */

  .cust-row {
    display: flex;
    flex-wrap: wrap;
    margin-left: -10px;
    margin-right: -10px;
    margin-top: -20px;
  }

  .cust-row [class^=cust-col] {
    padding-left: 10px;
    padding-right: 10px;
    margin: 0;
    margin-top: 20px;
    flex-shrink: 0;
    flex-grow: 0;
    box-sizing: border-box;
  }

  .cust-col-6 {
    flex-basis: 50%;
    max-width: 50%;
  }

  .cust-col-4 {
    flex-basis: 33.3333%;
    max-width: 33.3333%;
  }

  .cust-col-2 {
    flex-basis: 16.6667%;
    max-width: 16.6667%;
  }

  .cust-col-12 {
    flex-basis: 100%;
    max-width: 100%;
  }

  .hide-me {
    display: none;
  }

  .show-me {
    display: block;
  }

  @media (max-width: 1024px) {
    .cust-col-tablet-6 {
      flex-basis: 50%;
      max-width: 50%;
    }

    .cust-col-tablet-3 {
      flex-basis: 25%;
      max-width: 25%;
    }

    .cust-col-tablet-12 {
      flex-basis: 100%;
      max-width: 100%;
    }

    .cust-col-3 img {
      width: 100%;
    }

    .awg__health-list {
      flex-wrap: wrap;

    }

    .awg__health-1 .awg__health .awg__health-list, .awg__health-1 .awg__health:last-child .awg__health-list, .awg__health-3 .awg__health:last-child .awg__health-list {
      justify-content: flex-start;
    }

    .awg__health-1 .awg__health .awg__health-item {
      width: 25%;
      margin-bottom: 15px;
    }

    .awg__health__content {
      flex-wrap: wrap;
    }

    .awg__health-1 .awg__health:first-child, .awg__health-2 .awg__health:first-child, .awg__health-3 .awg__health:first-child {
      width: 100%;
      margin-bottom: 30px;
    }

    .awg__health-1 .awg__health:last-child, .awg__health-2 .awg__health:last-child, .awg__health-3 .awg__health:last-child {
      width: 100%;
    }

    .awg__vegs-item {
      margin-bottom: 15px;
    }

    .awg__vegs-item:last-child {
      margin-bottom: 0;
    }
  }


  @media (max-width: 768px) {
    .cust-row {
      margin-top: -32px;
      margin-left: -16px;
      margin-right: -16px;
    }

    .cust-row [class^=cust-col] {
      margin-top: 32px;
      padding-left: 16px;
      padding-right: 16px;
    }

    .cust-col-v-tablet-6 {
      flex-basis: 50%;
      max-width: 50%;
    }

    .cust-col-v-tablet-12 {
      flex-basis: 100%;
      max-width: 100%;
    }

    .cust-col-v-tablet-3 {
      flex-basis: 25%;
      max-width: 25%;
    }

    .show-me--v-tablet {
      display: block;
    }

    .hide-me--v-tablet {
      display: none;
    }

    .awg__section {
      margin: 33px 0;
    }

    .awg__section__h1, .awg__section__h2 {
      font-size: 22px;
    }

  }

  @media (max-width: 480px) {
    .cust-row {
      margin-top: -12px;
      margin-left: -6px;
      margin-right: -6px;
    }

    .cust-row [class^=cust-col] {
      margin-top: 12px;
      padding-left: 6px;
      padding-right: 6px;
    }

    .cust-col-mobile-12 {
      flex-basis: 100%;
      max-width: 100%;
    }

    .awg__grey {
      padding: 15px 20px;
    }

    .awg__vegs-item {
      width: 100%;
      margin-bottom: 15px;
    }

    .awg__health__content {
      flex-wrap: wrap;
    }

    .awg__health-list {
      flex-wrap: wrap;
    }

    .awg__health-item {
      width: 48% !important;
      margin-bottom: 15px;
    }


    .awg__type-2 img {
      width: 80px;
    }

    .awg__type-2 p {
      width: calc(100% - 100px);
    }
  }

  .street-light__section {
    max-width: 1180px;
    margin: 47px auto;
    padding: 0 15px;
  }

  .street-light__section p {
    font-size: 16px;
    line-height: 140%;
    letter-spacing: 0.05px;
    color: #333333;
  }

  .street-light__section p a {
    letter-spacing: 0.05px;
    text-decoration-line: underline;
    color: #333333;
  }

  .street-light__section a {
    color: #333333;
    text-decoration: underline;
  }

  .street-light__section a:hover {
    text-decoration: none;
  }

  .street-light_h1 {
    font-weight: 500;
    font-size: 38px;
    line-height: 24px;
    color: #333333;
    margin-bottom: 27px;
  }

  .street-light_h2 {
    font-weight: 500;
    font-size: 28px;
    color: #333333;
  }

  .street-light_h3 {
    font-weight: 500;
    font-size: 24px;
    line-height: 24px;
    color: #333333;
  }

  .street-light_jst {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-top: 47px;
    flex-wrap: wrap;
  }

  .street-light__icon_1 {
    width: 19%;
    text-align: center;
  }

  .street-light__grey {
    background: #F3F3F5;
    border-radius: 4px;
  }

  .street-light__g-list {
    padding: 36px 30px 0 30px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .street-light__g-item {
    width: 32%;
  }

  .street-light__gp {
    margin: 35px 30px 0 30px;
    padding-bottom: 20px;
  }

  .street-light__types {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .street-light__types__item {
    width: 24%;
  }

  .street-light__g-item img {
    margin-bottom: 20px;
  }

  /* grid */

  .cust-row {
    display: flex;
    flex-wrap: wrap;
    margin-left: -10px;
    margin-right: -10px;
    margin-top: -20px;
  }

  .cust-row [class^=cust-col] {
    padding-left: 10px;
    padding-right: 10px;
    margin: 0;
    margin-top: 20px;
    flex-shrink: 0;
    flex-grow: 0;
    box-sizing: border-box;
  }

  .cust-col-6 {
    flex-basis: 50%;
    max-width: 50%;
  }

  .cust-col-3 {
    flex-basis: 25%;
    max-width: 25%;
  }

  .cust-col-4 {
    flex-basis: 33.3333%;
    max-width: 33.3333%;
  }

  .cust-col-2 {
    flex-basis: 16.6667%;
    max-width: 16.6667%;
  }

  .cust-col-12 {
    flex-basis: 100%;
    max-width: 100%;
  }

  .hide-me {
    display: none;
  }

  .cust-row [class^=cust-col].mt-0 {
    margin-top: 0;
  }

  p.mb-25, ul.mb-25 {
    margin-top: 0;
    margin-bottom: 25px;
  }

  .cust-row [class^=cust-col].pl-50 {
    padding-left: 50px;
  }

  ul li {
    margin-bottom: 6px;
  }

  /* /grid */

  .cust-trend__item {
    padding: 16px;
    display: flex;
    align-items: flex-end;
    background: #F2F3F5;
    border-radius: 4px;
    white-space: nowrap;
    height: 100%;
    box-sizing: border-box;
    min-height: 270px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: 50% 50%;
    text-decoration: none;
    color: inherit;
    position: relative;
    transition: all 0.2s;
  }

  .cust-trend__item--1 {
    background: url(https://cdn.lemanapro.ru/lmru/image/upload/v1644910703/fudzi/elbrus/advice-new/osveshchenie/kak-vybrat-i-ustanovit-ulichnoe-osveshchenie/015.png/015.png) no-repeat center;
    background-size: cover;
  }

  .cust-trend__item--5 {
    background: url(https://cdn.lemanapro.ru/lmru/image/upload/v1644910703/fudzi/elbrus/advice-new/osveshchenie/kak-vybrat-i-ustanovit-ulichnoe-osveshchenie/017.png/017.png) no-repeat center;
    background-size: cover;
  }

  .cust-trend__item--4 {
    background: url(https://cdn.lemanapro.ru/lmru/image/upload/v1644910703/fudzi/elbrus/advice-new/osveshchenie/kak-vybrat-i-ustanovit-ulichnoe-osveshchenie/018.png/018.png) no-repeat center;
    background-size: cover;
  }

  .cust-trend__item--2 {
    background: url(https://cdn.lemanapro.ru/lmru/image/upload/v1644910703/fudzi/elbrus/advice-new/osveshchenie/kak-vybrat-i-ustanovit-ulichnoe-osveshchenie/016.png/016.png) no-repeat center;
    background-size: cover;
  }

  .cust-trend__item--3 {
    background: url(https://cdn.lemanapro.ru/lmru/image/upload/v1644910703/fudzi/elbrus/advice-new/osveshchenie/kak-vybrat-i-ustanovit-ulichnoe-osveshchenie/019.png/019.png) no-repeat center;
    background-size: cover;
  }

  .cust-trend__item--6 {
    background: url(https://cdn.lemanapro.ru/lmru/image/upload/v1644910703/fudzi/elbrus/advice-new/osveshchenie/kak-vybrat-i-ustanovit-ulichnoe-osveshchenie/020.png/020.png) no-repeat center;
    background-size: cover;
  }

  .street-light__house {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-top: 30px;
  }

  .street-light__house__item {
    background: #F3F3F5;
    border-radius: 4px;
    padding: 25px 25px 5px 25px;
    width: 32%;
    margin-bottom: 20px;
  }

  .street-light__house__item img {
    margin-bottom: 16px;
  }

  .cust-row.pd-30 {
    padding: 30px;
  }

  .street-light__table-inf {
    align-items: flex-end;
  }

  .street-light__table-inf p {
    font-size: 13px;
    font-weight: 700;
  }

  .flex-center {
    display: flex;
    align-items: center;
  }

  .flex-center p {
    margin-left: 30px;
  }

  ul {
    padding: 0 25px;
  }

  ol {
    padding: 0 20px;
  }

  ol li {
    margin-bottom: 10px;
  }

  .mt-0 {
    margin-top: 0 !important;
  }

  .red-text {
    font-weight: 600;
    color: red;
  }

  .street-light__safe-rules {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
  }

  .street-light__safe-rules__item {
    display: flex;
    align-items: center;
    width: 31%;
  }

  .street-light__safe-rules__item img {
    margin-right: 30px;
  }

  .street-light__safe-rules__item p {
    width: calc(100% - 154px);
  }

  li.mb-25 {
    margin-bottom: 25px;
    margin-top: 0;
  }

  @media (max-width: 1024px) {
    .cust-col-tablet-6 {
      flex-basis: 50%;
      max-width: 50%;
    }

    .cust-col-tablet-3 {
      flex-basis: 25%;
      max-width: 25%;
    }

    .cust-col-tablet-12 {
      flex-basis: 100%;
      max-width: 100%;
    }

    .cust-col-3 img {
      width: 100%;
    }
  }

  @media (min-width: 1024px) {
    .cust-row.street-light__table-inf .cust-col-4:nth-child(2) {
      flex-basis: 34%;
      max-width: 34%;
    }

    .cust-row.street-light__table-inf .cust-col-4:nth-child(3) {
      flex-basis: 31.8%;
      max-width: 31.8%;
    }
  }

  @media (max-width: 768px) {
    .cust-row {
      margin-top: -32px;
      margin-left: -16px;
      margin-right: -16px;
    }

    .cust-row [class^=cust-col] {
      margin-top: 32px;
      padding-left: 16px;
      padding-right: 16px;
    }

    .cust-col-v-tablet-6 {
      flex-basis: 50%;
      max-width: 50%;
    }

    .cust-col-v-tablet-12 {
      flex-basis: 100%;
      max-width: 100%;
    }

    .cust-col-v-tablet-3 {
      flex-basis: 25%;
      max-width: 25%;
    }

    .show-me--v-tablet {
      display: block;
    }

    .hide-me--v-tablet {
      display: none;
    }

    .street-light__section {
      margin: 33px 0;
    }

    .street-light__icon_1 {
      width: 48%;
    }

    .street-light_h1 {
      font-size: 22px;
      line-height: 130%;
    }

    .street-light__g-list {
      padding: 20px 15px 0 15px;
    }

    .street-light__gp {
      margin: 15px 15px 0 15px;
      padding-bottom: 15px;
    }

    .street-light__g-item {
      width: 100%;
      margin-bottom: 30px;
    }

    .street-light__types__item {
      width: 48%;
    }

    .street-light__safe-rules__item {
      width: 100%;
    }

    .street-light__house__item {
      width: 48%;
      padding: 15px 15px 5px 15px;
    }

    .cust-row [class^=cust-col].pl-50 {
      padding-left: 6px;
      margin-top: 15px !important;
    }

    .cust-row.pd-30 {
      padding: 20px 15px;
    }

    .street-light_h2 {
      font-size: 22px;
    }

    .street-light_jst {
      margin-top: 33px;
    }
  }

  @media (max-width: 480px) {
    .cust-row {
      margin-top: -12px;
      margin-left: -6px;
      margin-right: -6px;
    }

    .cust-row [class^=cust-col] {
      margin-top: 12px;
      padding-left: 6px;
      padding-right: 6px;
    }

    .cust-col-mobile-12 {
      flex-basis: 100%;
      max-width: 100%;
    }

    .street-light__icon_1 {
      width: 100%;
      display: flex;
      align-items: center;
      text-align: left;
      margin-bottom: 20px;
    }

    .street-light__icon_1 img {
      width: 72px;
      margin-right: 15px;
    }

    .street-light__icon_1 p {
      width: calc(100% - 90px);
      margin: 0;
    }

    .street-light__types__item {
      width: 100%;
      margin-bottom: 20px;
    }

    .street-light__types__item:last-child {
      margin-bottom: 0;
    }

    .street-light__types__item img {
      width: 100%;
    }

    .street-light__house__item {
      width: 100%;
    }

    .mt-12--mobile {
      margin-top: 12px !important;
    }

    .cust-col-3 img {
      width: 100%;
    }

    .street-light_h3 {
      font-size: 22px;
    }

    .street-light__safe-rules__item {
      margin-bottom: 20px;
    }

    .street-light__safe-rules__item:last-child {
      margin-bottom: 0;
    }

    .street-light__safe-rules__item img {
      width: 72px;
    }

    .street-light__safe-rules__item p {
      width: calc(100% - 90px);
      margin: 0;
    }
  }

  ._1407-wrap {
    overflow-x: hidden;
    max-width: 1366px;
    margin: 0 auto;
  }

  ._1407-container {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    margin: 0 93px;
  }

  .marker {
    position: absolute;
    top: 22px;
    left: 20px;
  }

  ._1407-prevtext {
    position: relative;
    margin: 40px 0;
  }

  ._1407-prevtext__title {
    font-weight: bold;
    font-size: 34px;
    line-height: 40px;
    color: #333333;
    margin-top: 0;
    margin-bottom: 24px;
  }

  ._1407-prevtext__desc {
    font-weight: normal;
    font-size: 20px;
    line-height: 32px;
    color: #333333;
    max-width: 776px;
  }

  ._1407-video {
    margin-bottom: 80px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    position: relative;
  }

  .video__image {
    width: inherit;
  }

  ._1407-video__user {
    display: flex;
    margin-bottom: 40px;
  }

  ._1407-video__icon {
    width: 40px;
    height: 40px;
    border-radius: 100px;
    margin-right: 12px;
  }

  ._1407-video__user-content {
    display: flex;
    flex-direction: column;
    align-self: center;
  }

  ._1407-video__content-title {
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    margin-top: 0;
    margin-bottom: 2px;
    color: #333333;
  }

  ._1407-video__content-text {
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    color: #666666;
    margin: 0;
  }

  ._1407-video__slides {
    order: 2;
    position: relative;
  }

  ._1407-video__slide {
    display: flex !important;
    flex-direction: column;
    align-items: stretch;
  }

  ._1407-video__image {
    display: block;
    width: 776px;
    position: relative;
  }

  ._1407-instructions {
    margin-bottom: 80px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    position: relative;
  }

  ._1407-instructions__slides {
    display: flex;
    flex-direction: column;
    width: calc(100% + 80px);
  }

  ._1407-instructions__slide {
    margin-bottom: 40px;
    display: flex;


    flex-direction: column;


    align-items: stretch;
  }

  ._1407-instructions__container {
    display: flex;
    flex-direction: column;
    width: fit-content;
    position: relative;
    box-shadow: 0 0.1660px 2.2138px rgba(0, 0, 0, 0.0196802), 0 0.3990px 5.3201px rgba(0, 0, 0, 0.0282725), 0 0.7513px 10.0172px rgba(0, 0, 0, 0.035), 0 1.3402px 17.869px rgba(0, 0, 0, 0.0417275), 0 2.5067px 33.4221px rgba(0, 0, 0, 0.0503198);
    border-radius: 8px;
  }

  .step {
    position: absolute;
    top: 40px;
    left: 40px;
    background-color: #ffffff;
    border-radius: 100px;
    width: 48px;
    height: 48px;
    z-index: 100;
    font-size: 29px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  ._1407-instructions__image {
    display: block;
    width: 776px;
    height: 582px;
    position: relative;
  }

  ._1407-instructions__content {
    max-width: 776px;
    padding: 40px;
    order: 3;
  }

  ._1407-instructions__text {
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    color: #333333;
    margin-top: 0;
  }

  ._1407-instructions__title {
    font-weight: 500;
    font-size: 26px;
    line-height: 32px;
    color: #333333;
    margin-bottom: 16px;
    margin-top: 0;
  }

  ._1407-products {
    margin-bottom: 80px;
  }

  ._1407-products__title {
    font-weight: 500;
    font-size: 26px;
    line-height: 32px;
    color: #333333;
    margin-bottom: 42px;
    margin-top: 0;
  }

  ._1407-products__list {
    width: 100%;
    order: 2;
    position: relative;
    display: flex;
    flex-wrap: wrap;
  }

  ._1407-products__item {
    width: 115px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    position: relative;
  }

  ._1407-products__link {
    margin-right: 32px;
    margin-bottom: 60px;
  }

  ._1407-products__link:last-child {
    margin: 0;
  }

  ._1407-products__image {
    width: 117px;
    height: 117px;
    margin-bottom: 8px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    -o-object-fit: contain;
    object-fit: contain;
  }

  ._1407-products__name {
    flex-grow: 1;
    font-weight: normal;
    font-size: 16px;
    line-height: 22px;
    color: #333333;
    margin: 0;
  }

  .card {
    margin-bottom: 15px;
    position: relative;
    width: inherit;
    height: 372px;
    box-shadow: 0 1.17px 2px rgba(0, 0, 0, 0.0196802), 0 1.4px 5px rgba(0, 0, 0, 0.03), 0 2px 10px rgba(0, 0, 0, 0.03), 0 2px 18px rgba(0, 0, 0, 0.04), 0 9px 33px rgba(0, 0, 0, 0.03);
    border-radius: 8px;
    background: #FFFFFF;
  }

  .card--margin {
    margin-right: 32px;
  }

  .card__image {
    width: 271px;
    height: 190px;
    margin-bottom: 19px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }

  .card__span {
    display: grid;
    height: 200px;
  }

  .card__title {
    font-weight: 500;
    font-size: 20px;
    margin: 0 20px;
    line-height: 28px;
    color: #333333;
    max-width: 231px;
  }

  .card__container {
    display: flex;
    padding: 20px;
    position: absolute;
    bottom: 0;
  }

  .card__icon {
    width: 40px;
    height: 40px;
    border-radius: 100px;
    margin-right: 12px;
  }

  .card__content {
    display: flex;
    flex-direction: column;
  }

  .card__content-title {
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    margin-top: 0;
    margin-bottom: 2px;
    color: #333333;
  }

  .card__content-text {
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    color: #666666;
    margin: 0;
  }

  .swiper-button-next-first, .swiper-button-prev-first {
    position: absolute;
    top: 50%;
    z-index: 10;
    cursor: pointer;
    display: none;
    align-items: center;
    justify-content: center;
  }

  @media (max-width: 1024px) {
    .swiper-button-next-first, .swiper-button-prev-first {
      display: flex;
    }
  }

  #swiper-button-prev-first {
    right: auto;
    left: -15px;
  }

  #swiper-button-next-first {
    left: auto;
    right: -20px;
  }

  #swiper-button-next-first, #swiper-button-prev-first {
    outline: none;
    background: #FFFFFF;
    box-shadow: 0 1.17px 2px rgba(0, 0, 0, 0.0196802), 0 1.4px 5px rgba(0, 0, 0, 0.03), 0 2px 10px rgba(0, 0, 0, 0.03), 0 2px 18px rgba(0, 0, 0, 0.04), 0 9px 33px rgba(0, 0, 0, 0.03);
    border-radius: 24px;
    width: 40px;
    height: 40px;
    top: 50%;
  }

  .swiper-button-prev-img {
    transform: rotate(180deg);
    margin: 30%;
  }

  .swiper-button-next-img {
    margin: 30%;
  }

  #swiper-button-prev-first.slick-disabled, #swiper-button-next-first.slick-disabled {
    opacity: 0;
    cursor: auto;
  }

  ._1407-advantages {
    margin-bottom: 7vw;
    position: relative;
  }

  ._1407-advantages__content-link {
    display: flex;
    justify-content: space-between;
    margin-bottom: 32px;
  }

  ._1407-advantages__title {
    font-weight: 500;
    font-size: 26px;
    line-height: 32px;
    margin: 0;
    color: #333333;
  }

  ._1407-advantages__link {
    color: #333333;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    display: flex;
    align-items: center;
    text-align: center;
  }

  ._1407-advantages__arrow {
    width: 20px;
  }

  ._1407-advantages__list {
    display: flex;
    position: relative;
  }


  @media (max-width: 1365px) {
    ._1407-container {
      margin: 0 4.12vw;
    }

    ._1407-prevtext__title {
      max-width: 699px;
    }

    ._1407-prevtext__desc {
      max-width: 697px;
    }

    ._1407-video__image {
      width: 697px;
    }

    ._1407-instructions__image {
      width: 697px;
      height: 523px;
    }

    ._1407-instructions__content {
      max-width: 697px;
    }

    .card {
      margin-bottom: 15px;
      width: min-content;
      height: 378px;
    }

    .card--margin {
      margin-right: 32px;
    }

    .card__image {
      margin-bottom: 19px;
      width: 292px;
      height: 204px;
    }

    .card__title {
      font-size: 20px;
      margin: 0 20px;
      line-height: 28px;
      max-width: 231px;
    }

    .card__container {
      padding: 20px;
    }

    .card__icon {
      width: 40px;
      height: 40px;
      margin-right: 12px;
    }

    .card__content-title {
      font-size: 16px;
      line-height: 22px;
      margin-bottom: 2px;
    }

    .card__content-text {
      font-size: 12px;
      line-height: 16px;
    }

    ._1407-products__item {
      width: 10.1vw;
    }

    ._1407-products__link {
      margin-right: 3.13vw;
      margin-bottom: 6vw;
    }

    ._1407-products__link:nth-child(7) {
      margin-right: 0;
    }

    #swiper-button-next-first, #swiper-button-prev-first {
      display: none;
    }

    ._1407-advantages {
      margin-bottom: 80px;
    }
  }

  @media (max-width: 1023px) {
    ._1407-container {
      margin: 0 7.1vw;
    }

    ._1407-prevtext__title {
      max-width: 545px;
    }

    ._1407-prevtext__desc {
      max-width: 545px;
    }

    ._1407-video__image {
      width: 660px;
    }

    ._1407-instructions__image {
      width: 660px;
      height: 495px;
    }

    ._1407-instructions__content {
      max-width: 660px;
    }

    .card {
      margin-bottom: 15px;
      height: 315px;
    }

    .card--margin {
      margin-right: 3.2vw;
    }

    .card__image {
      margin-bottom: 1.9vw;
      width: 258px;
      height: 180px;
    }

    .card__title {
      font-size: 15px;
      margin: 0 15px;
      line-height: 21px;
      max-width: 177px;
    }

    .card__container {
      padding: 15px;
    }

    .card__icon {
      width: 31px;
      height: 31px;
      margin-right: 10px;
    }

    .card__content-title {
      font-size: 12px;
      line-height: 17px;
      margin-bottom: 1px;
    }

    .card__content-text {
      font-size: 9px;
      line-height: 12px;
    }

    ._1407-advantages__link {
      position: absolute;
      bottom: -40px;
    }

    ._1407-products__item {
      width: 14.2vw;
    }

    ._1407-products__link {
      margin-right: 3.13vw;
      margin-bottom: 6vw;
    }

    ._1407-products__link:nth-child(7) {
      margin-right: 3.13vw;
    }

    ._1407-products__link:nth-child(5) {
      margin-right: 0;
    }

    .step {
      font-size: 23px;
      top: 24px;
      left: 24px;
    }
  }

  @media (max-width: 767px) {
    ._1407-products__list {
      flex-wrap: nowrap;
    }

    ._1407-container {
      margin: 0 5vw;
    }

    ._1407-prevtext {
      margin: 32px 0;
    }

    ._1407-prevtext__title {
      max-width: 288px;
      margin-bottom: 16px;
    }

    ._1407-prevtext__desc {
      font-size: 14px;
      line-height: 20px;
      max-width: 288px;
    }

    ._1407-instructions__image {
      order: 3;
      width: 350px;
      height: 260px;
    }

    ._1407-instructions__content {
      padding: 0;
      max-width: 84.4vw;
      margin-bottom: 32px;
      order: 2;
    }

    .card {
      margin-bottom: 15px;
      height: 318px;
    }

    .card__span {
      height: 205px;
    }

    .card--margin {
      margin-right: 32px;
    }

    ._1407-video__image {
      width: 350px;
    }

    .card__image {
      margin-bottom: 15px;
      width: 238px;
      height: 168px;
    }

    .card__title {
      font-size: 16px;
      margin: 0 20px;
      line-height: 22px;
      max-width: 206px;
    }

    .card__container {
      padding: 16px;
    }

    .card__icon {
      width: 40px;
      height: 40px;
      margin-right: 8px;
    }

    .card__content-title {
      font-size: 14px;
      line-height: 18px;
      margin-bottom: 2px;
    }

    .card__content-text {
      font-size: 12px;
      line-height: 16px;
    }

    ._1407-products__item {
      width: 162px;
    }

    ._1407-products__link {
      margin-right: 18px;
      margin-bottom: 0;
    }

    ._1407-products__link:nth-child(7) {
      margin-right: 18px;
    }

    ._1407-products__link:nth-child(5) {
      margin-right: 18px;
    }

    ._1407-instructions__container {
      box-shadow: none;
    }

    .step {
      position: relative;
      background: #464C5C;
      color: #fff;
      order: 1;
      width: 43px;
      height: 43px;
      font-size: 28px;
      margin-bottom: 32px;
      top: auto;
      left: auto;
    }

    ._1407-instructions__text {
      font-size: 19px;
      line-height: 27px;
    }

    ._1407-instructions__title {
      font-size: 35px;
      line-height: 43px;
      margin-bottom: 21px;
    }

    ._1407-video__slides {
      margin-bottom: 24px;
    }
  }

  @media (max-width: 425px) {
    .card {
      margin-bottom: 15px;
      height: 320px;
    }

    .card__span {
      height: 227px;
    }

    .card--margin {
      margin-right: 12px;
    }

    ._1407-products__item {
      width: 38.1vw;
    }

    ._1407-products__link {
      margin-right: 4.13vw;
      margin-bottom: 0;
    }

    ._1407-products__link:nth-child(7) {
      margin-right: 4.13vw;
    }

    ._1407-products__link:nth-child(5) {
      margin-right: 4.13vw;
    }

    .step {
      width: 10vw;
      height: 10vw;
      font-size: 6.5vw;
      margin-bottom: 7.5vw;
    }

    ._1407-instructions__image {
      width: 84.4vw;
      height: 63.5vw;
    }

    ._1407-instructions__content {
      max-width: 84.4vw;
      margin-bottom: 7.5vw;
    }

    ._1407-instructions__text {
      font-size: 4.4vw;
      line-height: 6.3vw;
    }

    ._1407-instructions__title {
      font-size: 8.2vw;
      line-height: 10vw;
      margin-bottom: 5vw;
    }

    ._1407-video__image {
      width: 84.4vw;
    }
  }

  @media all {
    ._1407-instructions {
      display: flex;
      flex-direction: column;
      align-items: stretch;
      position: relative;
    }

    ._1407-instructions:before {
      content: '';
      position: absolute;
      background: #f9f9fa;
      top: 0;
      bottom: 0;
      left: 50%;
      margin-left: -50vw;
      width: 100vw;
    }

    ._1407-instructions__title {
      order: 0;
      position: relative;
    }

    ._1407-instructions__arrows, .arrows-tab1, .arrows-tab2, .arrows-tab3 {
      order: 3;
      position: relative;
      display: flex;
      justify-content: center;
    }
  }
  @media all and (max-width: 767px) {
    ._1407-instructions__arrows, .arrows-tab1, .arrows-tab2, .arrows-tab3 {
      padding: 0 0 3vw 0;
    }
  }

  @media all {
    ._1407-instructions__slides, .wrap-video, .slides-tab1, .slides-tab2, .slides-tab3 {
      order: 2;
      position: relative;
      margin-left: -1rem;
      margin-right: -1rem;
    }

    ._1407-instructions__slide {
      padding-left: 1rem;
      padding-right: 1rem;
    }

    ._1407-instructions__image {
      display: block;
      width: 100%;
      position: relative;
      margin-bottom: 40px;
    }

    ._1407-instructions__step {
      font-size: 26px;
      line-height: 34px;
      margin-bottom: 24px;
      font-weight: 600;
      color: #4b4b4b;
    }
  }
  @media all and (min-width: 1024px) and (max-width: 1439px) {
    ._1407-instructions__step {
      font-size: 1.8vw;
      line-height: 2.4vw;
    }
  }
  @media all and (min-width: 768px) and (max-width: 1023px) {
    ._1407-instructions__step {
      font-size: 2.5vw;
      line-height: 3.2vw;
    }
  }
  @media all and (max-width: 767px) {
    ._1407-instructions__step {
      font-size: 5.9vw;
      line-height: 8.4vw;
    }
  }

  @media all {
    ._1407-instructions__text {
      position: relative;
      font-size: 22px;
      line-height: 30px;
      color: #727272;
      margin-bottom: 30px;
      z-index: 5;
    }
  }
  @media all and (min-width: 1024px) and (max-width: 1439px) {
    ._1407-instructions__text {
      font-size: 1.5vw;
      line-height: 2vw;
    }
  }
  @media all and (min-width: 768px) and (max-width: 1023px) {
    ._1407-instructions__text {
      font-size: 2vw;
      line-height: 3vw;
    }
  }
  @media all and (max-width: 767px) {
    ._1407-instructions__text {
      font-size: 5vw;
      line-height: 7.8vw;
    }
  }

  @media all {
    ._1407-instructions__text p {
      margin: 0;
    }
  }

  @media all and (min-width: 768px) {
    ._1407-instructions {
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: center;
    }

    ._1407-instructions:before {
      display: none;
    }

    ._1407-instructions__arrows, .arrows-tab1, .arrows-tab2, .arrows-tab3 {
      order: 2;
      margin: 0 0 2.4rem;
    }

    ._1407-instructions__slides, .wrap-video, .slides-tab1, .slides-tab2, .slides-tab3 {
      order: 3;
      width: calc(100% + 80px);
      margin-left: -40px;
      margin-right: -40px;
    }

    ._1407-instructions__slide {
      padding-left: 40px;
      padding-right: 40px;
    }

    ._1407-instructions__image {
      display: block;
      width: 600px;
      margin-bottom: -225px;
      margin-left: 3px;
    }

    ._1407-instructions__content {
      background: #eee;
      margin-left: 60px;
      padding: 265px 50px 24px;
    }
  }

  @media all and (min-width: 1024px) {
    ._1407-instructions__arrows, .arrows-tab1, .arrows-tab2, .arrows-tab3 {
      margin: 0 0 3rem;
    }
  }

  @media all and (min-width: 1200px) {
    ._1407-instructions__slide {
      display: flex !important;
      flex-direction: row;
      align-items: stretch;
    }

    ._1407-instructions__image {
      display: block;
      min-width: 600px;
      max-width: 600px;
      position: relative;
      margin: 30px 0;
      object-fit: contain;
      filter: drop-shadow(3px 3px 6px rgba(0, 0, 0, 0.2));
    }

    ._1407-instructions__content {
      background: #eee;
      flex-grow: 1;
      margin: 0 0 0 -100px;
      padding: 60px 70px 60px 160px;
    }

    .step-zero ._1407-instructions__content {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
  }

  @media (min-width: 769px) {
    .video iframe {
      height: 450px;
    }

    ._1407-instructions__image.video {
      height: 450px !important;
    }
  }

  .text-center {
    text-align: center;
  }
  
  .h4, h4 {
    font-size: 18px;
    margin-top: 9.5px;
    margin-bottom: 9.5px;
    font-family: inherit;
    font-weight: 600;
    line-height: 1.1;
    color: inherit;
  }

  .community-table__table-title {
    font-size: 28px;
    font-weight: 700;
    line-height: 0.93;
    text-align: center;
    color: #494848;
    margin-top: 60px;
    margin-bottom: 19px
  }

  .community-table__table {
    width: 100%;
    margin-top: 23px;
    margin-bottom: 16px;
    background-color: #fff;
    -webkit-box-shadow: 0 10px 22px 0 rgba(72,72,72,0.05);
    box-shadow: 0 10px 22px 0 rgba(72,72,72,0.05)
  }

  .community-table__table>tbody>tr td:first-child,.community-table__table>tbody>tr th:first-child,.community-table__table>tfoot>tr td:first-child,.community-table__table>tfoot>tr th:first-child,.community-table__table>thead>tr td:first-child,.community-table__table>thead>tr th:first-child {
    padding-left: 28px
  }

  .community-table__table>tbody>tr td:last-child,.community-table__table>tbody>tr th:last-child,.community-table__table>tfoot>tr td:last-child,.community-table__table>tfoot>tr th:last-child,.community-table__table>thead>tr td:last-child,.community-table__table>thead>tr th:last-child {
    padding-right: 28px
  }

  .community-table__table>tbody>tr>th,.community-table__table>tbody>tr td,.community-table__table>tfoot>tr>th,.community-table__table>tfoot>tr td,.community-table__table>thead>tr>th,.community-table__table>thead>tr td {
    font-size: 13px;
    text-align: left;
    padding-left: 10px;
    padding-right: 10px
  }

  .community-table__table>tbody>tr>th,.community-table__table>tfoot>tr>th,.community-table__table>thead>tr>th {
    border-top: none;
    border-bottom: 3px solid #66c05d;
    font-weight: 700;
    padding-top: 23px;
    padding-bottom: 23px;
    color: #adadad
  }

  .community-table__table>tbody>tr>td,.community-table__table>tfoot>tr>td,.community-table__table>thead>tr>td {
    border-top: 1px solid #efefef;
    font-family: inherit;
    line-height: 2.23;
    color: #5b5b5b;
    padding-top: 16px;
    padding-bottom: 16px
  }

  .community-table .table-responsive {
    border: none
  }
  
  .mobile-overflov-msg {
    font-size: 12px;
    line-height: 1.5;
    text-align: left;
    color: #494848;
    margin-top: 10px;
    display: none!important
}

@media (max-width: 767px) {
    .mobile-overflov-msg {
        display:block!important
    }
}

.mobile-overflov-msg__row {
    display: block;
    margin-top: 20px
}

.mobile-overflov-msg__row .mobile-overflov-msg__icon,.mobile-overflov-msg__row .mobile-overflov-msg__text {
    margin-left: 15px;
    vertical-align: middle;
    display: inline-block
}

.mobile-overflov-msg__row .mobile-overflov-msg__icon {
    font-size: 30px;
    width: 29px;
    height: 30px
}

.mobile-overflov-msg__row .mobile-overflov-msg__text {
    width: 75%
}

  .adaptive-column-size-control {
    display: block;
    position: relative
  }

  .adaptive-column-size-control .column-0, .adaptive-column-size-control .column-1 {
    margin: 0 0 20px;
    padding-top: 0;
    padding-bottom: 0
  }

  .fancybox-container {
    z-index: 1035
  }

  .community-table__table {
    width: 100%;
    margin-top: 23px;
    margin-bottom: 16px;
    background-color: #fff;
    -webkit-box-shadow: 0 10px 22px 0 rgba(72, 72, 72, .05);
    box-shadow: 0 10px 22px 0 rgba(72, 72, 72, .05)
  }

  .community-table__table > tbody > tr td:first-child, .community-table__table > tbody > tr th:first-child {
    padding-left: 28px
  }

  .community-table__table > tbody > tr td:last-child, .community-table__table > tbody > tr th:last-child {
    padding-right: 28px
  }

  .community-table__table > tbody > tr > th, .community-table__table > tbody > tr td {
    font-size: 13px;
    text-align: left;
    padding-left: 10px;
    padding-right: 10px
  }

  .community-table__table > tbody > tr > th {
    border-top: 0;
    border-bottom: 3px solid #66c05d;
    font-weight: 700;
    padding-top: 23px;
    padding-bottom: 23px;
    color: #adadad
  }

  .community-table__table > tbody > tr > td {
    border-top: 1px solid #efefef;
    font-family: inherit;
    line-height: 2.23;
    color: #5b5b5b;
    padding-top: 16px;
    padding-bottom: 16px
  }

  .community-table .table-responsive {
    border: 0
  }

  .service-content .adaptiveImage {
    position: relative;
    overflow: hidden;
    margin-left: -12px;
    margin-right: -12px
  }

  @media (max-width: 991px) {
    .service-content .adaptiveImage {
      padding-top: 32px
    }
  }

  .adaptiveImage .resize-image, .editorial-image, .service-content .adaptiveImage .img {
    width: 100%
  }

  .rte-header {
    font-size: 24px
  }

  .rte-standard {
    font-size: 14px
  }

  .rte-small {
    font-size: 12px
  }

  .accent-topic {
    text-decoration: underline;
  }

  .mobile-overflov-msg {
    font-size: 12px;
    line-height: 1.5;
    text-align: left;
    color: #494848;
    margin-top: 10px;
    display: none !important
  }

  @media (max-width: 767px) {
    .mobile-overflov-msg {
      display: block !important
    }
  }

  .mobile-overflov-msg__row {
    display: block;
    margin-top: 20px
  }

  .mobile-overflov-msg__row .mobile-overflov-msg__icon, .mobile-overflov-msg__row .mobile-overflov-msg__text {
    margin-left: 15px;
    vertical-align: middle;
    display: inline-block
  }

  .mobile-overflov-msg__row .mobile-overflov-msg__icon {
    font-size: 30px;
    width: 29px;
    height: 30px
  }

  .mobile-overflov-msg__row .mobile-overflov-msg__text {
    width: 75%
  }

  .fancybox-container {
    font-family: inherit
  }

  .navbar {
    border: 0
  }

  .navbar .container {
    width: inherit;
    padding: 20px
  }
  

  .navbar .nav-item {
    border-bottom: 1px dashed #f2f2f2
  }

  .navbar .nav-item a {
    text-transform: uppercase;
    font-size: 13px;
    padding-right: 20px
  }

  .navbar .nav-item a:hover {
    color: #fff;
    background-color: #66c05d
  }

  .navbar .nav-item a:after {
    font-family: Leroy Merlin Icons, serif;
    content: "\\E977";
    font-size: 7px;
    position: absolute;
    right: 15px;
    top: 35%;
    color: #999
  }

  .navbar .nav-item a:focus {
    background-color: inherit;
    color: #66c05d
  }

  .navbar .nav-item.active a:after {
    color: #fff
  }

  .service-section-comp {
    position: relative;
    float: left;
    width: 100%;
    min-height: 1px;
    padding-left: 0;
    padding-right: 0
  }

  @media (min-width: 992px) {
    .service-section-comp:before {
      content: "";
      display: block;
      height: 76px;
      margin: -76px 0 0
    }
  }

  section {
    display: block
  }

  h1 {
    font-size: 2em;
    margin: .67em 0
  }

  button[disabled], html input[disabled] {
    cursor: default
  }

  table {
    border-collapse: collapse;
    border-spacing: 0
  }

  td, th {
    padding: 0
  }

  @media print {
    tr {
      page-break-inside: avoid
    }

    .navbar {
      display: none
    }

    .table {
      border-collapse: collapse !important
    }

    .table td, .table th {
      background-color: #fff !important
    }
  }

  .h1, h1 {
    font-family: inherit;
    font-weight: 600;
    line-height: 1.1;
    color: inherit
  }

  .h1 .small, .h1 small, h1 .small, h1 small {
    font-weight: 300;
    line-height: 1;
    color: #9c9b9b
  }

  .h1, h1 {
    margin-top: 19px;
    margin-bottom: 9.5px
  }

  .h1 .small, .h1 small, h1 .small, h1 small {
    font-size: 65%
  }

  .h1, h1 {
    font-size: 36px
  }

  h1 {
    -webkit-transition: width 1s ease-out;
    transition: width 1s ease-out
  }

  .btn.disabled, .btn[disabled] {
    color: #999;
    background-color: #ddd;
    border-color: #ddd;
    cursor: not-allowed;
    opacity: .65;
    filter: alpha(opacity=65)
  }

  a.btn.disabled {
    pointer-events: none
  }

  .btn-success.disabled:focus, .btn-success.disabled:hover, .btn-success[disabled]:focus, .btn-success[disabled]:hover {
    color: #999;
    background-color: #ddd
  }

  .green-button.active:focus, .green-button:active:hover {
    color: #fff;
    background-color: #3f8f38
  }

  .green-button.disabled:focus, .green-button.disabled:hover, .green-button[disabled]:focus, .green-button[disabled]:hover, .red-button.disabled:focus, .red-button.disabled:hover, .red-button[disabled]:focus, .red-button[disabled]:hover {
    color: #999;
    background-color: #ddd
  }

  .btn-link[disabled] {
    background-color: transparent;
    border: 0;
    -webkit-box-shadow: none;
    box-shadow: none
  }

  .btn-link[disabled]:focus, .btn-link[disabled]:hover {
    color: #999;
    text-decoration: none;
    border: 0
  }

  tr.collapse.in {
    display: table-row
  }

  tbody.collapse.in {
    display: table-row-group
  }

  .nav > li.disabled > a {
    color: #9c9b9b
  }

  .nav > li.disabled > a:focus, .nav > li.disabled > a:hover {
    color: #9c9b9b;
    text-decoration: none;
    background-color: transparent;
    cursor: not-allowed
  }

  .nav-pills > li {
    float: left
  }

  .nav-pills > li > a {
    border-radius: 0
  }

  .nav-pills > li + li {
    margin-left: 2px
  }

  .nav-pills > li.active > a, .nav-pills > li.active > a:focus, .nav-pills > li.active > a:hover {
    color: #fafafa;
    background-color: #66c05d
  }

  .nav-stacked > li {
    float: none
  }

  .nav-stacked > li + li {
    margin-top: 2px;
    margin-left: 0
  }

  .navbar {
    position: relative;
    min-height: 50px;
    margin-bottom: 19px;
    border: 1px solid transparent
  }

  @media (min-width: 768px) {
    .navbar {
      border-radius: 0
    }
  }

  .fancybox-modal .change-city-modal .default-block:after, .fancybox-modal .change-city-modal .default-block:before, .fancybox-modal.change-service-city-modal .default-block:after, .fancybox-modal.change-service-city-modal .default-block:before, .footer .footer-row:after, .navbar:after, .navbar:before {
    content: " ";
    display: table
  }

  .fancybox-modal .change-city-modal .default-block:after, .fancybox-modal.change-service-city-modal .default-block:after, .navbar:after {
    clear: both
  }

  .hide {
    display: none !important
  }

  table {
    background-color: transparent
  }

  caption {
    padding-top: 8px;
    padding-bottom: 8px;
    color: #9c9b9b
  }

  caption, th {
    text-align: left
  }

  .table {
    width: 100%;
    max-width: 100%;
    margin-bottom: 19px
  }

  .table > tbody > tr > td, .table > tbody > tr > th {
    padding: 8px;
    line-height: 1.398;
    vertical-align: top;
    border-top: 1px solid #ddd
  }

  .table > tbody + tbody {
    border-top: 2px solid #ddd
  }

  .table .table {
    background-color: #fafafa
  }

  table td[class*=col-], table th[class*=col-] {
    position: static;
    float: none;
    display: table-cell
  }

  .table > tbody > tr.active > td, .table > tbody > tr.active > th, .table > tbody > tr > td.active, .table > tbody > tr > th.active {
    background-color: #f5f5f5
  }

  .table > tbody > tr.success > td, .table > tbody > tr.success > th, .table > tbody > tr > td.success, .table > tbody > tr > th.success {
    background-color: #dff0d8
  }

  .table-responsive {
    overflow-x: auto;
    min-height: .01%
  }

  @media screen and (max-width: 767px) {
    .table-responsive {
      width: 100%;
      margin-bottom: 14.25px;
      overflow-y: hidden;
      -ms-overflow-style: -ms-autohiding-scrollbar;
      border: 1px solid #ddd
    }

    .table-responsive > .table {
      margin-bottom: 0
    }

    .table-responsive > .table > tbody > tr > td, .table-responsive > .table > tbody > tr > th {
      white-space: nowrap
    }
  }

  input:not([type]) ::-webkit-input-placeholder, input[type=email] ::-webkit-input-placeholder, input[type=text] ::-webkit-input-placeholder, input[type=url] ::-webkit-input-placeholder {
    color: #999
  }

  input:not([type]) :-moz-placeholder, input:not([type]) ::-moz-placeholder, input[type=email] :-moz-placeholder, input[type=email] ::-moz-placeholder, input[type=text] :-moz-placeholder, input[type=text] ::-moz-placeholder, input[type=url] :-moz-placeholder, input[type=url] ::-moz-placeholder {
    color: #999
  }

  input:not([type]) :-ms-input-placeholder, input[type=email] :-ms-input-placeholder, input[type=text] :-ms-input-placeholder, input[type=url] :-ms-input-placeholder {
    color: #999
  }

  .white-bg {
    background: #fff
  }

  .fancybox-modal.change-service-city-modal .title {
    font-size: 28px;
    line-height: normal
  }

  .fancybox-modal .change-city-modal .default-block, .fancybox-modal.change-service-city-modal .default-block {
    border: 1px solid #eee;
    padding: 15px;
    margin-left: -10px;
    margin-right: -10px
  }

  .fancybox-modal .change-city-modal .my-shop .current, .fancybox-modal.change-service-city-modal .my-shop .current {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20preserveAspectRatio%3D%22xMidYMid%22%20width%3D%2216%22%20height%3D%2226%22%20viewBox%3D%220%200%2016%2026%22%20style%3D%22fill%3A%2366c05d%3B%22%3E%0D%0A%20%20%3Cdefs%3E%0D%0A%20%20%3C%2Fdefs%3E%0D%0A%20%20%3Cpath%20d%3D%22M16.000%2C7.964%20C16.000%2C3.565%2012.418%2C0.000%208.000%2C0.000%20C3.581%2C0.000%20-0.000%2C3.565%20-0.000%2C7.964%20C-0.000%2C9.056%200.221%2C10.096%200.620%2C11.043%20C0.620%2C11.043%200.621%2C11.043%200.621%2C11.043%20C0.621%2C11.043%208.015%2C26.000%208.015%2C26.000%20C8.015%2C26.000%2015.410%2C10.971%2015.410%2C10.971%20C15.410%2C10.971%2015.409%2C10.971%2015.409%2C10.971%20C15.790%2C10.043%2016.000%2C9.028%2016.000%2C7.964%20ZM8.000%2C13.407%20C4.869%2C13.407%202.332%2C10.881%202.332%2C7.764%20C2.332%2C4.648%204.869%2C2.121%208.000%2C2.121%20C11.130%2C2.121%2013.668%2C4.648%2013.668%2C7.764%20C13.668%2C10.881%2011.130%2C13.407%208.000%2C13.407%20Z%22%20id%3D%22path-1%22%20class%3D%22cls-2%22%20fill-rule%3D%22evenodd%22%2F%3E%0D%0A%3C%2Fsvg%3E");
    background-position: 0 0;
    background-repeat: no-repeat;
    font-size: 13px;
    font-weight: 600;
    height: 30px;
    line-height: 30px;
    padding-left: 30px;
    text-transform: uppercase
  }

  .fancybox-modal .change-city-modal .my-shop .current-shop-detail, .fancybox-modal.change-service-city-modal .my-shop .current-shop-detail {
    width: 246px;
    display: inline-block;
    margin-top: 15px;
    vertical-align: top
  }

  .fancybox-modal .change-city-modal .my-shop .current-shop-detail .detail-text, .fancybox-modal.change-service-city-modal .my-shop .current-shop-detail .detail-text {
    color: #444;
    font-size: 14px
  }

  .fancybox-modal .change-city-modal .my-shop .current-shop-detail .detail-main-text, .fancybox-modal.change-service-city-modal .my-shop .current-shop-detail .detail-main-text {
    font-size: 14px;
    font-weight: 600;
    color: #444
  }

  .fancybox-modal .change-city-modal .my-shop .current-shop .shop-name, .fancybox-modal.change-service-city-modal .my-shop .current-shop .shop-name {
    color: #444;
    font-weight: 600;
    font-size: 16px
  }

  @media (min-width: 992px) {
    .change-service-city-modal {
      width: 100%
    }
  }

  .header-block .header-inner.is-sticky {
    -webkit-box-shadow: 0 0 2px rgba(0, 0, 0, .4);
    box-shadow: 0 0 2px rgba(0, 0, 0, .4);
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    z-index: 1020
  }

  @media (max-width: 767px) {
    .header-block .header-inner.is-sticky {
      -webkit-box-shadow: none;
      box-shadow: none
    }
  }

  .header-block .header-inner.is-sticky .logo-icon img {
    height: 55px
  }

  @media (min-width: 767px) {
    .header-block .header-inner.is-sticky .logo-icon img {
      margin-top: 10px
    }
  }

  .header-block .header-inner.is-sticky .catalog-menu {
    margin-top: 8px
  }

  .header-block .header-inner.is-sticky .card-quick {
    margin-top: 0
  }

  .change-product-quantity .item-counter.disabled {
    border: 0
  }

  .change-product-quantity .item-counter-input.disabled {
    color: #ababab;
    border: 0
  }

  .change-product-quantity .item-counter-button.disabled {
    cursor: auto
  }

  .shop-list-wrapper .shop-list-empty {
    -webkit-transition: border .2s ease 0;
    transition: border .2s ease 0
  }

  .shop-list-wrapper .shop-list-empty .header {
    font-weight: 700;
    font-size: 18px
  }

  .shop-list-wrapper .shop-list-empty .text {
    margin-top: 12px;
    font-size: 14px;
    text-align: left;
    font-style: italic
  }

  .spinner-ajax h1 {
    font-size: 28px;
    font-weight: 700
  }

  .product-quick-view h1 {
    margin-top: 0;
    color: #333;
    font-weight: 600;
    font-size: 28px
  }

  .basket-wrapper .basket-list-empty .header {
    font-weight: 700;
    font-size: 18px
  }

  .basket-wrapper .basket-list-empty .text {
    margin-top: 12px;
    font-size: 14px;
    text-align: left;
    font-style: italic
  }

  @media (max-width: 991px) {
    .slide-menu {
      position: fixed !important;
      z-index: 1002 !important;
      top: 0;
      left: 100%;
      -webkit-transform: translateZ(0);
      transform: translateZ(0);
      -webkit-transition: -webkit-transform .2s ease-in-out;
      transition: -webkit-transform .2s ease-in-out;
      transition: transform .2s ease-in-out;
      transition: transform .2s ease-in-out, -webkit-transform .2s ease-in-out;
      width: 100%;
      height: 100vh;
      background-color: #fafafa
    }
  }

  @media (min-width: 768px) {
    .parbase .rte-header {
      margin-bottom: 16px;
      display: block
    }
  }

  @media (max-width: 767px) {
    .parbase .rte-header {
      font-size: 16px;
      margin-bottom: 28px;
      display: inline-block
    }
  }

  @media (max-width: 767px) {
    .parbase p {
      margin: 0
    }
  }

  .com-notification {
    background-color: #fffde9;
    border: 1px solid #fff595;
    padding: 22px 30px 24px;
    margin: 30px 0
  }

  @media (max-width: 480px) {
    .com-notification {
      padding: 22px 22px 24px 25px
    }
  }

  .com-notification__deck {
    font-size: 14px;
    font-weight: 400;
    line-height: 1.64;
    color: #5b5b5b
  }

  .com-notification__deck, .com-notification__title {
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal
  }

  .com-notification__title {
    font-size: 16px;
    font-weight: 700;
    line-height: 1.44;
    color: #333;
    margin-bottom: 8px
  }

  .com-notification__icon {
    display: inline-block;
    width: 17px;
    height: 17px;
    background-color: #d8dd32;
    border-radius: 50%;
    margin-right: 11px;
    text-align: center;
    color: #fff;
    line-height: 18px;
    position: relative;
    top: 2px
  }

  body.fancybox-active {
    overflow: hidden
  }

  .fancybox-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 99992;
    -webkit-tap-highlight-color: transparent;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }

  .fancybox-bg, .fancybox-inner, .fancybox-stage {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0
  }

  .fancybox-bg {
    background: #1e1e1e;
    opacity: 0;
    -webkit-transition-duration: inherit;
    transition-duration: inherit;
    -webkit-transition-property: opacity;
    transition-property: opacity;
    -webkit-transition-timing-function: cubic-bezier(.47, 0, .74, .71);
    transition-timing-function: cubic-bezier(.47, 0, .74, .71)
  }

  .fancybox-is-open .fancybox-bg {
    opacity: .87;
    -webkit-transition-timing-function: cubic-bezier(.22, .61, .36, 1);
    transition-timing-function: cubic-bezier(.22, .61, .36, 1)
  }

  .fancybox-caption-wrap, .fancybox-infobar, .fancybox-toolbar {
    position: absolute;
    direction: ltr;
    z-index: 99997;
    opacity: 0;
    visibility: hidden;
    -webkit-transition: opacity .25s, visibility 0 linear .25s;
    transition: opacity .25s, visibility 0 linear .25s;
    -webkit-box-sizing: border-box;
    box-sizing: border-box
  }

  .fancybox-infobar {
    top: 0;
    left: 0;
    font-size: 13px;
    padding: 0 10px;
    height: 44px;
    min-width: 44px;
    line-height: 44px;
    color: #ccc;
    text-align: center;
    pointer-events: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-touch-callout: none;
    -webkit-tap-highlight-color: transparent;
    -webkit-font-smoothing: subpixel-antialiased;
    mix-blend-mode: exclusion
  }

  .fancybox-toolbar {
    top: 0;
    right: 0;
    margin: 0;
    padding: 0
  }

  .fancybox-stage {
    overflow: hidden;
    direction: ltr;
    z-index: 99994;
    -webkit-transform: translateZ(0)
  }

  .fancybox-slide {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: auto;
    outline: 0;
    white-space: normal;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    text-align: center;
    z-index: 99994;
    -webkit-overflow-scrolling: touch;
    display: none;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    -webkit-transition-property: opacity, -webkit-transform;
    transition-property: opacity, -webkit-transform;
    transition-property: transform, opacity;
    transition-property: transform, opacity, -webkit-transform
  }

  .fancybox-slide:before {
    content: "";
    display: inline-block;
    vertical-align: middle;
    height: 100%;
    width: 0
  }

  .fancybox-slide--current {
    display: block
  }

  .fancybox-slide > * {
    display: inline-block;
    position: relative;
    padding: 24px;
    margin: 44px 0;
    border-width: 0;
    vertical-align: middle;
    text-align: left;
    background-color: #fff;
    overflow: auto;
    -webkit-box-sizing: border-box;
    box-sizing: border-box
  }

  .fancybox-slide > link, .fancybox-slide > meta, .fancybox-slide > script, .fancybox-slide > style, .fancybox-slide > title {
    display: none
  }

  .fancybox-button {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    display: inline-block;
    vertical-align: top;
    width: 44px;
    height: 44px;
    margin: 0;
    padding: 10px;
    border: 0;
    border-radius: 0;
    background: rgba(30, 30, 30, .6);
    -webkit-transition: color .3s ease;
    transition: color .3s ease;
    cursor: pointer;
    outline: 0
  }

  .fancybox-button, .fancybox-button:link, .fancybox-button:visited {
    color: #ccc
  }

  .fancybox-button:focus, .fancybox-button:hover {
    color: #fff
  }

  .fancybox-button[disabled] {
    color: #ccc;
    cursor: default;
    opacity: .6
  }

  .fancybox-button svg {
    display: block;
    position: relative;
    overflow: visible;
    shape-rendering: geometricPrecision
  }

  .fancybox-button svg path {
    fill: currentColor;
    stroke: currentColor;
    stroke-linejoin: round;
    stroke-width: 3
  }

  .fancybox-button--share svg path {
    stroke-width: 1
  }

  .fancybox-button--play svg path:nth-child(2), .fancybox-navigation {
    display: none
  }

  .fancybox-navigation button {
    position: absolute;
    top: 50%;
    margin: -50px 0 0;
    z-index: 99997;
    background: transparent;
    width: 60px;
    height: 100px;
    padding: 17px
  }

  .fancybox-navigation button:before {
    content: "";
    position: absolute;
    top: 30px;
    right: 10px;
    width: 40px;
    height: 40px;
    background: rgba(30, 30, 30, .6)
  }

  .fancybox-navigation .fancybox-button--arrow_left {
    left: 0
  }

  .fancybox-navigation .fancybox-button--arrow_right {
    right: 0
  }

  .fancybox-close-small {
    top: 0;
    right: 0;
    width: 40px;
    height: 40px;
    padding: 0;
    margin: 0;
    border: 0;
    border-radius: 0;
    background: transparent;
    z-index: 10;
    cursor: pointer
  }

  .fancybox-close-small:after {
    content: "\\D7";
    position: absolute;
    top: 5px;
    right: 5px;
    width: 30px;
    height: 30px;
    font: 22px/30px Arial, Helvetica Neue, Helvetica, sans-serif;
    color: #888;
    font-weight: 300;
    text-align: center;
    border-radius: 50%;
    border-width: 0;
    background-color: transparent;
    -webkit-transition: background-color .25s;
    transition: background-color .25s;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    z-index: 2
  }

  .fancybox-close-small:focus {
    outline: 0
  }

  .fancybox-close-small:focus:after {
    outline: 1px dotted #888
  }

  .fancybox-close-small:hover:after {
    color: #555;
    background: #eee
  }

  .fancybox-caption-wrap {
    bottom: 0;
    left: 0;
    right: 0;
    padding: 60px 2vw 0;
    background: -webkit-gradient(linear, left top, left bottom, from(transparent), color-stop(20%, rgba(0, 0, 0, .1)), color-stop(40%, rgba(0, 0, 0, .2)), color-stop(80%, rgba(0, 0, 0, .6)), to(rgba(0, 0, 0, .8)));
    background: linear-gradient(180deg, transparent, rgba(0, 0, 0, .1) 20%, rgba(0, 0, 0, .2) 40%, rgba(0, 0, 0, .6) 80%, rgba(0, 0, 0, .8));
    pointer-events: none
  }

  .fancybox-caption {
    padding: 30px 0;
    border-top: 1px solid hsla(0, 0, 100%, .4);
    font-size: 14px;
    color: #fff;
    line-height: 20px;
    -webkit-text-size-adjust: none
  }

  .fancybox-caption a, .fancybox-caption button {
    pointer-events: all;
    position: relative
  }

  .fancybox-caption a {
    color: #fff;
    text-decoration: underline
  }

  .fancybox-modal .btn-success[disabled] {
    background-color: #ddd;
    border-color: #ddd;
    color: #999;
    cursor: default;
    pointer-events: none
  }

  .fancybox-close-small {
    background: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHdpZHRoPScxNCcgaGVpZ2h0PScxNCc+PHBhdGggZmlsbD0nIzY2YzA1ZCcgZD0nTTE0LjA2MSAxMS45MzlMMTEuOTQgMTQuMDYgNyA5LjEyMWwtNC45MzkgNC45NEwtLjA2IDExLjk0IDQuODc5IDdsLTQuOTQtNC45MzlMMi4wNjEtLjA2MSA3IDQuODc5bDQuOTM5LTQuOTRMMTQuMDYgMi4wNiA5LjEyMSA3eicgZmlsbC1ydWxlPSdldmVub2RkJy8+PC9zdmc+);
    background-color: #fff;
    background-size: 50%;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    background-size: cover;
    border: 8px solid #fff;
    height: 30px;
    width: 30px;
    position: absolute
  }

  @media (min-width: 768px) {
    .fancybox-close-small {
      right: -30px;
      top: -30px
    }
  }

  @media (max-width: 767px) {
    .fancybox-close-small {
      right: 0;
      top: 0
    }
  }

  .fancybox-slide > * {
    overflow: visible
  }

  .fancybox-close-small:after {
    content: "" !important;
    top: -8px;
    right: -8px;
    border-radius: 0
  }

  .fancybox-close-small:hover:after {
    background-color: transparent;
    border: 1px solid #66c05d
  }

  .fancybox-bg {
    opacity: .3 !important
  }

  .fancybox-container {
    z-index: 1055;
  }

  .brands h1 {
    color: #333;
    text-transform: none;
    font-size: 24px;
    font-weight: 600;
    margin: 30px 15px 30px 10px
  }

  .section:after, .section:before {
    content: " ";
    display: table
  }

  .section:after {
    clear: both
  }

  @media (min-width: 768px) {
    .faq .slide-menu {
      position: relative;
      min-height: 1px;
      padding-left: 10px;
      padding-right: 10px
    }
  }

  @media (min-width: 768px) and (min-width: 768px) {
    .faq .slide-menu {
      float: left;
      width: 25%
    }
  }

  .faq h1 {
    padding-top: 0;
    margin: 30px 0;
    font-size: 36px;
    color: #333;
    text-transform: uppercase;
    font-weight: 600
  }

  .tooltip-container.service-item .popover {
    top: -50px !important;
    width: auto
  }

  .tooltip-container.service-item .popover.right {
    margin-left: -35px
  }

  .tooltip-container.service-item .popover.left {
    margin-left: 35px
  }

  .tooltip-container .popover {
    min-width: 290px;
    background-color: #66c05d;
    color: #fff;
    z-index: 1200;
    max-width: inherit;
    border-radius: 0;
    border: 0
  }

  .tooltip-container .popover-content {
    padding: 0
  }

  .tooltip-container .popover .arrow:after {
    border-top-color: #66c05d
  }

  .tooltip-container .popover ul {
    list-style: none;
    column-count: 2;
    -webkit-columns: 2;
    -moz-columns: 2;
    padding: 20px 0 0
  }

  .tooltip-container .popover ul li {
    margin-bottom: 15px;
    list-style: none;
    font-size: 13px;
    font-weight: 300
  }

  .tooltip-container .popover ul li a {
    color: #f1f1f1;
    text-decoration: underline;
    border: 0;
    margin: 0;
    padding: 0
  }

  .service-page-general {
    margin-top: 31px
  }

  @media (min-width: 992px) {
    .service-page-general {
      padding-bottom: 40px
    }
  }

  @media (max-width: 991px) {
    .service-page-general {
      padding-bottom: 30px
    }
  }

  .service-page .slide-menu {
    position: relative;
    min-height: 1px;
    padding-left: 10px;
    padding-right: 10px
  }

  @media (max-width: 767px) {
    .service-page .slide-menu {
      display: none !important
    }
  }

  @media (min-width: 768px) {
    .service-page .slide-menu {
      float: left;
      width: 25%
    }
  }

  .service-page .header {
    position: relative;
    float: left;
    width: 100%;
    min-height: 1px;
    padding-left: 10px;
    padding-right: 10px;
    margin-top: 22px;
    margin-bottom: 22px
  }

  @media (max-width: 767px) {
    .service-page .header {
      display: none !important
    }
  }

  @media (min-width: 768px) and (max-width: 991px) {
    .service-page .header {
      display: none !important
    }
  }

  .service-page .service-content {
    float: left;
    width: 100%;
    position: relative;
    min-height: 1px;
    background-color: #fff;
    padding: 0 12px 15px
  }

  @media (min-width: 992px) {
    .service-page .service-content {
      float: left;
      width: 100%
    }
  }

  .service-page .service-content .service-section:first-child .image:first-child {
    margin-left: -40px;
    margin-right: -40px
  }

  @media (max-width: 991px) {
    .service-page .service-content {
      margin-top: 30px
    }
  }

  .service-page .service {
    font-size: 16px;
    line-height: 24px
  }

  @media (max-width: 991px) {
    .service-page {
      width: 100%
    }

    .service-page .service {
      font-size: 14px;
      line-height: 21px
    }

    .service-page .editorial-image {
      padding-top: 32px
    }
  }

  .service-block .service-items {
    float: left;
    width: 100%;
    position: relative;
    min-height: 1px;
    padding-left: 10px;
    padding-right: 10px
  }

  @media (min-width: 768px) {
    .service-block .service-items {
      float: left;
      width: 25%
    }
  }

  @media (max-width: 991px) and (min-width: 768px) {
    .service-block .service-items {
      padding-left: 4px;
      padding-right: 4px
    }
  }

  @media (min-width: 992px) {
    .service-block .service-items {
      padding-left: 10px;
      padding-right: 10px
    }
  }

  @media (max-width: 767px) {
    .service-block .service-items {
      padding-left: 10px;
      padding-right: 10px
    }
  }

  .service-block .service-items .service-item {
    padding-left: 20px;
    padding-right: 20px;
    border: 1px solid #eee;
    position: relative;
    display: inline-block;
    vertical-align: top;
    height: 189px;
    width: 100%
  }

  @media (max-width: 767px) {
    .service-block .service-items .service-item {
      padding-left: 10px;
      padding-right: 10px;
      margin-top: 5px;
      margin-bottom: 5px
    }
  }

  @media (max-width: 991px) and (min-width: 768px) {
    .service-block .service-items .service-item {
      padding-left: 10px;
      padding-right: 10px;
      margin-top: 4px;
      margin-bottom: 4px
    }
  }

  @media (min-width: 992px) {
    .service-block .service-items .service-item {
      padding-left: 10px;
      padding-right: 10px;
      margin-top: 10px;
      margin-bottom: 10px
    }
  }

  .service-block .service-items .service-item .service-link {
    display: block;
    text-decoration: none;
    line-height: 189px
  }

  .service-block .service-items .service-item .service-link img {
    display: inline-block;
    max-width: 100%;
    height: auto
  }

  .service-block .service-items .active {
    box-shadow: 0 0 20px 0 #d3d3d3;
    -webkit-box-shadow: 0 0 15px 0 #d3d3d3;
    -moz-box-shadow: 0 0 15px 0 #d3d3d3;
    cursor: default
  }

  .service-block .note {
    font-size: 17px;
    line-height: 20px;
    padding-left: 65px;
    margin-top: 40px;
    background-color: #fff;
    padding-bottom: 99px
  }

  .service-block .note:before {
    content: "*";
    font-size: 72px;
    line-height: 60px;
    color: #66c05d;
    position: absolute;
    top: -8px;
    left: 15px
  }

  .service-block .service-content h1 {
    font-size: 25px;
    font-weight: 600;
    margin: 0;
    padding: 0 0 30px
  }

  .service-block .service-content p {
    font-size: 16px;
    padding: 0;
    margin: 0 0 10px
  }

  .service-block .service-content a {
    border-bottom: 1px solid #66c05d;
    color: #66c05d;
    text-decoration: none
  }

  .service-block .service-content a:hover {
    color: #4ba842;
    text-decoration: none;
    border-color: #4ba842
  }

  .service-block .service-content table {
    margin-bottom: 20px;
    display: table;
    height: auto;
    border: 1px solid #eee;
    border-right: 0;
    border-bottom: 0;
    width: 100%
  }

  .service-block .service-content table th {
    font-weight: 600
  }

  .service-block .service-content table td, .service-block .service-content table th {
    border-right: 1px solid #eee;
    border-bottom: 1px solid #eee;
    padding: 10px;
    vertical-align: middle
  }

  .store-selector-component {
    padding: 15px 26px 24px;
    background-color: #f8f8f8
  }

  .store-selector-component .store-icon {
    padding-right: 18px;
    color: #66c05d;
    font-size: 36px
  }

  .store-selector-component .store-icon, .store-selector-component .store-selector-content {
    display: table-cell;
    vertical-align: middle
  }

  .store-selector-component .store-selector-content .caption {
    font-size: 17px;
    font-weight: 600;
    color: #333;
    line-height: 1.7
  }

  .store-selector-component .store-selector-content .select-link {
    font-size: 14px
  }

  .store-selector-component .store-selector-content .select-link a {
    border-bottom: 1px dashed
  }

  .store-selector-all-stores {
    width: 100%;
    border-bottom: 1px solid #eee;
    margin-top: 20px;
    padding-bottom: 10px;
    font-size: 17px;
    font-weight: 600;
    color: #333;
    display: inline-block;
    white-space: nowrap
  }

  @media (min-width: 768px) {
    .store-selector-all-stores {
      line-height: 62px
    }
  }

  @media (max-width: 767px) {
    .store-selector-all-stores {
      line-height: 25px
    }
  }

  .store-selector-all-stores .store-selector-info {
    display: inline-block;
    vertical-align: middle;
    color: #ffcd7e;
    line-height: 62px;
    font-size: 32px;
    margin-right: 14px
  }

  .store-selector-all-stores .store-selector-text {
    width: calc(100% - 46px);
    vertical-align: middle;
    display: inline-block;
    white-space: normal
  }

  .header-with-store-selector {
    margin-top: 27px;
    margin-left: -10px;
    margin-right: -10px
  }

  .header-with-store-selector .header {
    float: left;
    width: 100%;
    position: relative;
    min-height: 1px;
    padding-left: 10px;
    padding-right: 10px
  }

  @media (min-width: 992px) {
    .header-with-store-selector .header {
      float: left;
      width: 41.6667%
    }
  }

  @media (min-width: 1200px) {
    .header-with-store-selector .header {
      float: left;
      width: 33.3333%
    }
  }

  .header-with-store-selector .header .store-selector__header {
    margin-top: 0;
    display: inline-block;
    font-size: 29px;
    color: #333;
    text-transform: uppercase;
    font-weight: 600;
    line-height: 1.45
  }

  .header-with-store-selector .header-store-selector {
    float: left;
    width: 100%;
    position: relative;
    min-height: 1px;
    padding-left: 10px;
    padding-right: 10px
  }

  @media (min-width: 992px) {
    .header-with-store-selector .header-store-selector {
      float: left;
      width: 41.6667%
    }
  }

  .service-page .store-selector-component {
    margin-top: 37px;
    margin-bottom: 30px;
    width: 100%
  }

  @media (min-width: 768px) {
    .service-page .store-selector-component {
      width: 60%
    }
  }

  .tooltip-container.service-item .popover {
    top: -50px !important;
    width: auto
  }

  .tooltip-container.service-item .popover.right {
    margin-left: -35px
  }

  .tooltip-container.service-item .popover.left {
    margin-left: 35px
  }

  .tooltip-container .popover {
    min-width: 290px;
    background-color: #66c05d;
    color: #fff;
    z-index: 1200;
    max-width: inherit;
    border-radius: 0;
    border: 0
  }

  .tooltip-container .popover-content {
    padding: 0
  }

  .tooltip-container .popover .popover-section {
    font-size: 16px;
    font-weight: 600;
    padding: 16px 44px 16px 28px
  }

  .fancybox-modal .change-city-modal .title, .fancybox-modal.change-service-city-modal .title {
    font-size: 28px;
    line-height: normal
  }

  .fancybox-modal .change-city-modal .default-block, .fancybox-modal.change-service-city-modal .default-block {
    border: 1px solid #eee;
    padding: 15px;
    margin-left: -10px;
    margin-right: -10px
  }

  .fancybox-modal .change-city-modal .search-panel, .fancybox-modal.change-service-city-modal .search-panel {
    overflow: hidden;
    background-color: #66c05d
  }

  .fancybox-modal .change-city-modal .search-panel__input, .fancybox-modal.change-service-city-modal .search-panel__input {
    float: left;
    width: 100%;
    position: relative;
    min-height: 1px;
    padding-left: 10px;
    padding-right: 10px
  }

  @media (min-width: 992px) {
    .fancybox-modal .change-city-modal .search-panel__input, .fancybox-modal.change-service-city-modal .search-panel__input {
      float: left;
      width: 66.6667%
    }
  }

  .fancybox-modal .change-city-modal .search-panel__alternative, .fancybox-modal.change-service-city-modal .search-panel__alternative {
    float: left;
    width: 100%;
    position: relative;
    min-height: 1px;
    padding-left: 10px;
    padding-right: 10px;
    white-space: nowrap
  }

  @media (min-width: 992px) {
    .fancybox-modal .change-city-modal .search-panel__alternative, .fancybox-modal.change-service-city-modal .search-panel__alternative {
      float: left;
      width: 33.3333%
    }
  }

  .fancybox-modal .change-city-modal .search-panel .search-input, .fancybox-modal.change-service-city-modal .search-panel .search-input {
    height: 38px;
    margin: 0;
    display: inline-block
  }

  .fancybox-modal .change-city-modal .search-panel .search-text, .fancybox-modal.change-service-city-modal .search-panel .search-text {
    color: #fff;
    height: 38px;
    line-height: 38px;
    text-align: center;
    display: inline-block;
    width: 62px
  }

  .fancybox-modal .change-city-modal .search-panel .search-link, .fancybox-modal.change-service-city-modal .search-panel .search-link {
    border-bottom: 1px solid #fff;
    color: #fff;
    display: inline-block;
    margin-left: 30px;
    padding-top: 10px;
    position: relative;
    font-size: 14px
  }

  .fancybox-modal .change-city-modal .search-panel .search-link:before, .fancybox-modal.change-service-city-modal .search-panel .search-link:before {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20preserveAspectRatio%3D%22xMidYMid%22%20width%3D%2216%22%20height%3D%2226%22%20viewBox%3D%220%200%2016%2026%22%20style%3D%22fill%3A%23fff%3B%22%3E%0D%0A%20%20%3Cdefs%3E%0D%0A%20%20%3C%2Fdefs%3E%0D%0A%20%20%3Cpath%20d%3D%22M16.000%2C7.964%20C16.000%2C3.565%2012.418%2C0.000%208.000%2C0.000%20C3.581%2C0.000%20-0.000%2C3.565%20-0.000%2C7.964%20C-0.000%2C9.056%200.221%2C10.096%200.620%2C11.043%20C0.620%2C11.043%200.621%2C11.043%200.621%2C11.043%20C0.621%2C11.043%208.015%2C26.000%208.015%2C26.000%20C8.015%2C26.000%2015.410%2C10.971%2015.410%2C10.971%20C15.410%2C10.971%2015.409%2C10.971%2015.409%2C10.971%20C15.790%2C10.043%2016.000%2C9.028%2016.000%2C7.964%20ZM8.000%2C13.407%20C4.869%2C13.407%202.332%2C10.881%202.332%2C7.764%20C2.332%2C4.648%204.869%2C2.121%208.000%2C2.121%20C11.130%2C2.121%2013.668%2C4.648%2013.668%2C7.764%20C13.668%2C10.881%2011.130%2C13.407%208.000%2C13.407%20Z%22%20id%3D%22path-1%22%20class%3D%22cls-2%22%20fill-rule%3D%22evenodd%22%2F%3E%0D%0A%3C%2Fsvg%3E");
    background-position: 0 0;
    background-repeat: no-repeat;
    content: "";
    height: 38px;
    left: -30px;
    position: absolute;
    top: 2px;
    width: 30px
  }

  .fancybox-modal .change-city-modal .search-panel .search-link:hover, .fancybox-modal.change-service-city-modal .search-panel .search-link:hover {
    text-decoration: none;
    border-bottom-color: #000;
    color: #000
  }

  .fancybox-modal .change-city-modal .search-panel .search-link:hover:before, .fancybox-modal.change-service-city-modal .search-panel .search-link:hover:before {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20preserveAspectRatio%3D%22xMidYMid%22%20width%3D%2216%22%20height%3D%2226%22%20viewBox%3D%220%200%2016%2026%22%20style%3D%22fill%3A%23000%3B%22%3E%0D%0A%20%20%3Cdefs%3E%0D%0A%20%20%3C%2Fdefs%3E%0D%0A%20%20%3Cpath%20d%3D%22M16.000%2C7.964%20C16.000%2C3.565%2012.418%2C0.000%208.000%2C0.000%20C3.581%2C0.000%20-0.000%2C3.565%20-0.000%2C7.964%20C-0.000%2C9.056%200.221%2C10.096%200.620%2C11.043%20C0.620%2C11.043%200.621%2C11.043%200.621%2C11.043%20C0.621%2C11.043%208.015%2C26.000%208.015%2C26.000%20C8.015%2C26.000%2015.410%2C10.971%2015.410%2C10.971%20C15.410%2C10.971%2015.409%2C10.971%2015.409%2C10.971%20C15.790%2C10.043%2016.000%2C9.028%2016.000%2C7.964%20ZM8.000%2C13.407%20C4.869%2C13.407%202.332%2C10.881%202.332%2C7.764%20C2.332%2C4.648%204.869%2C2.121%208.000%2C2.121%20C11.130%2C2.121%2013.668%2C4.648%2013.668%2C7.764%20C13.668%2C10.881%2011.130%2C13.407%208.000%2C13.407%20Z%22%20id%3D%22path-1%22%20class%3D%22cls-2%22%20fill-rule%3D%22evenodd%22%2F%3E%0D%0A%3C%2Fsvg%3E")
  }

  .fancybox-modal .change-city-modal .shop-help, .fancybox-modal.change-service-city-modal .shop-help {
    font-weight: 600;
    font-size: 13px
  }

  .fancybox-modal .change-city-modal .shop-card .half, .fancybox-modal.change-service-city-modal .shop-card .half {
    display: inline-block;
    vertical-align: top;
    float: left;
    width: 100%;
    position: relative;
    min-height: 1px;
    padding-left: 10px;
    padding-right: 10px
  }

  @media (min-width: 992px) {
    .fancybox-modal .change-city-modal .shop-card .half, .fancybox-modal.change-service-city-modal .shop-card .half {
      float: left;
      width: 50%
    }
  }

  .fancybox-modal .change-city-modal .shop-card .shop-main-info .shop-additional, .fancybox-modal.change-service-city-modal .shop-card .shop-main-info .shop-additional {
    margin-bottom: 20px
  }

  .fancybox-modal .change-city-modal .shop-card .shop-name, .fancybox-modal.change-service-city-modal .shop-card .shop-name {
    color: #000;
    font-weight: 600
  }

  .fancybox-modal .change-city-modal .shop-card .shop-additional, .fancybox-modal.change-service-city-modal .shop-card .shop-additional {
    color: #666
  }

  .fancybox-modal .change-city-modal .shop-card .shop-additional-title, .fancybox-modal.change-service-city-modal .shop-card .shop-additional-title {
    color: #666;
    font-weight: 600
  }

  .fancybox-modal .change-city-modal .shop-card .shop-button, .fancybox-modal.change-service-city-modal .shop-card .shop-button {
    width: 100%;
    margin-bottom: 15px
  }

  .fancybox-modal .change-city-modal .my-shop .current, .fancybox-modal.change-service-city-modal .my-shop .current {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20preserveAspectRatio%3D%22xMidYMid%22%20width%3D%2216%22%20height%3D%2226%22%20viewBox%3D%220%200%2016%2026%22%20style%3D%22fill%3A%2366c05d%3B%22%3E%0D%0A%20%20%3Cdefs%3E%0D%0A%20%20%3C%2Fdefs%3E%0D%0A%20%20%3Cpath%20d%3D%22M16.000%2C7.964%20C16.000%2C3.565%2012.418%2C0.000%208.000%2C0.000%20C3.581%2C0.000%20-0.000%2C3.565%20-0.000%2C7.964%20C-0.000%2C9.056%200.221%2C10.096%200.620%2C11.043%20C0.620%2C11.043%200.621%2C11.043%200.621%2C11.043%20C0.621%2C11.043%208.015%2C26.000%208.015%2C26.000%20C8.015%2C26.000%2015.410%2C10.971%2015.410%2C10.971%20C15.410%2C10.971%2015.409%2C10.971%2015.409%2C10.971%20C15.790%2C10.043%2016.000%2C9.028%2016.000%2C7.964%20ZM8.000%2C13.407%20C4.869%2C13.407%202.332%2C10.881%202.332%2C7.764%20C2.332%2C4.648%204.869%2C2.121%208.000%2C2.121%20C11.130%2C2.121%2013.668%2C4.648%2013.668%2C7.764%20C13.668%2C10.881%2011.130%2C13.407%208.000%2C13.407%20Z%22%20id%3D%22path-1%22%20class%3D%22cls-2%22%20fill-rule%3D%22evenodd%22%2F%3E%0D%0A%3C%2Fsvg%3E");
    background-position: 0 0;
    background-repeat: no-repeat;
    font-size: 13px;
    font-weight: 600;
    height: 30px;
    line-height: 30px;
    padding-left: 30px;
    text-transform: uppercase
  }

  .fancybox-modal .change-city-modal .my-shop .current-shop-detail, .fancybox-modal.change-service-city-modal .my-shop .current-shop-detail {
    width: 246px;
    display: inline-block;
    margin-top: 15px;
    vertical-align: top
  }

  .fancybox-modal .change-city-modal .my-shop .current-shop-detail .detail-text, .fancybox-modal.change-service-city-modal .my-shop .current-shop-detail .detail-text {
    color: #444;
    font-size: 14px
  }

  .fancybox-modal .change-city-modal .my-shop .current-shop-detail .detail-main-text, .fancybox-modal.change-service-city-modal .my-shop .current-shop-detail .detail-main-text {
    font-size: 14px;
    font-weight: 600;
    color: #444
  }

  .fancybox-modal .change-city-modal .my-shop .current-shop-detail .shop-link, .fancybox-modal.change-service-city-modal .my-shop .current-shop-detail .shop-link {
    font-size: 11px;
    text-decoration: underline;
    position: relative
  }

  .fancybox-modal .change-city-modal .my-shop .current-shop-detail .shop-link:after, .fancybox-modal.change-service-city-modal .my-shop .current-shop-detail .shop-link:after {
    border-bottom: 3px solid rgba(0, 0, 0, 0);
    border-left: 5px solid #66c05d;
    border-top: 3px solid rgba(0, 0, 0, 0);
    content: "";
    display: inline-block;
    height: 0;
    position: absolute;
    right: -15px;
    top: 4px;
    width: 0
  }

  .fancybox-modal .change-city-modal .my-shop .current-shop .shop-name, .fancybox-modal.change-service-city-modal .my-shop .current-shop .shop-name {
    color: #444;
    font-weight: 600;
    font-size: 16px
  }

  @media (min-width: 992px) {
    .change-service-city-modal {
      width: 100%
    }
  }

  .action-big-button, .action-big-button-reg, .action-button, .action-button-reg, .action-middle-button, .action-middle-button-reg, .big-button, .empty-button, .empty-red-labeled-button, .green-big-button, .green-big-button-reg, .green-button-reg, .green-middle-button, .green-middle-button-reg, .middle-button, .orange-big-button, .orange-big-button-reg, .orange-button-reg, .orange-middle-button, .orange-middle-button-reg, .red-big-button, .red-big-button-reg, .red-button-reg, .red-middle-button, .red-middle-button-reg, .standard-button, .white-big-button, .white-big-button-reg, .white-button-reg, .white-middle-button, .white-middle-button-reg, .yellow-big-button, .yellow-big-button-reg, .yellow-button-reg, .yellow-middle-button, .yellow-middle-button-reg {
    display: inline-block;
    position: relative;
    overflow: visible;
    clear: both;
    padding: 0 30px;
    text-decoration: none;
    text-align: center;
    vertical-align: top;
    outline: 0;
    -webkit-transition: all .2s ease;
    transition: all .2s ease;
    cursor: pointer;
    height: 38px;
    font-size: 12px;
    line-height: 37px;
    border-width: 1px;
    border-style: solid;
    text-transform: uppercase;
    color: #fff;
    fill: #fff
  }

  .action-big-button-reg, .action-button-reg, .action-middle-button-reg, .green-big-button-reg, .green-button-reg, .green-middle-button-reg, .orange-big-button-reg, .orange-button-reg, .orange-middle-button-reg, .red-big-button-reg, .red-button-reg, .red-middle-button-reg, .regular-button, .white-big-button-reg, .white-button-reg, .white-middle-button-reg, .yellow-big-button-reg, .yellow-button-reg, .yellow-middle-button-reg {
    text-transform: none
  }

  .green-big-button, .green-big-button-reg, .green-button-reg, .green-middle-button, .green-middle-button-reg {
    background-color: #66c05d;
    border: 1px solid #89ce82;
    color: white
  }

  .capitalize-first-letter:first-letter, .store-selector-button {
    text-transform: uppercase
  }

  .store-selector-button {
    width: 100%;
    margin-bottom: 15px;
    font-size: 14px
  }

  .fancybox-modal {
    color: #444
  }

  @media (min-width: 1200px) {
    .fancybox-modal {
      max-width: 900px;
      margin: 30px
    }
  }

  @media (max-width: 1199px) and (min-width: 992px) {
    .fancybox-modal {
      max-width: 780px;
      margin: 30px
    }
  }

  @media (max-width: 991px) and (min-width: 768px) {
    .fancybox-modal {
      max-width: 540px;
      margin: 30px
    }
  }

  @media (max-width: 767px) {
    .fancybox-modal {
      width: 100%;
      margin: 0
    }
  }

  .fancybox-modal .title {
    font-size: 18px;
    font-weight: 600;
    line-height: 19.8px;
    margin-bottom: 30px
  }

  .service-block .service-items .service-item .service-link img.unavailable {
    -webkit-filter: grayscale(100%);
    filter: grayscale(100%)
  }

  .tooltip-container.service-item .popover {
    top: -50px !important;
    width: auto
  }

  .tooltip-container.service-item .popover.right {
    margin-left: -35px
  }

  .tooltip-container.service-item .popover.left {
    margin-left: 35px
  }

  .tooltip-container .popover {
    min-width: 290px;
    background-color: #66c05d;
    color: #fff;
    z-index: 1200;
    max-width: inherit;
    border-radius: 0;
    border: 0
  }

  .service-item.tooltip-container .popover {
    z-index: 1000
  }

  .tooltip-container .popover-content {
    padding: 0
  }

  .tooltip-container .popover .popover-section {
    font-size: 16px;
    font-weight: 600;
    padding: 16px 44px 16px 28px
  }

  .tooltip-container .popover .arrow:after {
    border-top-color: #66c05d
  }

  .tooltip-container .popover ul {
    list-style: none;
    column-count: 2;
    -webkit-columns: 2;
    -moz-columns: 2;
    padding: 20px 0 0
  }

  .tooltip-container .popover ul li {
    margin-bottom: 15px;
    list-style: none;
    font-size: 13px;
    font-weight: 300
  }

  .tooltip-container .popover ul li a {
    color: #f1f1f1;
    text-decoration: underline;
    border: 0;
    margin: 0;
    padding: 0
  }

  .tooltip-container .popover .popover-service-links {
    font-size: 16px;
    font-weight: 400
  }

  @media (min-width: 768px) {
    .tooltip-container .popover .popover-service-links {
      width: 460px
    }
  }

  @media (max-width: 767px) {
    .tooltip-container .popover .popover-service-links {
      width: 100%
    }
  }

  .tooltip-container .popover .popover-service-links .popover-service-links-caption {
    font-size: 16px;
    font-weight: 600
  }

  .tooltip-container .popover .dotted-underline {
    border-bottom: 1px dashed #fff
  }

  .service-section-parsys .table > tbody > tr > td, .service-section-parsys .table > tbody > tr > th, .service-section-parsys .table > tfoot > tr > td, .service-section-parsys .table > tfoot > tr > th, .service-section-parsys .table > thead > tr > td, .service-section-parsys .table > thead > tr > th {
    padding: 8px;
    line-height: 1.398;
    vertical-align: top;
    border-top: 1px solid #ddd
  }
  
  .service-page ul {
    list-style: disc;
  }
  
  
`;